
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c3dSY", function(module, exports) {

$parcel$export(module.exports, "WhiteboardUnifiedQuery", () => $8a46d0d2a20f0daa$export$257b287ae3940670);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $8a46d0d2a20f0daa$export$257b287ae3940670 = (0, $d2LG0.default)`query WhiteboardUnifiedQuery($contentId:ID!$spaceKey:String$contentVersion:Int!$enableBulkImportProperties:Boolean!){content(id:$contentId){nodes{id referenceId title operations{operation targetType}hasRestrictions hasViewRestrictions hasInheritedRestrictions space{id name key type alias}type status ancestors{id type title status}metadata{currentuser{favourited{isFavourite}}}properties(keys:["import-source" "imported-page-modified-date"])@include(if:$enableBulkImportProperties){nodes{key value}}history{createdBy{...on KnownUser{accountId}...on UnknownUser{accountId}}}}}spaces(spaceKey:$spaceKey first:10){nodes{id name homepage{id}}}user:confluence_atlassianUser(current:true){id confluence{space{id}}}paywallStatus(id:$contentId)canvasToken(contentId:$contentId){token}contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value}readWriteToken{value}}configuration{fileStoreUrl}}entitlements{whiteboardFeatures{smartConnectors{isEntitled}smartSections{isEntitled}}}dataSecurityPolicy{isActionEnabledForContent(action:PAGE_EXPORT contentId:$contentId contentStatus:CURRENT spaceKey:$spaceKey contentVersion:$contentVersion){allowed}}}`;

});

parcelRegister("aVmIf", function(module, exports) {

$parcel$export(module.exports, "SpaceQuery", () => $557bf56f96dc85c8$export$530c9ba642f8af16);

var $d2LG0 = parcelRequire("d2LG0");
const $557bf56f96dc85c8$export$530c9ba642f8af16 = (0, $d2LG0.default)`query SpaceQueryWhiteboards($spaceKey:String){space(key:$spaceKey){id name icon{path}homepage{id}}}`;

});

parcelRegister("iQHWF", function(module, exports) {

$parcel$export(module.exports, "WhiteboardShell", () => $37b15d9afdcd8fd6$export$4352d232b2258df2);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $aTqya = parcelRequire("aTqya");

var $kDuN4 = parcelRequire("kDuN4");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $aORIy = parcelRequire("aORIy");

var $eStoj = parcelRequire("eStoj");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $7d2Nc = parcelRequire("7d2Nc");

var $fyPYm = parcelRequire("fyPYm");

var $3mVfX = parcelRequire("3mVfX");

var $8i27m = parcelRequire("8i27m");

var $8dwdz = parcelRequire("8dwdz");

var $1NBp8 = parcelRequire("1NBp8");

var $h3KT5 = parcelRequire("h3KT5");

var $hQnHK = parcelRequire("hQnHK");
var $kDja4 = parcelRequire("kDja4");
var $75BBP = parcelRequire("75BBP");

var $3PXtn = parcelRequire("3PXtn");

var $dtX5n = parcelRequire("dtX5n");

var $jU7XN = parcelRequire("jU7XN");

var $4PO77 = parcelRequire("4PO77");

var $faVFI = parcelRequire("faVFI");

var $4RbZ3 = parcelRequire("4RbZ3");

var $bvJwp = parcelRequire("bvJwp");

var $7aRa9 = parcelRequire("7aRa9");

var $bbp3G = parcelRequire("bbp3G");

var $ai7NK = parcelRequire("ai7NK");

var $8WXru = parcelRequire("8WXru");

var $dPJCf = parcelRequire("dPJCf");

var $8fj5s = parcelRequire("8fj5s");

var $9wGTI = parcelRequire("9wGTI");

var $55rla = parcelRequire("55rla");

var $hgdkS = parcelRequire("hgdkS");

var $l6qp5 = parcelRequire("l6qp5");

var $aWwYt = parcelRequire("aWwYt");

var $5JnXv = parcelRequire("5JnXv");

var $fQa5o = parcelRequire("fQa5o");

var $3r60T = parcelRequire("3r60T");

var $exahZ = parcelRequire("exahZ");

var $fq9IJ = parcelRequire("fq9IJ");

var $1K5hY = parcelRequire("1K5hY");

var $2D9Zb = parcelRequire("2D9Zb");

var $81swl = parcelRequire("81swl");

var $4wero = parcelRequire("4wero");

var $etZHd = parcelRequire("etZHd");

var $b1RVt = parcelRequire("b1RVt");

var $aWJgU = parcelRequire("aWJgU");

var $pgUwo = parcelRequire("pgUwo");

var $eR152 = parcelRequire("eR152");

var $8O6cX = parcelRequire("8O6cX");

var $2rcwI = parcelRequire("2rcwI");

var $jzHIJ = parcelRequire("jzHIJ");

var $iaHf1 = parcelRequire("iaHf1");

var $3CK9i = parcelRequire("3CK9i");

var $41HuM = parcelRequire("41HuM");

var $gsFkM = parcelRequire("gsFkM");

var $5ojcA = parcelRequire("5ojcA");

var $5x0FP = parcelRequire("5x0FP");

var $vMrtF = parcelRequire("vMrtF");

var $7vhVT = parcelRequire("7vhVT");

var $jUWrE = parcelRequire("jUWrE");
const $37b15d9afdcd8fd6$var$PAYWALL_READ_ONLY_BANNER_ANALYTICS_SOURCE = `${(0, $hQnHK.WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX)}readOnlyBanner`;
const $37b15d9afdcd8fd6$var$contentHeaderWrapperStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: 'color.border',
    backgroundColor: 'elevation.surface'
});
const $37b15d9afdcd8fd6$var$whiteboardShellContainerBase = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $37b15d9afdcd8fd6$var$headerAndWhiteboardContainer = (0, $ecnYn.xcss)({
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
});
const $37b15d9afdcd8fd6$var$archivedBannerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    justifyContent: 'center',
    width: '100%'
});
const $37b15d9afdcd8fd6$var$archivedBannerStyles = (0, $ecnYn.xcss)({
    transition: 'transform 300ms cubic-bezier(0.2, 0, 0, 1) 0s'
});
const $37b15d9afdcd8fd6$export$76e4f1187ca129c4 = ({ space: spaceFromProps, spaceKey: spaceKey, contentId: contentId, contentCreatorId: contentCreatorId, title: title, contentStatus: contentStatus = null, contentReferenceId: contentReferenceId, externalShareContent: externalShareContent, loading: loading, queryNetworkStatus: queryNetworkStatus, refetch: refetch, allowedFeatures: allowedFeatures, displayPaywallViewOnlyBanner: displayPaywallViewOnlyBanner, shareToken: shareToken, flags: flags, dialogs: dialogs, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, paywallStatus: paywallStatus, paywallButtonClicked: paywallButtonClicked, onPermissionChange: onPermissionChange })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { isNotLoaded: isNotLoaded, onThemeLoaded: onThemeLoaded } = (0, $75BBP.useThemeLoaded)(isSSR);
    const whiteboardsVersionHistoryService = (0, $vMrtF.useWhiteboardsVersionHistory)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    (0, $exahZ.useRegisterCommentsPanelCallbacks)();
    const navigationService = (0, $3CK9i.useNavigationService)(spaceKey);
    // Used to clear existing comments data when we leave the space overview page
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { clearCommentsData: clearCommentsData } = (0, $8i27m.useCommentsDataActions)();
    // refs and resize observers needed only to properly position side panel since content types header is absolutely positioned
    const { bannerHeight: whiteboardReadOnlyBannerHeight, setBannerElement: setWhiteboardReadOnlyBannerElement } = (0, $bvJwp.useResizeBanner)(isSSR);
    const { bannerHeight: whiteboardHeaderHeight, setBannerElement: setWhiteboardHeaderElement, setBannerHeight: setWhiteboardHeaderHeight } = (0, $bvJwp.useResizeBanner)(isSSR);
    const handleHeightChange = (height)=>{
        setWhiteboardHeaderHeight(height);
    };
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardHeaderPinned = isWhiteboardFeatureEnabled('whiteboardSolidHeader');
    const isLoadingNewContent = loading && queryNetworkStatus !== (0, $aTqya.NetworkStatus).refetch;
    const params = (0, $1K5hY.useWhiteboardParams)();
    const version = (0, $2D9Zb.getWhiteboardVersion)(params);
    const serverSpot = (0, $eR152.getWhiteboardSpot)(params, 'canvas-server');
    const relaySpot = (0, $eR152.getWhiteboardSpot)(params, 'canvas-relay');
    const shouldShowMobileWebWhiteboard = (0, $8dwdz.shouldShowMobileWeb)() && !params.isMobileAppEmbed;
    const contentActions = (0, $aWJgU.useWhiteboardHeaderActions)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { includeTopNav: includeTopNav } = (0, $gwFzn.useContext)((0, $3PXtn.BannerContext));
    const [editionUpgradeService] = (0, $gwFzn.useState)(()=>new (0, $8O6cX.WhiteboardEditionUpgradeService)());
    const [feedbackService] = (0, $gwFzn.useState)(()=>new (0, $jU7XN.ContentFeedbackService)());
    const [eventService] = (0, $gwFzn.useState)(()=>new (0, $4RbZ3.ContentTypeEventService)());
    const [whiteboardInternalModalService] = (0, $gwFzn.useState)(()=>new (0, $41HuM.WhiteboardInternalModalService)());
    const [flagService] = (0, $gwFzn.useState)(()=>new (0, $faVFI.ContentTypesFlagService)(flags));
    const [showVersionHistorySpotlight, setShowVersionHistorySpotlight] = (0, $gwFzn.useState)(false);
    const whiteboardContainerRef = (0, $gwFzn.useRef)(null);
    // When paywall modal is present, we want to track how users interact with it so that
    // the EP message runs as soon as they close the modal
    // This also ensures that onboarding modal does not get prematurely exposed when paywall is present
    const shouldStartVersionHistoryOnboardingExperience = (()=>{
        if (!paywallButtonClicked && paywallStatus === (0, $7vhVT.PaywallStatus).ACTIVE) return true;
        else if (paywallButtonClicked === 'close') return true;
        else if (paywallButtonClicked === 'viewOnly') {
            if (paywallStatus && paywallStatus !== (0, $7vhVT.PaywallStatus).UNSET) return true;
        } else if (paywallButtonClicked === 'active') {
            if (paywallStatus && paywallStatus === (0, $7vhVT.PaywallStatus).ACTIVE) return true;
        } else if (paywallButtonClicked === 'redirect') return true;
        return false;
    })();
    const isNotPublicWhiteboard = !Boolean(externalShareContent);
    const [hasStartedVersionHistoryOnboardingCoordination, stopVersionHistoryOnboardingCoordination] = (0, $8fj5s.useSkippableCoordination)('cc-whiteboard-version-history-onboarding', !(isNotPublicWhiteboard && shouldStartVersionHistoryOnboardingExperience));
    const onCloseVersionHistoryModal = (0, $gwFzn.useCallback)(()=>{
        stopVersionHistoryOnboardingCoordination();
    }, [
        stopVersionHistoryOnboardingCoordination
    ]);
    const showVersionHistoryOnboardingModal = shouldStartVersionHistoryOnboardingExperience && hasStartedVersionHistoryOnboardingCoordination && !Boolean(externalShareContent);
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const onConfirm = (0, $gwFzn.useCallback)(()=>{
        setShowVersionHistorySpotlight(true);
    }, [
        setShowVersionHistorySpotlight
    ]);
    const space = (0, $b1RVt.useSpace)(spaceKey, spaceFromProps);
    const integrationService = (0, $5x0FP.useIntegrationService)(flags, contentId, contentStatus);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const updateWhiteboardHeaderEvents = (event)=>{
        const newData = {
            objectType: 'whiteboard'
        };
        const newAttributes = {
            contentType: 'whiteboard'
        };
        event.update((payload)=>{
            const mergedAttributes = {
                ...payload.data?.attributes,
                ...newAttributes
            };
            return {
                ...payload,
                data: {
                    ...payload.data,
                    ...newData,
                    attributes: mergedAttributes
                }
            };
        });
    };
    const isNewWhiteboard = Boolean((0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.NEW_WHITEBOARD_QUERY_PARAM)));
    (0, $l6qp5.useShareNewWhiteboardFlag)({
        isNewWhiteboard: isNewWhiteboard,
        isMobile: shouldShowMobileWebWhiteboard || params.isMobileAppEmbed,
        contentId: contentId,
        spaceKey: spaceKey,
        flags: flags,
        dialogs: dialogs
    });
    const aiAgentService = (0, $jUWrE.useWhiteboardAIAgentService)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentTitle: title
    });
    (0, $gwFzn.useEffect)(()=>{
        aiAgentService.setWhiteboardContainerRef(whiteboardContainerRef);
    }, [
        aiAgentService,
        whiteboardContainerRef
    ]);
    const [objectSidebarService] = (0, $gwFzn.useState)(()=>new (0, $3r60T.ContentTypesObjectSidebarService)());
    const onboardingService = (0, $jzHIJ.useOnboardingService)({
        isNewWhiteboard: isNewWhiteboard
    });
    // When version history panel is open, we pass in 'latest' value to versionId query param
    // to let canvas know that the current version should be in view only mode
    const whiteboardVersionId = isSidePanelOpen && !whiteboardsVersionHistoryService.versionId ? 'latest' : whiteboardsVersionHistoryService.versionId;
    const onPermissionChangeHandler = (0, $gwFzn.useCallback)((permissions)=>{
        aiAgentService.updatePermissions(permissions);
        if (onPermissionChange) onPermissionChange(permissions);
    }, [
        onPermissionChange,
        aiAgentService
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments')) {
                resetInitialDataLoadedMap();
                clearCommentsData();
            }
        };
    }, [
        clearCommentsData,
        resetInitialDataLoadedMap,
        contentId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // hide sidebar when navigating between different whiteboards
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // hide the object sidebar panels when we open version history.
        // when we have the version history panel open, the sidebar control is not visible,
        // so we will never run into the case where we have version history open and then the user
        // opens the comments/details panel
        if (isObjectSidebarShown && isSidePanelOpen) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        hideObjectSidebar();
    }, [
        isObjectSidebarShown,
        isSidePanelOpen,
        hideObjectSidebar
    ]);
    const { initialUrl: initialUrl } = (0, $4wero.useWhiteboardBridgeAPI)({
        version: version,
        serverSpot: serverSpot,
        relaySpot: relaySpot,
        space: space,
        spaceKey: spaceKey,
        contentId: contentId,
        // use "undefined" value here allows us to render whiteboard skeleton loading state
        // while WhiteboardUnifiedQuery is loading
        referenceId: isLoadingNewContent ? undefined : contentReferenceId,
        contentCreatorId: isLoadingNewContent ? undefined : contentCreatorId,
        shareToken: shareToken,
        params: params,
        dataSecurityPolicyPageExport: dataSecurityPolicyPageExport,
        refetch: refetch,
        whiteboardVersionId: whiteboardVersionId,
        services: {
            aiAgentService: aiAgentService,
            editionUpgradeService: editionUpgradeService,
            feedbackService: feedbackService,
            onboardingService: onboardingService,
            whiteboardInternalModalService: whiteboardInternalModalService,
            eventService: eventService,
            flagService: flagService,
            integrationService: integrationService,
            whiteboardsVersionHistoryService: whiteboardsVersionHistoryService,
            navigationService: navigationService,
            objectSidebarService: objectSidebarService
        },
        whiteboardLocale: params[0, $hQnHK.WHITEBOARD_LOCALE],
        whiteboardLinkedObject: params[0, $hQnHK.WHITEBOARD_LINKED_OBJECT],
        focusedCommentId: params[0, $hQnHK.FOCUSED_COMMENT_ID],
        replyToComment: params[0, $hQnHK.REPLY_TO_COMMENT],
        createdFromSlug: params[0, $hQnHK.CREATED_FROM_SLUG],
        onThemeLoaded: onThemeLoaded,
        onPermissionChange: onPermissionChangeHandler
    });
    (0, $gwFzn.useEffect)(()=>{
        const flowQueryParam = routeDataRef.current?.queryParams?.flow;
        if (flowQueryParam === 'restoreVersion') experienceTracker.succeed({
            name: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_RESTORE_EXPERIENCE)
        });
    }, [
        routeDataRef,
        experienceTracker,
        contentId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        eventService.registerEventHandler('hideSidePanel', ()=>{
            hideSidePanel();
        });
        return ()=>{
            eventService.unregisterEventHandler('hideSidePanel');
        };
    }, [
        eventService,
        hideSidePanel
    ]);
    (0, $gwFzn.useEffect)(()=>{
        objectSidebarService.onChangeObjectSidebarShown({
            isOpen: isObjectSidebarShown,
            panelId: panel?.id
        });
    }, [
        isObjectSidebarShown,
        objectSidebarService,
        panel?.id
    ]);
    (0, $gwFzn.useEffect)(()=>{
        whiteboardsVersionHistoryService.setWhiteboardVersion(null);
        hideSidePanel();
    // If we include the version history service here
    // we end up closing the side panel when selecting a new version
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        hideSidePanel
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            hideSidePanel();
        };
    }, [
        hideSidePanel
    ]);
    const handleCloseTitleSpotlight = (0, $gwFzn.useCallback)(()=>{
        onboardingService.startOnboarding('spotlight-sticky-creator');
    }, [
        onboardingService
    ]);
    const handleRegisterOnShowHeaderSpotlight = (0, $gwFzn.useCallback)((cb)=>{
        onboardingService.onShowHeaderSpotlight(cb);
    }, [
        onboardingService
    ]);
    const handleRegisterOnShowTitleSpotlight = (0, $gwFzn.useCallback)((cb)=>{
        onboardingService.onShowTitleSpotlight(cb);
    }, [
        onboardingService
    ]);
    const handleRegisterOnShowCollaboratorSpotlight = (0, $gwFzn.useCallback)((cb)=>{
        onboardingService.onShowCollaboratorSpotlight(cb);
    }, [
        onboardingService
    ]);
    const renderArchiveBanner = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $37b15d9afdcd8fd6$var$archivedBannerContainerStyles,
            style: {
                marginTop: isWhiteboardHeaderPinned ? '100px' : '60px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $37b15d9afdcd8fd6$var$archivedBannerStyles,
            style: {
                transform: isSidePanelOpen ? `translateX(-160px)` : `translateX(0)`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8WXru.ArchivedPageBanner), {
            contentId: contentId,
            marginStyle: "none"
        })));
    };
    if (!loading && !contentReferenceId) {
        experienceTracker.fail({
            name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
            error: new Error('WhiteboardUnifiedQuery did not return valid referenceId')
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h3KT5.NotFoundContained), {
            route: (0, $1NBp8.WHITEBOARD_BOARD),
            spaceKey: spaceKey
        });
    }
    // Always show the Object Header if enabled by the feature gate - but keep the current behavior
    // for the old content header which isn't shown in SSR
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isHeaderShown = true;
    const showContentTypesHeader = isHeaderShown && !isLoadingNewContent && !params.isSmartLinkEmbed;
    const showContentTypesHeaderPlaceholder = isLoadingNewContent && !params.isSmartLinkEmbed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $etZHd.StartWhiteboardPageLoad), {
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: (0, $fq9IJ.whiteboardHeightContainer)
    }, (bannerState)=>{
        // need to use bannerState to account for topnav in public links
        const bannerHeight = params.isMobileAppEmbed ? 0 : bannerState.getTotalHeight(includeTopNav);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            ref: whiteboardContainerRef,
            xcss: $37b15d9afdcd8fd6$var$whiteboardShellContainerBase,
            style: {
                height: bannerHeight > 0 ? `calc(100vh - ${bannerHeight}px)` : '100vh'
            },
            testId: "whiteboard-shell-container"
        }, displayPaywallViewOnlyBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dtX5n.WhiteboardPaywallReadOnlyBanner), {
            ref: setWhiteboardReadOnlyBannerElement,
            analyticsSource: $37b15d9afdcd8fd6$var$PAYWALL_READ_ONLY_BANNER_ANALYTICS_SOURCE
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
            direction: "column",
            xcss: $37b15d9afdcd8fd6$var$headerAndWhiteboardContainer
        }, showContentTypesHeaderPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eStoj.ContentTypesHeaderPlaceholder), {
            isFloating: !isWhiteboardHeaderPinned
        }), showContentTypesHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
            onEvent: updateWhiteboardHeaderEvents
        }, isWhiteboardHeaderPinned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            testId: "pinned-content-header",
            xcss: $37b15d9afdcd8fd6$var$contentHeaderWrapperStyles,
            ref: setWhiteboardHeaderElement
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aORIy.ContentTypesHeader), {
            contentId: contentId,
            contentActions: contentActions,
            externalShareContent: externalShareContent,
            allowedFeatures: allowedFeatures,
            isFloating: !isWhiteboardHeaderPinned,
            onCloseTitleSpotlight: handleCloseTitleSpotlight,
            registerShowTitleSpotlightHandler: handleRegisterOnShowTitleSpotlight,
            handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
            handleRegisterOnShowCollaboratorSpotlight: handleRegisterOnShowCollaboratorSpotlight,
            isHeaderPinned: isWhiteboardHeaderPinned,
            showVersionHistorySpotlight: showVersionHistorySpotlight,
            setShowVersionHistorySpotlight: setShowVersionHistorySpotlight,
            whiteboardAIAgentService: aiAgentService
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aORIy.ContentTypesHeader), {
            contentId: contentId,
            contentActions: contentActions,
            externalShareContent: externalShareContent,
            allowedFeatures: allowedFeatures,
            isFloating: !isWhiteboardHeaderPinned,
            onCloseTitleSpotlight: handleCloseTitleSpotlight,
            registerShowTitleSpotlightHandler: handleRegisterOnShowTitleSpotlight,
            handleRegisterOnShowHeaderSpotlight: handleRegisterOnShowHeaderSpotlight,
            handleRegisterOnShowCollaboratorSpotlight: handleRegisterOnShowCollaboratorSpotlight,
            onHeightChange: handleHeightChange,
            showVersionHistorySpotlight: showVersionHistorySpotlight,
            setShowVersionHistorySpotlight: setShowVersionHistorySpotlight,
            whiteboardAIAgentService: aiAgentService
        })), renderArchiveBanner(), shouldShowMobileWebWhiteboard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $pgUwo.MobileWebView), {
            bannerState: bannerState
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
            metric: (0, $etZHd.WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("iframe", {
            title: (0, $hQnHK.WHITEBOARD_IFRAME_TITLE),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: (0, $fq9IJ.whiteboardShellStyle)(isNotLoaded, isSidePanelOpen),
            src: initialUrl,
            frameBorder: 0
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fQa5o.OnboardingNthUserContentTypeSpotlight), {
            contentType: (0, $fQa5o.ContentType).WHITEBOARD,
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fyPYm.ContentViewedEvent), {
            contentId: contentId
        })), isObjectSidebarShown && [
            'detailsPanel',
            'commentsPanel'
        ].includes(panel?.id ?? '') && (0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5JnXv.ObjectSidebarPanel), {
            useFloatingSidebarHeight: true,
            useFloatingSidebar: true
        }), isSidePanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hgdkS.VersionHistory), {
            headerHeight: bannerHeight + whiteboardReadOnlyBannerHeight + whiteboardHeaderHeight,
            contentId: contentId,
            title: title,
            displayTopBorder: !isWhiteboardHeaderPinned,
            panelTop: whiteboardHeaderHeight,
            eventService: eventService,
            setVersion: whiteboardsVersionHistoryService.setWhiteboardVersion,
            contentType: "whiteboard"
        })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2rcwI.WhiteboardEditionUpgradeCTA), {
        editionUpgradeService: editionUpgradeService
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4PO77.GlobalFeedbackCollectorModal), {
        feedbackService: feedbackService
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gsFkM.WhiteboardInternalModal), {
        whiteboardInternalModalService: whiteboardInternalModalService
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $81swl.WhiteboardExitVersion), {
        version: version,
        serverSpot: serverSpot,
        relaySpot: relaySpot
    }), showVersionHistoryOnboardingModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $55rla.VersionHistoryModalManager), {
        onClose: onCloseVersionHistoryModal,
        onConfirm: onConfirm
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5ojcA.WhiteboardNavigationLockout), {
        navigationService: navigationService,
        contentId: contentId
    }));
};
const $37b15d9afdcd8fd6$export$4352d232b2258df2 = (0, $bbp3G.withDialogs)((0, $7aRa9.withFlags)($37b15d9afdcd8fd6$export$76e4f1187ca129c4));

});
parcelRegister("75BBP", function(module, exports) {

$parcel$export(module.exports, "useThemeLoaded", () => $68b01ec21051545a$export$53b0325c8db78a21);

var $gwFzn = parcelRequire("gwFzn");
const $68b01ec21051545a$export$53b0325c8db78a21 = (isSSR)=>{
    const [isNotLoaded, setIsNotLoaded] = (0, $gwFzn.useState)(true);
    const setThemeLoaded = (0, $gwFzn.useCallback)(()=>setIsNotLoaded(isSSR), [
        isSSR
    ]);
    const themeTimeout = setTimeout(setThemeLoaded, 2500);
    const onThemeLoaded = (0, $gwFzn.useCallback)(()=>{
        clearTimeout(themeTimeout);
        setThemeLoaded();
    }, [
        themeTimeout,
        setThemeLoaded
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>clearTimeout(themeTimeout);
    }, [
        themeTimeout
    ]);
    return {
        isNotLoaded: isNotLoaded,
        onThemeLoaded: onThemeLoaded
    };
};

});

parcelRegister("dtX5n", function(module, exports) {

$parcel$export(module.exports, "WhiteboardPaywallReadOnlyBanner", () => $63c74d54eeb243cb$export$12f9dd0b97111aa6);
/* WhiteboardPaywallReadOnlyBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $1ytiN = parcelRequire("1ytiN");

var $hQnHK = parcelRequire("hQnHK");

var $euL71 = parcelRequire("euL71");

var $Zkhpa = parcelRequire("Zkhpa");
const $63c74d54eeb243cb$var$i18n = (0, $2nPZH.defineMessages)({
    whiteboardPaywallReadOnlyBannerViewOnlyTextAdmin: {
        id: "change-edition.whiteboard-upsell.paywall-read-only-banner.text-admin",
        defaultMessage: "<b>This whiteboard is view-only.</b> Your current plan only allows three active whiteboards. Upgrade to Premium for unlimited whiteboards."
    },
    whiteboardPaywallReadOnlyBannerViewOnlyTextNonAdmin: {
        id: "change-edition.whiteboard-upsell.paywall-read-only-banner.text-non-admin",
        defaultMessage: "<b>This whiteboard is view-only.</b> Your current plan only allows three active whiteboards. Ask your admin to upgrade to Premium for unlimited whiteboards."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63c74d54eeb243cb$var$WhiteboardPaywallReadOnlyBannerWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1tkeckbl",
            __cmplp.className
        ])
    });
});
const $63c74d54eeb243cb$export$12f9dd0b97111aa6 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ analyticsSource: analyticsSource }, ref)=>{
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const bannerMessage = isSiteAdmin ? $63c74d54eeb243cb$var$i18n.whiteboardPaywallReadOnlyBannerViewOnlyTextAdmin : $63c74d54eeb243cb$var$i18n.whiteboardPaywallReadOnlyBannerViewOnlyTextNonAdmin;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($63c74d54eeb243cb$var$WhiteboardPaywallReadOnlyBannerWrapper, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $Zkhpa.MiniSectionMessage), {
        messageContent: {
            ...bannerMessage,
            values: {
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
            }
        },
        source: analyticsSource,
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        upgradeEditionActionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID)
    }));
});

});
parcelRegister("Zkhpa", function(module, exports) {

$parcel$export(module.exports, "MiniSectionMessage", () => $32a7b52fc4024767$export$4970578d41b1ae7b);
/* MiniSectionMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $bQm3c = parcelRequire("bQm3c");

var $1ytiN = parcelRequire("1ytiN");

var $4WmbV = parcelRequire("4WmbV");

var $ki6F7 = parcelRequire("ki6F7");

var $ktelT = parcelRequire("ktelT");

var $euL71 = parcelRequire("euL71");

var $gLeLL = parcelRequire("gLeLL");
const $32a7b52fc4024767$var$BodyWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulputpp _1e0c1txw _16jlkb7n _1bah1yb4",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $32a7b52fc4024767$var$MessageWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "",
            __cmplp?.topBanner ? "_zulputpp _1e0c11p5 _yv0e1ghl _4cvrv2br" : "_1e0c1o8l _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $32a7b52fc4024767$var$LearnMoreLink = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_k48p1wq8 _syaz1250 _80omtlke",
            __cmplp.className
        ])
    });
});
const $32a7b52fc4024767$var$messageWrapperBannerStyles = (0, $ecnYn.xcss)({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $32a7b52fc4024767$var$messageWrapperMessageStyles = (0, $ecnYn.xcss)({
    display: 'inline'
});
const $32a7b52fc4024767$export$4970578d41b1ae7b = ({ messageContent: messageContent, dismissButton: dismissButton, learnMoreLink: learnMoreLink, topBanner: topBanner = false, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).PREMIUM, ...rest })=>{
    const { source: source, upgradeEditionActionSubjectId: upgradeEditionActionSubjectId, onUpgradeButtonClick: onUpgradeButtonClick } = rest;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const LearnMoreLinkComponent = learnMoreLink?.appearance === 'subtle-link' ? (0, $ktelT.GradientSubtleLinkButton) : $32a7b52fc4024767$var$LearnMoreLink;
    const onLearnMoreClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                source: source,
                attributes: {
                    currentEdition: edition,
                    targetEdition: targetEdition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: learnMoreLink?.messageDescriptor?.defaultMessage
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        edition,
        targetEdition,
        isSiteAdmin,
        learnMoreLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gLeLL.SectionMessage), {
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($32a7b52fc4024767$var$BodyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($32a7b52fc4024767$var$MessageWrapper, {
            topBanner: topBanner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: topBanner ? $32a7b52fc4024767$var$messageWrapperBannerStyles : $32a7b52fc4024767$var$messageWrapperMessageStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), messageContent), ' '), isSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ki6F7.UpgradeEditionButton), {
            analyticsProps: {
                actionSubjectId: upgradeEditionActionSubjectId || '',
                source: source,
                attributes: {
                    isSiteAdmin: true
                }
            },
            appearance: "subtle-link",
            targetEdition: targetEdition,
            onUpgradeButtonClick: onUpgradeButtonClick
        }) : learnMoreLink?.messageDescriptor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(LearnMoreLinkComponent, {
            href: learnMoreLink?.href,
            onClick: ()=>{
                onLearnMoreClick();
                learnMoreLink?.onClick?.();
            },
            target: learnMoreLink?.target
        }, formatMessage(learnMoreLink.messageDescriptor))), dismissButton),
        buttonConfig: (0, $4WmbV.SectionMessageButtonConfig).NONE,
        ...rest
    });
};

});


parcelRegister("jU7XN", function(module, exports) {

$parcel$export(module.exports, "ContentFeedbackService", () => $d2e2ca258eafc654$export$c6921f0b2e403bcf);
function $d2e2ca258eafc654$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $d2e2ca258eafc654$var$id = 0;
function $d2e2ca258eafc654$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $d2e2ca258eafc654$var$id++ + "_" + e;
}
var $d2e2ca258eafc654$var$_feedbackHandler = /*#__PURE__*/ $d2e2ca258eafc654$var$_classPrivateFieldLooseKey("feedbackHandler");
var $d2e2ca258eafc654$var$_closeHandler = /*#__PURE__*/ $d2e2ca258eafc654$var$_classPrivateFieldLooseKey("closeHandler");
class $d2e2ca258eafc654$export$c6921f0b2e403bcf {
    registerFeedbackHandler(feedbackHandler) {
        $d2e2ca258eafc654$var$_classPrivateFieldLooseBase(this, $d2e2ca258eafc654$var$_feedbackHandler)[$d2e2ca258eafc654$var$_feedbackHandler] = feedbackHandler;
    }
    registerCloseHandler(closeHandler) {
        $d2e2ca258eafc654$var$_classPrivateFieldLooseBase(this, $d2e2ca258eafc654$var$_closeHandler)[$d2e2ca258eafc654$var$_closeHandler] = closeHandler;
    }
    // Show Global Feedback Collector with provided options
    // Feedback handler returns deferred Promise that resolves when modal is closed
    showFeedbackCollector(options) {
        return $d2e2ca258eafc654$var$_classPrivateFieldLooseBase(this, $d2e2ca258eafc654$var$_feedbackHandler)[$d2e2ca258eafc654$var$_feedbackHandler](options);
    }
    // Method exposed to bridge API for allowing whiteboards to close feedback modal
    closeFeedbackModal() {
        $d2e2ca258eafc654$var$_classPrivateFieldLooseBase(this, $d2e2ca258eafc654$var$_closeHandler)[$d2e2ca258eafc654$var$_closeHandler]();
    }
    constructor(){
        Object.defineProperty(this, $d2e2ca258eafc654$var$_feedbackHandler, {
            writable: true,
            value: async ()=>{}
        });
        Object.defineProperty(this, $d2e2ca258eafc654$var$_closeHandler, {
            writable: true,
            value: ()=>{}
        });
    }
}
const $d2e2ca258eafc654$export$8c1ea8997e385b84 = new $d2e2ca258eafc654$export$c6921f0b2e403bcf();

});

parcelRegister("4PO77", function(module, exports) {

$parcel$export(module.exports, "GlobalFeedbackCollectorModal", () => $102c61618c081fd8$export$60397dd39dc89bde);

var $gwFzn = parcelRequire("gwFzn");

var $6ZZJK = parcelRequire("6ZZJK");

var $lJcX0 = parcelRequire("lJcX0");
const $102c61618c081fd8$export$60397dd39dc89bde = ({ feedbackService: feedbackService })=>{
    const modalState = (0, $lJcX0.useGlobalFeedbackCollector)(feedbackService);
    if (!modalState.isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6ZZJK.GlobalFeedbackCollector), {
        ...modalState.modalProps,
        onClose: ()=>modalState.closeModal()
    });
};

});
parcelRegister("lJcX0", function(module, exports) {

$parcel$export(module.exports, "useGlobalFeedbackCollector", () => $125382a73b79e08f$export$c2f84a7df139d8af);

var $gwFzn = parcelRequire("gwFzn");

var $lmEGt = parcelRequire("lmEGt");
const $125382a73b79e08f$export$c2f84a7df139d8af = (feedbackService)=>{
    const [modalState, setModalState] = (0, $gwFzn.useState)({
        isModalOpen: false
    });
    const closeModal = (0, $gwFzn.useCallback)(()=>{
        if (modalState.isModalOpen) modalState.modalCloseDeferrable.resolve();
        setModalState({
            isModalOpen: false
        });
    }, [
        modalState
    ]);
    const feedbackHandler = (0, $gwFzn.useCallback)((modalProps)=>{
        const deferrable = new (0, $lmEGt.Deferrable)();
        setModalState({
            isModalOpen: true,
            modalProps: modalProps,
            modalCloseDeferrable: deferrable
        });
        return deferrable.get();
    }, []);
    feedbackService.registerFeedbackHandler(feedbackHandler);
    feedbackService.registerCloseHandler(closeModal);
    return modalState.isModalOpen ? {
        isModalOpen: modalState.isModalOpen,
        modalProps: modalState.modalProps,
        closeModal: closeModal
    } : modalState;
};

});
parcelRegister("lmEGt", function(module, exports) {

$parcel$export(module.exports, "Deferrable", () => $ec6eb9233b99a537$export$bb373f2025a3840b);
function $ec6eb9233b99a537$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $ec6eb9233b99a537$var$id = 0;
function $ec6eb9233b99a537$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $ec6eb9233b99a537$var$id++ + "_" + e;
}
var $ec6eb9233b99a537$var$_promise = /*#__PURE__*/ $ec6eb9233b99a537$var$_classPrivateFieldLooseKey("promise");
var $ec6eb9233b99a537$var$_resolve = /*#__PURE__*/ $ec6eb9233b99a537$var$_classPrivateFieldLooseKey("resolve");
var $ec6eb9233b99a537$var$_reject = /*#__PURE__*/ $ec6eb9233b99a537$var$_classPrivateFieldLooseKey("reject");
class $ec6eb9233b99a537$export$bb373f2025a3840b {
    resolve(value) {
        $ec6eb9233b99a537$var$_classPrivateFieldLooseBase(this, $ec6eb9233b99a537$var$_resolve)[$ec6eb9233b99a537$var$_resolve](value);
    }
    reject(reason) {
        $ec6eb9233b99a537$var$_classPrivateFieldLooseBase(this, $ec6eb9233b99a537$var$_reject)[$ec6eb9233b99a537$var$_reject](reason);
    }
    get() {
        return $ec6eb9233b99a537$var$_classPrivateFieldLooseBase(this, $ec6eb9233b99a537$var$_promise)[$ec6eb9233b99a537$var$_promise];
    }
    constructor(){
        Object.defineProperty(this, $ec6eb9233b99a537$var$_promise, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $ec6eb9233b99a537$var$_resolve, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $ec6eb9233b99a537$var$_reject, {
            writable: true,
            value: void 0
        });
        $ec6eb9233b99a537$var$_classPrivateFieldLooseBase(this, $ec6eb9233b99a537$var$_promise)[$ec6eb9233b99a537$var$_promise] = new Promise((resolve, reject)=>{
            $ec6eb9233b99a537$var$_classPrivateFieldLooseBase(this, $ec6eb9233b99a537$var$_resolve)[$ec6eb9233b99a537$var$_resolve] = resolve;
            $ec6eb9233b99a537$var$_classPrivateFieldLooseBase(this, $ec6eb9233b99a537$var$_reject)[$ec6eb9233b99a537$var$_reject] = reject;
        });
        this.resolve = this.resolve.bind(this);
        this.reject = this.reject.bind(this);
    }
}

});



parcelRegister("faVFI", function(module, exports) {

$parcel$export(module.exports, "ContentTypesFlagService", () => $e69c7ecf0858446f$export$a3823aa64e973105);

var $5SppV = parcelRequire("5SppV");
function $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $e69c7ecf0858446f$var$id = 0;
function $e69c7ecf0858446f$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $e69c7ecf0858446f$var$id++ + "_" + e;
}
var $e69c7ecf0858446f$var$_flags = /*#__PURE__*/ $e69c7ecf0858446f$var$_classPrivateFieldLooseKey("flags");
class $e69c7ecf0858446f$export$a3823aa64e973105 {
    showFlag(flagProps) {
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags].showFlag({
            ...flagProps,
            customIcon: flagProps.type === 'custom' ? (0, $5SppV.getContentTypesFlagIcon)(flagProps.iconString, flagProps.iconColor) : undefined
        });
    }
    hideFlag(flagId) {
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags].hideFlag(flagId);
    }
    constructor(flags){
        Object.defineProperty(this, $e69c7ecf0858446f$var$_flags, {
            writable: true,
            value: void 0
        });
        $e69c7ecf0858446f$var$_classPrivateFieldLooseBase(this, $e69c7ecf0858446f$var$_flags)[$e69c7ecf0858446f$var$_flags] = flags;
    }
}

});
parcelRegister("5SppV", function(module, exports) {

$parcel$export(module.exports, "getContentTypesFlagIcon", () => $0c4d6050022a8715$export$15b497b4bcae19f4);

var $gwFzn = parcelRequire("gwFzn");

var $7yOcR = parcelRequire("7yOcR");

var $4vzBZ = parcelRequire("4vzBZ");
const $0c4d6050022a8715$export$1173a795b68d5ee4 = ({ iconString: iconString, iconColor: iconColor })=>{
    let IconComponent;
    switch(iconString){
        case 'feedback':
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($7yOcR)));
            break;
        case 'info':
        default:
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ)));
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(IconComponent, {
        color: iconColor,
        label: ""
    });
};
const $0c4d6050022a8715$export$15b497b4bcae19f4 = (iconString, iconColor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0c4d6050022a8715$export$1173a795b68d5ee4, {
        iconString: iconString,
        iconColor: iconColor ?? "var(--ds-icon, #44546F)"
    });

});


parcelRegister("4RbZ3", function(module, exports) {

$parcel$export(module.exports, "ContentTypeEventService", () => $ebcb8f414be8c1a8$export$f3bbb07f64a9b14d);
class $ebcb8f414be8c1a8$export$f3bbb07f64a9b14d {
    dispose() {
        this.eventHandlers = new Map();
    }
    /**
   * This is called in Whiteboards to register the any event callbacks.
   * Confluence FE can then use any of these events to trigger the whiteboard events.
   */ registerEventHandler(event, handler) {
        this.eventHandlers.set(event, handler);
    }
    /**
   * This is called in Whiteboards to unregister the any event callbacks.
   */ unregisterEventHandler(event) {
        this.eventHandlers.delete(event);
    }
    /**
   * Check if an event has any handlers registered to it
   * @param event
   */ hasEventHandler(event) {
        return this.eventHandlers.has(event);
    }
    /**
   * Trigger an event in Whiteboards.
   */ triggerEvent(event) {
        this.eventHandlers.get(event)?.();
    }
    constructor(){
        this.eventHandlers = void 0;
        this.eventHandlers = new Map();
    }
}

});

parcelRegister("bvJwp", function(module, exports) {

$parcel$export(module.exports, "useResizeBanner", () => $357714bfdc877a0f$export$75b569184a0dd765);

var $gwFzn = parcelRequire("gwFzn");
const $357714bfdc877a0f$export$75b569184a0dd765 = (isSSR)=>{
    const [bannerHeight, setBannerHeight] = (0, $gwFzn.useState)(0);
    const [bannerElement, setBannerElement] = (0, $gwFzn.useState)(null);
    const resizeObserver = (0, $gwFzn.useMemo)(()=>{
        if (!isSSR) return new ResizeObserver((entries)=>{
            for (const entry of entries)setBannerHeight(entry.borderBoxSize[0].blockSize);
        });
    }, [
        isSSR
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (bannerElement && resizeObserver) {
            resizeObserver.observe(bannerElement);
            return ()=>resizeObserver.unobserve(bannerElement);
        } else setBannerHeight(0);
    }, [
        bannerElement,
        resizeObserver
    ]);
    return {
        setBannerElement: setBannerElement,
        bannerHeight: bannerHeight,
        setBannerHeight: setBannerHeight
    };
};

});

parcelRegister("hgdkS", function(module, exports) {

$parcel$export(module.exports, "VersionHistory", () => $641b32b3bb33877e$export$bc676b00e8f62584);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");

var $kevJM = parcelRequire("kevJM");

var $7hXDW = parcelRequire("7hXDW");

var $lnqHu = parcelRequire("lnqHu");

var $kmWRd = parcelRequire("kmWRd");
var $cHiEk = parcelRequire("cHiEk");

var $ai7NK = parcelRequire("ai7NK");

var $dIouf = parcelRequire("dIouf");

var $aCrkK = parcelRequire("aCrkK");

var $9wGTI = parcelRequire("9wGTI");

var $eTQu9 = parcelRequire("eTQu9");

var $av0to = parcelRequire("av0to");

var $jpcXR = parcelRequire("jpcXR");

var $3G6jD = parcelRequire("3G6jD");

var $kI68q = parcelRequire("kI68q");
const $641b32b3bb33877e$var$headerTitleStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
const $641b32b3bb33877e$var$i18n = (0, $2nPZH.defineMessages)({
    versionHistoryTitle: {
        id: "version-history.title",
        defaultMessage: "History"
    },
    versionHistoryHeaderTitle: {
        id: "version-history.header-title",
        defaultMessage: "Version history"
    },
    versionHistoryIconLabel: {
        id: "version-history.icon.label",
        defaultMessage: "Frequent clock icon"
    },
    versionHistoryCloseButtonLabel: {
        id: "version-history.close.button.icon.label",
        defaultMessage: "Close button"
    },
    restoreWhiteboardLabel: {
        id: "version-history.restore.whiteboard.label",
        defaultMessage: "Restore as new whiteboard"
    },
    restoreWhiteboardButtonText: {
        id: "version-history.restore.whiteboard.button.text",
        defaultMessage: "Restore as new whiteboard"
    },
    restoreDatabaseButtonText: {
        id: "version-history.restore.database.button.text",
        defaultMessage: "Restore as new database"
    },
    restoreDatabaseLabel: {
        id: "version-history.restore.database.label",
        defaultMessage: "Restore as new database"
    }
});
const $641b32b3bb33877e$var$contentTypeMessaging = {
    whiteboard: {
        buttonText: $641b32b3bb33877e$var$i18n.restoreWhiteboardButtonText,
        label: $641b32b3bb33877e$var$i18n.restoreWhiteboardLabel
    },
    database: {
        buttonText: $641b32b3bb33877e$var$i18n.restoreDatabaseButtonText,
        label: $641b32b3bb33877e$var$i18n.restoreDatabaseLabel
    }
};
const $641b32b3bb33877e$var$VersionHistoryComponent = ({ contentId: contentId, title: title, headerHeight: headerHeight = 0, displayTopBorder: displayTopBorder, panelTop: panelTop = 0, eventService: eventService, setVersion: setVersion, contentType: contentType })=>{
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [showRestoreModal, setShowRestoreModal] = (0, $gwFzn.useState)(false);
    const { onVersionClick: onVersionClick, onVersionHistoryMenuOpen: onVersionHistoryMenuOpen, onRestoreModalClose: onRestoreModalClose } = (0, $av0to.useVersionHistoryAnalytics)();
    const { autosavedVersions: autosavedVersions, loading: loading, loadMoreVersions: loadMoreVersions, hasNextPage: hasNextPage, cursor: cursor, error: error, refetch: refetch } = (0, $eTQu9.useVersionHistory)({
        contentId: contentId,
        contentType: contentType
    });
    // current version is selected by default
    const [selectedVersion, setSelectedVersion] = (0, $gwFzn.useState)(null);
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const headerTitle = (0, $9wGTI.fg)('confluence_frontend_object_header') ? $641b32b3bb33877e$var$i18n.versionHistoryHeaderTitle : $641b32b3bb33877e$var$i18n.versionHistoryTitle;
    (0, $gwFzn.useEffect)(()=>{
        // succeed side panel experience on render
        trackExperience({
            contentType: contentType,
            experience: 'sidePanel',
            task: 'succeed'
        });
    }, [
        contentType,
        trackExperience
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!selectedVersion) setSelectedVersion(null);
    }, [
        setSelectedVersion,
        selectedVersion
    ]);
    (0, $gwFzn.useEffect)(()=>{
        onVersionHistoryMenuOpen();
    }, [
        onVersionHistoryMenuOpen
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            setVersion(null);
        };
    }, [
        setVersion
    ]);
    const handleClose = (0, $gwFzn.useCallback)(()=>{
        onRestoreModalClose();
        setShowRestoreModal(false);
    }, [
        onRestoreModalClose
    ]);
    const handleVersionClick = (0, $gwFzn.useCallback)((version)=>{
        setSelectedVersion(version);
        onVersionClick(version);
        setVersion(version || null);
    }, [
        onVersionClick,
        setVersion
    ]);
    // current version does not return externalVersionId
    const isRestoreButtonDisabled = !!error || !Boolean(selectedVersion?.contentProperties?.latest?.externalVersionId);
    const handleRestoreVersionClick = (0, $gwFzn.useCallback)(()=>{
        trackExperience({
            contentType: contentType,
            experience: 'restoreModal',
            task: 'start'
        });
        setShowRestoreModal(true);
    }, [
        contentType,
        trackExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kmWRd.SidePanel), {
        headerHeight: headerHeight,
        displayTopBorder: displayTopBorder,
        panelTop: panelTop
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kI68q.VersionHistoryLoadingPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        backgroundColor: "elevation.surface",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150",
        paddingBlock: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        xcss: $641b32b3bb33877e$var$headerTitleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
        label: formatMessage($641b32b3bb33877e$var$i18n.versionHistoryIconLabel),
        color: "var(--ds-icon, #44546F)",
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "small",
        as: "h5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), headerTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        onClick: hideSidePanel,
        label: formatMessage($641b32b3bb33877e$var$i18n.versionHistoryCloseButtonLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3G6jD.VersionHistoryContent), {
        autosavedVersions: autosavedVersions,
        hasNextPage: hasNextPage,
        loadMoreVersions: loadMoreVersions,
        cursor: cursor,
        error: error,
        refetch: refetch,
        loading: loading,
        handleVersionClick: handleVersionClick,
        selectedVersion: selectedVersion,
        eventService: eventService,
        contentType: contentType,
        title: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cHiEk.SidePanelFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        "aria-label": formatMessage($641b32b3bb33877e$var$contentTypeMessaging[contentType].label),
        shouldFitContainer: true,
        onClick: handleRestoreVersionClick,
        isDisabled: isRestoreButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $641b32b3bb33877e$var$contentTypeMessaging[contentType].buttonText))))), showRestoreModal && selectedVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jpcXR.RestoreContentModal), {
        onClose: handleClose,
        selectedVersion: selectedVersion,
        contentType: contentType
    }));
};
const $641b32b3bb33877e$export$bc676b00e8f62584 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).CONTENT_TYPES
})($641b32b3bb33877e$var$VersionHistoryComponent);

});
parcelRegister("cHiEk", function(module, exports) {

$parcel$export(module.exports, "SidePanelFooter", () => $50364c7681d2ff9d$export$87589ca4d6050188);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $50364c7681d2ff9d$var$footerBaseStyles = (0, $ecnYn.xcss)({
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    borderTopWidth: 'border.width'
});
const $50364c7681d2ff9d$export$87589ca4d6050188 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.200",
        paddingInline: "space.300",
        xcss: $50364c7681d2ff9d$var$footerBaseStyles
    }, children);
};

});

parcelRegister("aCrkK", function(module, exports) {

$parcel$export(module.exports, "useVersionHistoryExperienceTracking", () => $91a763c2849bb3c4$export$9560419a530f63b5);

var $gwFzn = parcelRequire("gwFzn");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");
const $91a763c2849bb3c4$var$experienceMap = {
    whiteboard: {
        restoreModal: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.WHITEBOARD_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    },
    database: {
        restoreModal: (0, $irVI7.DATABASE_VERSION_HISTORY_LOAD_RESTORE_MODAL),
        restoreExperience: (0, $irVI7.DATABASE_VERSION_HISTORY_RESTORE_EXPERIENCE),
        sidePanel: (0, $irVI7.DATABASE_VERSION_HISTORY_SIDE_PANEL_EXPERIENCE)
    }
};
const $91a763c2849bb3c4$export$9560419a530f63b5 = ()=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const trackExperience = ({ contentType: contentType, experience: experience, task: task })=>{
        if (!contentType || !experience || !task) return;
        if (contentType === 'whiteboard' || contentType === 'database') {
            const experienceName = $91a763c2849bb3c4$var$experienceMap[contentType]?.[experience];
            if (experienceName) {
                if (task === 'start') experienceTracker.start({
                    name: experienceName
                });
                else experienceTracker.succeed({
                    name: experienceName
                });
            }
        }
    };
    return {
        trackExperience: trackExperience
    };
};

});

parcelRegister("eTQu9", function(module, exports) {

$parcel$export(module.exports, "useVersionHistory", () => $f24fd770e6b9a487$export$c17d09885b37d368);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");
const $f24fd770e6b9a487$export$c17d09885b37d368 = ({ contentType: contentType, contentId: contentId })=>{
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, refetch: refetch } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useVersionHistoryContentVersionHistoryQuery($contentId:ID!$filter:ContentVersionHistoryFilter!$after:String){contentVersionHistory(id:$contentId after:$after first:30 filter:$filter){nodes{author{id isActive displayName}contentId number updatedTime contentProperties{latest{externalVersionId}}}pageInfo{hasNextPage hasPreviousPage startCursor endCursor}}}`, {
        variables: {
            contentId: contentId,
            filter: {
                contentType: contentType
            }
        }
    });
    const startCursor = data?.contentVersionHistory?.pageInfo?.startCursor || null;
    const hasNextPage = data?.contentVersionHistory?.pageInfo?.hasNextPage || false;
    const autosavedVersions = data?.contentVersionHistory?.nodes || [];
    const loadMoreVersions = ()=>{
        if (hasNextPage && startCursor && !loading) fetchMore({
            variables: {
                contentId: contentId,
                filter: {
                    contentType: contentType
                },
                after: startCursor
            },
            updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
                if (!fetchMoreResult?.contentVersionHistory) return prev;
                const prevNodes = prev?.contentVersionHistory?.nodes || [];
                const fetchedNodes = fetchMoreResult.contentVersionHistory.nodes || [];
                const pageInfo = fetchMoreResult.contentVersionHistory.pageInfo || prev?.contentVersionHistory?.pageInfo;
                return {
                    contentVersionHistory: {
                        nodes: [
                            ...prevNodes,
                            ...fetchedNodes
                        ],
                        pageInfo: pageInfo,
                        __typename: 'ContentVersionHistoryConnection'
                    }
                };
            }
        });
    };
    return {
        autosavedVersions: autosavedVersions,
        loading: loading,
        error: error,
        loadMoreVersions: loadMoreVersions,
        cursor: startCursor,
        hasNextPage: hasNextPage,
        refetch: refetch
    };
};

});

parcelRegister("av0to", function(module, exports) {

$parcel$export(module.exports, "useVersionHistoryAnalytics", () => $bac38a4aff776821$export$8fea35734ad69528);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $ep3mz = parcelRequire("ep3mz");
const $bac38a4aff776821$export$8fea35734ad69528 = ()=>{
    const [{ contentType: contentType, contentId: contentId }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onVersionClick = (0, $gwFzn.useCallback)((version)=>{
        if (version) {
            const { updatedTime: updatedTime, number: number } = version;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'version',
                    actionSubjectId: 'selected',
                    source: 'versionHistoryScreen',
                    objectId: contentId,
                    objectType: contentType,
                    attributes: {
                        updatedTime: updatedTime,
                        number: number
                    }
                }
            }).fire();
        } else createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'version',
                actionSubjectId: 'current',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onVersionHistoryMenuOpen = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'versionHistoryScreen',
                attributes: {
                    objectType: contentType,
                    objectId: contentId
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onCopyVersionContent = (0, $gwFzn.useCallback)((version)=>{
        const { updatedTime: updatedTime, number: number } = version;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'copyVersionContent',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType,
                attributes: {
                    updatedTime: updatedTime,
                    number: number
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onRestore = (0, $gwFzn.useCallback)((version)=>{
        const { updatedTime: updatedTime, number: number } = version;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'restore',
                objectId: contentId,
                objectType: contentType,
                source: 'versionHistoryModal',
                attributes: {
                    updatedTime: updatedTime,
                    number: number
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const onRestoreModalClose = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'closeButton',
                source: 'versionHistoryScreen',
                objectId: contentId,
                objectType: contentType
            }
        }).fire();
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    return {
        onVersionClick: onVersionClick,
        onVersionHistoryMenuOpen: onVersionHistoryMenuOpen,
        onCopyVersionContent: onCopyVersionContent,
        onRestore: onRestore,
        onRestoreModalClose: onRestoreModalClose
    };
};

});

parcelRegister("jpcXR", function(module, exports) {

$parcel$export(module.exports, "RestoreContentModal", () => $3e7e8a0093eea0b3$export$63ec0fdbb660e929);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");

var $7hXDW = parcelRequire("7hXDW");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");

var $lnqHu = parcelRequire("lnqHu");

var $aoVih = parcelRequire("aoVih");

var $a1qSg = parcelRequire("a1qSg");

var $ep3mz = parcelRequire("ep3mz");

var $dPJCf = parcelRequire("dPJCf");

var $caYQd = parcelRequire("caYQd");

var $lqy4C = parcelRequire("lqy4C");

var $ai7NK = parcelRequire("ai7NK");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $aCrkK = parcelRequire("aCrkK");

var $ck0S9 = parcelRequire("ck0S9");

var $av0to = parcelRequire("av0to");

var $ktuvZ = parcelRequire("ktuvZ");
const $3e7e8a0093eea0b3$var$i18n = (0, $2nPZH.defineMessages)({
    restoreContentTitle: {
        id: "version-history.restore.content.title",
        defaultMessage: "Restore"
    },
    closeIconButtonLabel: {
        id: "version-history.close.icon.button.label",
        defaultMessage: "Close icon"
    },
    restoreButton: {
        id: "version-history.restore.button",
        defaultMessage: "Restore"
    },
    whiteboardInfoBoxText: {
        id: "version-history.info.box.text",
        defaultMessage: "When restoring a board, permission and share settings remain the same."
    },
    saveWorkWithoutCreatingText: {
        id: "version-history.save-work-without-creating.text",
        defaultMessage: "To save work without creating, try copying content from the whiteboard to an editable whiteboard."
    },
    spaceSelectorLabel: {
        id: "version-history.space-selector.label",
        defaultMessage: "Select space"
    },
    whiteboardPlaceholderTitle: {
        id: "version-history.placeholder.whiteboard.title",
        defaultMessage: "[Restored] Untitled board {date}"
    },
    duplicateTitleErrorTitle: {
        id: "version-history.restore-modal.conflicting-title-error-title",
        defaultMessage: "Duplicate title in this space"
    },
    duplicateTitleErrorBody: {
        id: "version-history.restore-modal.conflicting-title-error-body",
        defaultMessage: "To restore your board, create a unique title or try adding it to a different space."
    },
    newDuplicateTitleErrorBody: {
        id: "version-history.restore-modal.new-conflicting-title-error-body",
        defaultMessage: "To continue restoring, create a unique title or try adding it to a different space."
    },
    spacePermissionErrorTitle: {
        id: "version-history.restore-modal.space-permission-error-title",
        defaultMessage: "You don\u2019t have space access"
    },
    spacePermissionErrorBody: {
        id: "version-history.restore-modal.space-permission-error-body",
        defaultMessage: "To restore this board, you\u2019ll need permissions to <b>Create</b> in this space."
    },
    newSpacePermissionErrorBody: {
        id: "version-history.restore-modal.new-space-permission-error-body",
        defaultMessage: "To restore this content, you\u2019ll need permissions to <b>Create</b> in this space."
    },
    genericErrorTitle: {
        id: "version-history.restore-modal.generic-error-title",
        defaultMessage: "We couldn\u2019t complete your request"
    },
    genericErrorBody: {
        id: "version-history.restore-modal.generic-error-body",
        defaultMessage: "Try refreshing the page, or check your network connection."
    },
    databasePlaceholderTitle: {
        id: "version-history.placeholder.database.title",
        defaultMessage: "[Restored] Untitled database {date}"
    },
    databaseInfoBoxText: {
        id: "version-history.database.info.box.text",
        defaultMessage: "When restoring a database, permission and share settings remain the same."
    }
});
const $3e7e8a0093eea0b3$var$restoreContentModalMessaging = {
    whiteboard: {
        description: $3e7e8a0093eea0b3$var$i18n.whiteboardInfoBoxText,
        placeholderTitle: $3e7e8a0093eea0b3$var$i18n.whiteboardPlaceholderTitle
    },
    database: {
        description: $3e7e8a0093eea0b3$var$i18n.databaseInfoBoxText,
        placeholderTitle: $3e7e8a0093eea0b3$var$i18n.databasePlaceholderTitle
    }
};
const $3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE = {
    duplicateTitle: 'exists with the same title in this space',
    spacePermissions: 'com.atlassian.confluence.api.service.exceptions.PermissionException: Could not create content'
};
const $3e7e8a0093eea0b3$var$errorSectionMessageStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
const $3e7e8a0093eea0b3$var$ErrorSectionMessage = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    let errorTitle;
    let errorBody;
    if (!error) return null;
    if (error.message.includes($3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE.duplicateTitle)) {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.duplicateTitleErrorTitle;
        errorBody = (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui') ? $3e7e8a0093eea0b3$var$i18n.newDuplicateTitleErrorBody : $3e7e8a0093eea0b3$var$i18n.duplicateTitleErrorBody;
    } else if (error.message.includes($3e7e8a0093eea0b3$var$EXPECTED_ERROR_MESSAGE.spacePermissions)) {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.spacePermissionErrorTitle;
        errorBody = (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui') ? $3e7e8a0093eea0b3$var$i18n.newSpacePermissionErrorBody : $3e7e8a0093eea0b3$var$i18n.spacePermissionErrorBody;
    } else {
        errorTitle = $3e7e8a0093eea0b3$var$i18n.genericErrorTitle;
        errorBody = $3e7e8a0093eea0b3$var$i18n.genericErrorBody;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3e7e8a0093eea0b3$var$errorSectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "error",
        title: formatMessage(errorTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...errorBody,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
        }
    }))));
};
const $3e7e8a0093eea0b3$export$63ec0fdbb660e929 = ({ onClose: onClose, selectedVersion: selectedVersion, contentType: contentType })=>{
    const { formatMessage: formatMessage, formatDate: formatDate, formatTime: formatTime } = (0, $dBxQj.default)();
    const { onRestore: onRestore } = (0, $av0to.useVersionHistoryAnalytics)();
    const selectedVersionDate = (0, $ck0S9.getFormattedDate)(selectedVersion.updatedTime, formatDate, formatTime);
    // use current space as default space key
    const [{ spaceKey: spaceKey, contentId: contentId }] = (0, $ep3mz.usePageState)();
    const [destinationSpaceKey, setDestinationSpaceKey] = (0, $gwFzn.useState)(spaceKey);
    const [title, setTitle] = (0, $gwFzn.useState)(formatMessage($3e7e8a0093eea0b3$var$restoreContentModalMessaging[contentType].placeholderTitle, {
        date: selectedVersionDate
    }));
    const [restoreError, setRestoreError] = (0, $gwFzn.useState)(null);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'restore-content-modal'
    });
    const { selectedClassification: selectedClassification, classificationError: classificationError } = (0, $a1qSg.useClassificationChangeState)(String(contentId), destinationSpaceKey, spaceKey);
    const { hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const requiredSpaceOperations = [
        {
            targetType: 'page',
            operation: 'create'
        }
    ];
    const onSpaceSelectorChange = (selectedSpace)=>{
        const { spaceKey: selectedSpaceKey } = selectedSpace;
        setDestinationSpaceKey(selectedSpaceKey);
    };
    const { trackExperience: trackExperience } = (0, $aCrkK.useVersionHistoryExperienceTracking)();
    const [restoreVersion] = (0, $diswb.useMutation)((0, $d2LG0.default)`mutation RestoreContentModalRestoreContentMutation($spaceKey:String!$restoreVersionContentId:String!$title:String$type:String!){createContentContextual(input:{spaceKey:$spaceKey contentSpecificCreateInput:[{key:"restoreVersionContentId" value:$restoreVersionContentId}]status:CURRENT title:$title type:$type}){id links{context webui}}}`, {
        onCompleted: (data)=>{
            const contentUrl = `${data?.createContentContextual?.links?.context}${data?.createContentContextual?.links?.webui}?flow=restoreVersion`;
            trackExperience({
                contentType: contentType,
                experience: 'restoreExperience',
                task: 'start'
            });
            onRestore(selectedVersion);
            hideSidePanel();
            push(contentUrl);
        },
        onError: (graphqlError)=>{
            setRestoreError(graphqlError);
        }
    });
    const handleRestoreClick = (0, $gwFzn.useCallback)(()=>{
        setRestoreError(null);
        restoreVersion({
            variables: {
                spaceKey: destinationSpaceKey,
                title: title,
                type: contentType,
                restoreVersionContentId: selectedVersion.contentId
            }
        });
    }, [
        restoreVersion,
        destinationSpaceKey,
        title,
        contentType,
        selectedVersion
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // succeed restore modal load experience on render
        trackExperience({
            contentType: contentType,
            experience: 'restoreModal',
            task: 'succeed'
        });
    }, [
        contentType,
        trackExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        testId: "restore-content-modal",
        width: "400px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium",
        as: "h6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3e7e8a0093eea0b3$var$i18n.restoreContentTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        onClick: onClose,
        label: formatMessage($3e7e8a0093eea0b3$var$i18n.closeIconButtonLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3e7e8a0093eea0b3$var$ErrorSectionMessage, {
        error: restoreError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3e7e8a0093eea0b3$var$restoreContentModalMessaging[contentType].description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ktuvZ.VersionTitleUpdate), {
        title: title,
        setTitle: setTitle,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $caYQd.SpaceSelector), {
        onChange: onSpaceSelectorChange,
        operationsUsedToDetermineRestrictedStatus: requiredSpaceOperations,
        showRestrictedSpaces: false,
        filterDefaultFromResults: false,
        spaceKey: destinationSpaceKey,
        labelTextTransform: "none",
        useMenuPortalTarget: true,
        spaceClassification: selectedClassification,
        hasClassificationError: !!classificationError,
        selectStyleOverrides: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 9999
                })
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: enforceStorageLimit(handleRestoreClick),
        testId: "restore-content-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3e7e8a0093eea0b3$var$i18n.restoreButton))));
};

});
parcelRegister("ck0S9", function(module, exports) {

$parcel$export(module.exports, "getFormattedDate", () => $a0d25f7e92df57be$export$92521769c5df59ad);
const $a0d25f7e92df57be$export$92521769c5df59ad = (dateInputString, formatDate, formatTime)=>{
    const dateString = new Date(dateInputString);
    const formattedDate = formatDate(dateString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
    const formattedTime = formatTime(dateString, {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });
    return `${formattedDate} ${formattedTime.replace('AM', 'a.m.').replace('PM', 'p.m.')}`;
};

});

parcelRegister("ktuvZ", function(module, exports) {

$parcel$export(module.exports, "VersionTitleUpdate", () => $bd5348f98ee50a88$export$68f60d0fda17fe94);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");
var $jVhgp = parcelRequire("jVhgp");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $4noo5 = parcelRequire("4noo5");
const $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH = 60;
const $bd5348f98ee50a88$var$i18n = (0, $2nPZH.defineMessages)({
    whiteboardTitle: {
        id: "version-history.whiteboard-title",
        defaultMessage: "Whiteboard title"
    },
    titleLengthError: {
        id: "version-history.title.length.error",
        defaultMessage: "{maxLength, plural, one {Title has a maximum of {maxLength} character} other {Title has a maximum of {maxLength} characters}}"
    },
    databaseTitle: {
        id: "version-history.database-title",
        defaultMessage: "Database title"
    }
});
const $bd5348f98ee50a88$var$titleUpdateMessaging = {
    whiteboard: $bd5348f98ee50a88$var$i18n.whiteboardTitle,
    database: $bd5348f98ee50a88$var$i18n.databaseTitle
};
const $bd5348f98ee50a88$var$labelComponentStyle = (0, $ecnYn.xcss)({
    marginBottom: 'space.100',
    color: 'color.text.subtlest'
});
const $bd5348f98ee50a88$var$LabelComponent = ({ contentType: contentType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $bd5348f98ee50a88$var$labelComponentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $bd5348f98ee50a88$var$titleUpdateMessaging[contentType]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jVhgp.default), null));
const $bd5348f98ee50a88$export$68f60d0fda17fe94 = ({ title: title, setTitle: setTitle, contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [hasError, setHasError] = (0, $gwFzn.useState)(false);
    const handleTitleChange = (e)=>{
        const value = e.target.value;
        if (value.length <= $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH) {
            setTitle(value);
            setHasError(false);
        } else setHasError(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd5348f98ee50a88$var$LabelComponent, {
            contentType: contentType
        }),
        name: "version-title"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4noo5.default), {
            ...fieldProps,
            value: title,
            onChange: handleTitleChange,
            maxLength: $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH + 1,
            autoComplete: "off",
            isInvalid: hasError,
            testId: "version-title-input"
        })), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gQhRa.ErrorMessage), null, formatMessage($bd5348f98ee50a88$var$i18n.titleLengthError, {
        maxLength: $bd5348f98ee50a88$var$MAX_TITLE_NAME_LENGTH
    })));
};

});


parcelRegister("3G6jD", function(module, exports) {

$parcel$export(module.exports, "VersionHistoryContent", () => $3210ac4b9f221c74$export$23bb3757bf428071);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $7hXDW = parcelRequire("7hXDW");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $4B2M3 = parcelRequire("4B2M3");

var $dIouf = parcelRequire("dIouf");

var $av0to = parcelRequire("av0to");

var $cI2Ba = parcelRequire("cI2Ba");

var $8DoOG = parcelRequire("8DoOG");
const $3210ac4b9f221c74$var$i18n = (0, $2nPZH.defineMessages)({
    currentVersionTitle: {
        id: "version-history.current.version.title",
        defaultMessage: "Current version"
    },
    autoSavedVersionsTitle: {
        id: "version-history.auto-saved.version.title",
        defaultMessage: "Autosaved versions"
    },
    historyAvailabilityInfo: {
        id: "version-history.history.availability.info",
        defaultMessage: "Whiteboards history is available for the past 30 days."
    },
    databasehHistoryAvailabilityInfo: {
        id: "version-history.database.history.availability.info",
        defaultMessage: "Databases history is available for the past 30 days."
    }
});
const $3210ac4b9f221c74$var$contentTypeMessaging = {
    whiteboard: $3210ac4b9f221c74$var$i18n.historyAvailabilityInfo,
    database: $3210ac4b9f221c74$var$i18n.databasehHistoryAvailabilityInfo
};
const $3210ac4b9f221c74$var$bodyContentWrapperStyles = (0, $ecnYn.xcss)({
    overflowY: 'auto',
    flexGrow: 1
});
const $3210ac4b9f221c74$var$SectionTitle = ({ title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), title)));
const $3210ac4b9f221c74$export$23bb3757bf428071 = ({ error: error, autosavedVersions: autosavedVersions, hasNextPage: hasNextPage, loadMoreVersions: loadMoreVersions, cursor: cursor, refetch: refetch, loading: loading, handleVersionClick: handleVersionClick, selectedVersion: selectedVersion, eventService: eventService, contentType: contentType, title: title })=>{
    const { onCopyVersionContent: onCopyVersionContent } = (0, $av0to.useVersionHistoryAnalytics)();
    // certain browsers may not allow copying
    // only whiteboards support copying content
    const isCopyAllowed = contentType === 'whiteboard' && eventService.hasEventHandler('copy');
    const handleCopyClick = (0, $gwFzn.useCallback)(()=>{
        eventService.triggerEvent('copy');
        if (selectedVersion) onCopyVersionContent(selectedVersion);
    }, [
        eventService,
        selectedVersion,
        onCopyVersionContent
    ]);
    if (error && !loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8DoOG.ErrorState), {
        refetch: refetch
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3210ac4b9f221c74$var$bodyContentWrapperStyles,
        "data-testId": "version-history-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3210ac4b9f221c74$var$SectionTitle, {
        title: $3210ac4b9f221c74$var$i18n.currentVersionTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cI2Ba.VersionHistoryCurrentVersionItem), {
        handleVersionClick: handleVersionClick,
        isSelected: !selectedVersion,
        title: title
    })), autosavedVersions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3210ac4b9f221c74$var$SectionTitle, {
        title: $3210ac4b9f221c74$var$i18n.autoSavedVersionsTitle
    }), autosavedVersions.map((version)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cI2Ba.VersionHistoryItem), {
            version: version,
            key: version.number,
            handleVersionClick: handleVersionClick,
            isSelected: version.number === selectedVersion?.number,
            isCopyAllowed: isCopyAllowed,
            handleCopyClick: handleCopyClick
        });
    }), hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4B2M3.ObservableSpinner), {
        cursor: cursor,
        testId: "version-history-loading-spinner",
        onScrollTo: loadMoreVersions,
        observerOptions: {
            root: null,
            rootMargin: '0px',
            threshold: 0.05
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.200",
        paddingInlineEnd: "space.200",
        paddingInlineStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        align: "center",
        as: "p",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3210ac4b9f221c74$var$contentTypeMessaging[contentType]))));
};

});
parcelRegister("cI2Ba", function(module, exports) {

$parcel$export(module.exports, "VersionHistoryCurrentVersionItem", () => $073a675ae869dda9$export$15c96dc1a83defb4);
$parcel$export(module.exports, "VersionHistoryItem", () => $073a675ae869dda9$export$e0ca0449ea662b5);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $1qfLF = parcelRequire("1qfLF");

var $2MuFw = parcelRequire("2MuFw");

var $3gadb = parcelRequire("3gadb");

var $56M4r = parcelRequire("56M4r");

var $ck0S9 = parcelRequire("ck0S9");
const $073a675ae869dda9$var$i18n = (0, $2nPZH.defineMessages)({
    currentVersionDescription: {
        id: "version-history.current.version.description",
        defaultMessage: "Most recently saved"
    },
    copyIconLabel: {
        id: "version-history.copy.icon.label",
        defaultMessage: "Copy icon"
    },
    copyIconTooltip: {
        id: "version-history.copy.icon.tooltip",
        defaultMessage: "Copy all content"
    },
    copyIconTooltipCopied: {
        id: "version-history.copy.icon.tooltip-copied",
        defaultMessage: "Copied!"
    },
    lastEditedByLabel: {
        id: "version-history.author.last-edited-by.label",
        defaultMessage: "Last edited by {author}"
    },
    lastEditedByAnonymousUserLabel: {
        id: "version-history.author.last-edited-by-anonymous-user.label",
        defaultMessage: "Last edited by Anonymous"
    },
    lastEditedByDeactivatedUserLabel: {
        id: "version-history.author.last-edited-by-deactivated-user.label",
        defaultMessage: "Last edited by {author} (Deactivated)"
    }
});
const $073a675ae869dda9$var$itemContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100'
});
const $073a675ae869dda9$export$15c96dc1a83defb4 = ({ handleVersionClick: handleVersionClick, isSelected: isSelected, title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        isSelected: isSelected,
        testId: "version-history-item",
        onClick: ()=>handleVersionClick(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $073a675ae869dda9$var$itemContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "medium"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $073a675ae869dda9$var$i18n.currentVersionDescription)))));
};
const $073a675ae869dda9$export$e0ca0449ea662b5 = ({ version: version, handleVersionClick: handleVersionClick, isSelected: isSelected, isCopyAllowed: isCopyAllowed, handleCopyClick: handleCopyClick })=>{
    const { formatMessage: formatMessage, formatDate: formatDate, formatTime: formatTime } = (0, $dBxQj.default)();
    const copyAllContentText = formatMessage($073a675ae869dda9$var$i18n.copyIconTooltip);
    const copiedText = formatMessage($073a675ae869dda9$var$i18n.copyIconTooltipCopied);
    const [isCopyClicked, setIsCopyClicked] = (0, $gwFzn.useState)(false);
    const handleClick = (0, $gwFzn.useCallback)((e)=>{
        e.stopPropagation();
        handleCopyClick();
        setIsCopyClicked(true);
    }, [
        handleCopyClick
    ]);
    const handleMouseLeave = ()=>{
        setIsCopyClicked(false);
    };
    const displayName = ()=>{
        const author = version?.author;
        if (!author?.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $073a675ae869dda9$var$i18n.lastEditedByAnonymousUserLabel);
        if (author?.isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$073a675ae869dda9$var$i18n.lastEditedByLabel,
            values: {
                author: author?.displayName
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$073a675ae869dda9$var$i18n.lastEditedByDeactivatedUserLabel,
            values: {
                author: author?.displayName
            }
        });
    };
    const shouldShowCopyIcon = isSelected && isCopyAllowed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        isSelected: isSelected,
        testId: "version-history-item",
        onClick: ()=>handleVersionClick(version)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $073a675ae869dda9$var$itemContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "medium"
    }, (0, $ck0S9.getFormattedDate)(version.updatedTime, formatDate, formatTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle"
    }, displayName())), shouldShowCopyIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: isCopyClicked ? copiedText : copyAllContentText,
        position: "bottom",
        // force remount otherwise content is off-center
        key: isCopyClicked ? 'copied' : 'default'
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
            ...tooltipProps,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
            label: formatMessage($073a675ae869dda9$var$i18n.copyIconLabel),
            onClick: handleClick,
            onMouseLeave: handleMouseLeave,
            onBlur: handleMouseLeave,
            testId: "version-content-copy-button"
        }))));
};

});

parcelRegister("8DoOG", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $ed56899ddf7b83e5$export$c1ed4f415b9e7023);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $abC4X = parcelRequire("abC4X");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $ccHMk = parcelRequire("ccHMk");

var $9wGTI = parcelRequire("9wGTI");

var $fF3tF = parcelRequire("fF3tF");
const $ed56899ddf7b83e5$var$i18n = (0, $2nPZH.defineMessages)({
    errorStateHeaderTitle: {
        id: "version-history.error-state.header.title",
        defaultMessage: "Unable to load"
    },
    retryOrRefreshText: {
        id: "version-history.error-state.retry.or.refresh.text",
        defaultMessage: "We were unable to load board history. Try again, or check your network connection."
    },
    newRetryOrRefreshText: {
        id: "version-history.error-state.new.retry.or.refresh.text",
        defaultMessage: "We were unable to load history. Try again, or check your network connection."
    },
    retryButtonText: {
        id: "version-history.error-state.retry.button.text",
        defaultMessage: "Retry"
    }
});
const $ed56899ddf7b83e5$var$errorStateContainerStyles = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $ed56899ddf7b83e5$export$c1ed4f415b9e7023 = ({ refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const handleRefetch = (0, $gwFzn.useCallback)(()=>{
        refetch();
    }, [
        refetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $ed56899ddf7b83e5$var$errorStateContainerStyles,
        paddingInline: "space.600",
        paddingBlockEnd: "space.600",
        testId: "version-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $abC4X.default), {
        header: formatMessage($ed56899ddf7b83e5$var$i18n.errorStateHeaderTitle),
        description: (0, $9wGTI.fg)('confluence_frontend_databases_version_history_ui') ? formatMessage($ed56899ddf7b83e5$var$i18n.newRetryOrRefreshText) : formatMessage($ed56899ddf7b83e5$var$i18n.retryOrRefreshText),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleRefetch
        }, formatMessage($ed56899ddf7b83e5$var$i18n.retryButtonText)),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($fF3tF)))
    }));
};

});
parcelRegister("fF3tF", function(module, exports) {
module.exports = new URL("GenericErrorImage.b96ea332.svg", import.meta.url).toString();

});



parcelRegister("kI68q", function(module, exports) {

$parcel$export(module.exports, "VersionHistoryLoadingPlaceholder", () => $7a46560dab52d7e2$export$ad13dd24f966ba14);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $3hnrC = parcelRequire("3hnrC");
var $4WZFP = parcelRequire("4WZFP");
const $7a46560dab52d7e2$var$titleSkeleton = (0, $ecnYn.xcss)({
    height: '16px',
    width: '100%',
    borderRadius: '16px'
});
const $7a46560dab52d7e2$var$subHeaderSkeletion = (0, $ecnYn.xcss)({
    height: '14px',
    borderRadius: '16px',
    width: '60px',
    marginBottom: 'space.150'
});
const $7a46560dab52d7e2$var$versionItemSkeleton = (0, $ecnYn.xcss)({
    width: '75%',
    borderRadius: '16px'
});
const $7a46560dab52d7e2$var$sectionBodySkeleton = (0, $ecnYn.xcss)({
    width: '100%',
    paddingBlock: 'space.250'
});
const $7a46560dab52d7e2$export$ad13dd24f966ba14 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        "data-testId": "version-history-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$titleSkeleton,
        backgroundColor: "color.skeleton"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3hnrC.SidePanelBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $7a46560dab52d7e2$var$sectionBodySkeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$subHeaderSkeletion,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$versionItemSkeleton,
        paddingBlock: "space.100",
        backgroundColor: "color.skeleton"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $7a46560dab52d7e2$var$sectionBodySkeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$subHeaderSkeletion,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $7a46560dab52d7e2$var$versionItemSkeleton,
        paddingBlock: "space.100",
        paddingInline: "space.200",
        backgroundColor: "color.skeleton"
    }))));
};

});
parcelRegister("3hnrC", function(module, exports) {

$parcel$export(module.exports, "SidePanelBody", () => $6f3a2c1a9f6e5048$export$b32ca013fcba8075);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $6f3a2c1a9f6e5048$var$bodyWrapperStyles = (0, $ecnYn.xcss)({
    flexGrow: '1'
});
const $6f3a2c1a9f6e5048$export$b32ca013fcba8075 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.100",
        paddingInlineStart: "space.300",
        paddingInlineEnd: "space.150",
        xcss: $6f3a2c1a9f6e5048$var$bodyWrapperStyles
    }, children);
};

});



parcelRegister("l6qp5", function(module, exports) {

$parcel$export(module.exports, "useShareNewWhiteboardFlag", () => $42b1b28d51262f30$export$9c12f2fdf6cc721d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $9M4aB = parcelRequire("9M4aB");

var $bQm3c = parcelRequire("bQm3c");

var $lgKMU = parcelRequire("lgKMU");

var $8crFA = parcelRequire("8crFA");

var $euL71 = parcelRequire("euL71");

var $jooGc = parcelRequire("jooGc");

var $6mKj3 = parcelRequire("6mKj3");
const $42b1b28d51262f30$export$5ff95d09b8f6f8b0 = 'shareNewWhiteboardFlag';
const $42b1b28d51262f30$var$FIVE_MINUTES_TIMEOUT = 300000;
const $42b1b28d51262f30$var$i18n = (0, $2nPZH.defineMessages)({
    shareFlagTitle: {
        id: "experiment-share-new-whiteboard.flag-title",
        defaultMessage: "Share this whiteboard with your team"
    },
    shareFlagDescription: {
        id: "experiment-share-new-whiteboard.flag-description",
        defaultMessage: "Start collaborating in real-time using tools like voting, timer, integrations, and more."
    },
    shareFlagCTA: {
        id: "experiment-share-new-whiteboard.flag-cta",
        defaultMessage: "Share whiteboard"
    }
});
function $42b1b28d51262f30$export$9c12f2fdf6cc721d({ isNewWhiteboard: isNewWhiteboard, isMobile: isMobile = false, contentId: contentId, spaceKey: spaceKey, dialogs: dialogs, flags: flags }) {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const shareWhiteboardFlagTimeoutRef = (0, $gwFzn.useRef)(null);
    const { hasClickedShareButton: hasClickedShareButton } = (0, $8crFA.useShareAndRestrictButtonState)();
    const { hasClickedCopyContentLink: hasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkState)();
    const handleShowShareAndRestrictDialog = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: $42b1b28d51262f30$export$5ff95d09b8f6f8b0,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'ShareWhiteboard'
            }
        }).fire();
        flags.hideFlag($42b1b28d51262f30$export$5ff95d09b8f6f8b0);
        dialogs.showModal((0, $lgKMU.ShareAndRestrictDialogController), {
            contentId: contentId,
            contentType: 'whiteboard',
            allowRestrictions: true,
            pageModes: 'view',
            refetchButtonData: ()=>{},
            isUnpublishedDraft: false,
            spaceKey: spaceKey,
            openFrom: $42b1b28d51262f30$export$5ff95d09b8f6f8b0
        });
    }, [
        createAnalyticsEvent,
        contentId,
        spaceKey,
        dialogs,
        flags
    ]);
    const handleDismissFlag = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissFlag',
                source: $42b1b28d51262f30$export$5ff95d09b8f6f8b0
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    //Step 1 : Add timeout to trigger share whiteboard flag
    // -> Only eligible for experiment and new whiteboard will have trigger
    //Step 2: Show share whiteboard flag when 5 mins timeout due
    // -> Only if user hasnt click share button or copy link button can see share whiteboard flag
    // -> Only if user are in test(experiment) group will fire exposure and show share whiteboard flag
    (0, $gwFzn.useEffect)(()=>{
        if (!isMobile && isNewWhiteboard) shareWhiteboardFlagTimeoutRef.current = setTimeout(()=>{
            if (!hasClickedShareButton && !hasClickedCopyContentLink) //2 experiments are mutually exclusive on Confluence edition check level
            {
                if (edition === (0, $euL71.ConfluenceEdition).FREE && (0, $6mKj3.expValEquals)('cc_share_new_whiteboard_free', 'cohort', 'experiment') || edition !== (0, $euL71.ConfluenceEdition).FREE && (0, $6mKj3.expValEquals)('cc_share_new_whiteboard_paid', 'cohort', 'experiment')) {
                    flags.showFlag({
                        id: $42b1b28d51262f30$export$5ff95d09b8f6f8b0,
                        onClose: handleDismissFlag,
                        close: 'never',
                        type: 'custom',
                        customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9M4aB))), {
                            label: ""
                        }),
                        title: formatMessage($42b1b28d51262f30$var$i18n.shareFlagTitle),
                        description: formatMessage($42b1b28d51262f30$var$i18n.shareFlagDescription),
                        actions: [
                            {
                                content: formatMessage($42b1b28d51262f30$var$i18n.shareFlagCTA),
                                onClick: ()=>handleShowShareAndRestrictDialog()
                            }
                        ]
                    });
                    createAnalyticsEvent({
                        type: 'sendScreenEvent',
                        data: {
                            name: $42b1b28d51262f30$export$5ff95d09b8f6f8b0
                        }
                    }).fire();
                }
            }
        }, $42b1b28d51262f30$var$FIVE_MINUTES_TIMEOUT);
        return ()=>{
            if (shareWhiteboardFlagTimeoutRef.current) clearTimeout(shareWhiteboardFlagTimeoutRef.current);
            flags.hideFlag($42b1b28d51262f30$export$5ff95d09b8f6f8b0);
        };
    }, [
        isNewWhiteboard,
        isMobile,
        hasClickedShareButton,
        hasClickedCopyContentLink,
        handleShowShareAndRestrictDialog,
        handleDismissFlag,
        createAnalyticsEvent,
        flags,
        formatMessage,
        edition
    ]);
}

});
parcelRegister("8crFA", function(module, exports) {

$parcel$export(module.exports, "useShareAndRestrictButtonState", () => $d466d6f5ce37a5ee$export$15991ed5dace2362);
$parcel$export(module.exports, "useShareAndRestrictButtonActions", () => $d466d6f5ce37a5ee$export$6033af6626ad7b59);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $d466d6f5ce37a5ee$var$initialState = {
    hasClickedShareButton: false
};
const $d466d6f5ce37a5ee$var$actions = {
    setHasClickedShareButton: ()=>({ setState: setState })=>{
            setState({
                hasClickedShareButton: true
            });
        },
    resetHasClickedShareButton: ()=>({ setState: setState })=>{
            setState({
                hasClickedShareButton: false
            });
        }
};
const $d466d6f5ce37a5ee$var$ShareAndRestrictButtonStore = (0, $4ZoIm.createStore)({
    initialState: $d466d6f5ce37a5ee$var$initialState,
    actions: $d466d6f5ce37a5ee$var$actions,
    name: 'ShareAndRestrictButtonStore'
});
const $d466d6f5ce37a5ee$export$15991ed5dace2362 = (0, $iFWZA.createStateHook)($d466d6f5ce37a5ee$var$ShareAndRestrictButtonStore);
const $d466d6f5ce37a5ee$export$6033af6626ad7b59 = (0, $iFWZA.createActionsHook)($d466d6f5ce37a5ee$var$ShareAndRestrictButtonStore);

});


parcelRegister("3r60T", function(module, exports) {

$parcel$export(module.exports, "ContentTypesObjectSidebarService", () => $1f097128e34aca92$export$8bb2aafdd7e4ca0b);
class $1f097128e34aca92$export$8bb2aafdd7e4ca0b {
    dispose() {
        this.changeObjectSidebarShownHandler = [];
        this.changeObjectSidebarShownHandler_LEGACY = [];
    }
    registerChangeObjectSidebarShownHandler(callback) {
        this.changeObjectSidebarShownHandler.push(callback);
    }
    registerChangeObjectSidebarShownHandler_LEGACY(callback) {
        this.changeObjectSidebarShownHandler_LEGACY.push(callback);
    }
    onChangeObjectSidebarShown(state) {
        this.changeObjectSidebarShownHandler.forEach((callback)=>callback(state));
    }
    onChangeObjectSidebarShown_LEGACY(isShown) {
        this.changeObjectSidebarShownHandler_LEGACY.forEach((callback)=>callback(isShown));
    }
    constructor(){
        this.changeObjectSidebarShownHandler = void 0;
        this.changeObjectSidebarShownHandler_LEGACY = void 0;
        this.changeObjectSidebarShownHandler = [];
        this.changeObjectSidebarShownHandler_LEGACY = [];
    }
}

});

parcelRegister("exahZ", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommentsPanelCallbacks", () => $f159370a32aca251$export$9008442889802bb3);

var $gwFzn = parcelRequire("gwFzn");

var $5fMeR = parcelRequire("5fMeR");

var $3mVfX = parcelRequire("3mVfX");
var $6KwrO = parcelRequire("6KwrO");

var $6hmtW = parcelRequire("6hmtW");
const $f159370a32aca251$export$9008442889802bb3 = ()=>{
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel, hideCommentsPanel: hideCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const setCommentThreadHandler = (0, $gwFzn.useCallback)((threadId)=>{
        // highlight a comment in sidebar
        // if threadId is undefined, it means we are de-selecting
        setCurrentlySelectedThreadKey(threadId);
        if (threadId) // scroll to the comment thread in the sidebar
        scrollCommentsPanelToThread({
            annotationId: threadId,
            annotationClicked: true
        });
    }, [
        setCurrentlySelectedThreadKey,
        scrollCommentsPanelToThread
    ]);
    const showPanelHandler = (0, $gwFzn.useCallback)((threadId)=>{
        if (!isCommentsPanelShown) showCommentsPanel();
        if (threadId) setCommentThreadHandler(threadId);
    }, [
        isCommentsPanelShown,
        showCommentsPanel,
        setCommentThreadHandler
    ]);
    const hidePanelHandler = (0, $gwFzn.useCallback)(()=>{
        if (isCommentsPanelShown) hideCommentsPanel();
    }, [
        isCommentsPanelShown,
        hideCommentsPanel
    ]);
    (0, $gwFzn.useEffect)(()=>{
        commentService.registerSelectCommentThreadHandler(setCommentThreadHandler);
        commentService.registerShowPanelHandler(showPanelHandler);
        commentService.registerHidePanelHandler(hidePanelHandler);
        return ()=>{
            // un-set the handlers on component unmount
            commentService.registerSelectCommentThreadHandler(undefined);
            commentService.registerShowPanelHandler(undefined);
            commentService.registerHidePanelHandler(undefined);
        };
    }, [
        commentService,
        showPanelHandler,
        hidePanelHandler,
        setCommentThreadHandler
    ]);
};

});

parcelRegister("fq9IJ", function(module, exports) {

$parcel$export(module.exports, "whiteboardHeightContainer", () => $e46898bd2b09485d$export$12c5be5178523b06);
$parcel$export(module.exports, "whiteboardShellStyle", () => $e46898bd2b09485d$export$b401fb5faf01c309);

var $3PXtn = parcelRequire("3PXtn");
const $e46898bd2b09485d$export$12c5be5178523b06 = [
    (0, $3PXtn.BannerStateContainer)
];
const $e46898bd2b09485d$export$b401fb5faf01c309 = (isSSR, isSidePanelOpen = false)=>({
        width: isSidePanelOpen ? 'calc(100% - 320px)' : '100%',
        opacity: isSSR ? 0 : 1,
        backgroundColor: "var(--ds-surface, #FFFFFF)",
        ...isSidePanelOpen ? {
            transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1) 0s'
        } : {},
        flexGrow: 1
    });

});

parcelRegister("1K5hY", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardParams", () => $6ffd0682adb72547$export$3f113f8dceee6e07);

var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");

var $bj5fB = parcelRequire("bj5fB");

var $hQnHK = parcelRequire("hQnHK");

var $lLfgC = parcelRequire("lLfgC");
const $6ffd0682adb72547$var$envList = [
    'dev',
    'branch',
    'staging',
    'hello'
];
const $6ffd0682adb72547$var$retrieveQueryParameter = (queryParams, key)=>{
    return queryParams?.[key] && !Array.isArray(queryParams?.[key]) ? queryParams?.[key] // TypeScript doesn't acknowledge the !Array.isArray
     : undefined;
};
const $6ffd0682adb72547$export$3f113f8dceee6e07 = ()=>{
    const { isMobileApp: isMobileAppEmbed } = (0, $bj5fB.useIsMobileApp)();
    const { getQueryParams: getQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    // Versioned deploys are currently only supported in development and internal
    // environments
    const allowDevParams = $6ffd0682adb72547$var$envList.some((e)=>e === "canary");
    const frontendVersion = allowDevParams && queryParams?.['canvas-frontend'] && !Array.isArray(queryParams?.['canvas-frontend']) ? queryParams?.['canvas-frontend'] : null;
    const whiteboardLocale = $6ffd0682adb72547$var$retrieveQueryParameter(queryParams, (0, $hQnHK.WHITEBOARD_LOCALE));
    const whiteboardLinkedObject = $6ffd0682adb72547$var$retrieveQueryParameter(queryParams, (0, $hQnHK.WHITEBOARD_LINKED_OBJECT));
    const canvasServerSpot = allowDevParams ? (0, $lLfgC.whiteboardSpotFromParams)(queryParams, 'canvas-server') : undefined;
    const canvasRelaySpot = allowDevParams ? (0, $lLfgC.whiteboardSpotFromParams)(queryParams, 'canvas-relay') : undefined;
    const focusedCommentId = $6ffd0682adb72547$var$retrieveQueryParameter(queryParams, (0, $hQnHK.FOCUSED_COMMENT_ID));
    const replyToComment = $6ffd0682adb72547$var$retrieveQueryParameter(queryParams, (0, $hQnHK.REPLY_TO_COMMENT));
    const parentProduct = $6ffd0682adb72547$var$retrieveQueryParameter(queryParams, (0, $hQnHK.PARENT_PRODUCT_QUERY_PARAM));
    const createdFromSlug = $6ffd0682adb72547$var$retrieveQueryParameter(queryParams, (0, $hQnHK.CREATED_FROM_SLUG));
    const visualRefresh = $6ffd0682adb72547$var$retrieveQueryParameter(queryParams, (0, $hQnHK.VISUAL_REFRESH_PARAM));
    return {
        'canvas-frontend': frontendVersion,
        'canvas-server': canvasServerSpot,
        'canvas-relay': canvasRelaySpot,
        [(0, $hQnHK.WHITEBOARD_LOCALE)]: whiteboardLocale,
        [(0, $hQnHK.WHITEBOARD_LINKED_OBJECT)]: whiteboardLinkedObject,
        [(0, $hQnHK.FOCUSED_COMMENT_ID)]: focusedCommentId,
        [(0, $hQnHK.REPLY_TO_COMMENT)]: replyToComment,
        [(0, $hQnHK.CREATED_FROM_SLUG)]: createdFromSlug,
        headless: queryParams?.[0, $hQnHK.HEADLESS_QUERY_PARAM] === 'true',
        parentProduct: parentProduct,
        isSmartLinkEmbed: parentProduct === 'smartLink',
        isMobileAppEmbed: isMobileAppEmbed,
        [(0, $hQnHK.VISUAL_REFRESH_PARAM)]: visualRefresh === 'true'
    };
};

});
parcelRegister("bj5fB", function(module, exports) {

$parcel$export(module.exports, "useIsMobileApp", () => $8579ac0d0bed5d4d$export$ee773ad61083d113);

var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");
const $8579ac0d0bed5d4d$var$MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS = [
    'mobileAppWithEditing'
];
const $8579ac0d0bed5d4d$var$MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS = [
    ...$8579ac0d0bed5d4d$var$MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS,
    'mobileAppWithCommenting'
];
const $8579ac0d0bed5d4d$var$MOBILE_APP_PARENT_PRODUCT_QUERY_PARAMS = [
    ...$8579ac0d0bed5d4d$var$MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS,
    'mobileApp'
];
const $8579ac0d0bed5d4d$export$ee773ad61083d113 = ()=>{
    const { getQueryParams: getQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { parentProduct: parentProduct = '' } = getQueryParams();
    return {
        isMobileApp: $8579ac0d0bed5d4d$var$MOBILE_APP_PARENT_PRODUCT_QUERY_PARAMS.includes(parentProduct),
        isMobileAppWithCommenting: $8579ac0d0bed5d4d$var$MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS.includes(parentProduct),
        isMobileAppWithEditing: $8579ac0d0bed5d4d$var$MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS.includes(parentProduct)
    };
};

});

parcelRegister("lLfgC", function(module, exports) {

$parcel$export(module.exports, "whiteboardSpotFromParams", () => $ac26edd98938424a$export$2a32b5a7437debe7);
const $ac26edd98938424a$export$2a32b5a7437debe7 = function whiteboardSpotFromParams(params, name) {
    const rawSpot = params[name];
    if (!rawSpot || Array.isArray(rawSpot)) return;
    const maybeSpot = parseInt(rawSpot);
    if (Number.isNaN(maybeSpot)) return;
    if (maybeSpot < 1 || maybeSpot > 20) return;
    return maybeSpot;
};

});


parcelRegister("2D9Zb", function(module, exports) {

$parcel$export(module.exports, "getWhiteboardVersion", () => $caab4665cbd3d103$export$2a27d7291de20da8);
$parcel$export(module.exports, "clearWhiteboardVersion", () => $caab4665cbd3d103$export$1171fa9f6c24312a);

var $68uaC = parcelRequire("68uaC");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $caab4665cbd3d103$export$5f70f33d821bcec0 = 'bifrost-override';
const $caab4665cbd3d103$export$42d2f767834caa32 = ()=>{
    const cookieValue = (0, $68uaC.Cookies).get($caab4665cbd3d103$export$5f70f33d821bcec0);
    if (!cookieValue) return null;
    try {
        // Decode the URL-encoded JSON string
        const decodedValue = decodeURIComponent(cookieValue);
        const parsedValue = JSON.parse(decodedValue);
        return parsedValue.version || null;
    } catch (err) {
        return null;
    }
};
const $caab4665cbd3d103$export$2a27d7291de20da8 = (params)=>{
    const version = params['canvas-frontend'];
    return version ?? $caab4665cbd3d103$export$42d2f767834caa32();
};
const $caab4665cbd3d103$export$1171fa9f6c24312a = async ()=>new Promise((resolve)=>/**
		 * "Why on earth is there a setTimeout here?"
		 * Empirically, without this we've had situations where you'd need to click "Exit branch deploy"
		 * twice, because the first time the local storage would not be recognised as cleared.
		 *
		 * This is addressed by adding a 0ms timeout, which moves the inside function to execute and then
		 * resolves a Promise when it's complete. We await this promise in the parent function,
		 * which forces the clearing of the whiteboard version to complete before refreshing.
		 *
		 * Sources:
		 * https://stackoverflow.com/questions/20231163/is-html5-localstorage-asynchronous
		 * https://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
		 * https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#delay
		 */ setTimeout(()=>{
            (0, $68uaC.Cookies).remove($caab4665cbd3d103$export$5f70f33d821bcec0);
            (0, $e9zUf.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).CANVAS_FRONTEND_VERSION);
            (0, $e9zUf.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).CANVAS_SERVER);
            (0, $e9zUf.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).CANVAS_RELAY);
            return resolve();
        }));

});

parcelRegister("81swl", function(module, exports) {

$parcel$export(module.exports, "WhiteboardExitVersion", () => $ce9868b16382ef51$export$e9457b32d848cffb);

var $gwFzn = parcelRequire("gwFzn");

var $eEA8O = parcelRequire("eEA8O");

var $2D9Zb = parcelRequire("2D9Zb");
const $ce9868b16382ef51$var$styles = {
    position: 'absolute',
    left: "var(--ds-space-250, 20px)",
    top: "var(--ds-space-800, 64px)"
};
const $ce9868b16382ef51$export$e9457b32d848cffb = ({ version: version, serverSpot: serverSpot, relaySpot: relaySpot })=>{
    const onClearVersion = (0, $gwFzn.useCallback)(async ()=>{
        await (0, $2D9Zb.clearWhiteboardVersion)();
        location.replace(location.pathname);
    }, []);
    if (!version && !serverSpot && !relaySpot) return null;
    const typeTag = version ? 'version' : 'spot';
    const versionTag = version ? `(${version})` : '';
    const serverTag = serverSpot ? `canvas-server-${serverSpot}` : '';
    const relayTag = relaySpot ? `canvas-relay-${relaySpot}` : '';
    const description = [
        typeTag,
        'deploy',
        versionTag,
        serverTag,
        relayTag
    ].filter(Boolean);
    return(//eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        style: $ce9868b16382ef51$var$styles,
        onClick: onClearVersion
    }, "Exit ", description.join(' ')));
};

});

parcelRegister("4wero", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardBridgeAPI", () => $9b1a77e0f3e24c9b$export$2da4cfbe6309fb9a);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $bEV5S = parcelRequire("bEV5S");

var $bQm3c = parcelRequire("bQm3c");

var $1kHsc = parcelRequire("1kHsc");

var $hQnHK = parcelRequire("hQnHK");
var $kDja4 = parcelRequire("kDja4");

var $6mKj3 = parcelRequire("6mKj3");

var $gXrHX = parcelRequire("gXrHX");

var $6hmtW = parcelRequire("6hmtW");

var $3nKIV = parcelRequire("3nKIV");

var $7LhUs = parcelRequire("7LhUs");

var $iaHf1 = parcelRequire("iaHf1");

var $bLB3t = parcelRequire("bLB3t");

var $k6t2p = parcelRequire("k6t2p");

var $6attE = parcelRequire("6attE");

var $5wU3V = parcelRequire("5wU3V");

var $6CkfA = parcelRequire("6CkfA");

var $9Yv7s = parcelRequire("9Yv7s");

var $9Zj7l = parcelRequire("9Zj7l");
const $9b1a77e0f3e24c9b$export$2da4cfbe6309fb9a = ({ version: version, relaySpot: relaySpot, serverSpot: serverSpot, whiteboardLocale: whiteboardLocale, whiteboardLinkedObject: whiteboardLinkedObject, focusedCommentId: focusedCommentId, replyToComment: replyToComment, space: space, spaceKey: spaceKey, contentId: contentId, referenceId: referenceId, contentCreatorId: contentCreatorId, shareToken: shareToken, params: params, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, refetch: refetch, services: { aiAgentService: aiAgentService, editionUpgradeService: editionUpgradeService, feedbackService: feedbackService, onboardingService: onboardingService, eventService: eventService, whiteboardInternalModalService: whiteboardInternalModalService, flagService: flagService, integrationService: integrationService, whiteboardsVersionHistoryService: whiteboardsVersionHistoryService, navigationService: navigationService, objectSidebarService: objectSidebarService }, onThemeLoaded: onThemeLoaded, onPermissionChange: onPermissionChange, whiteboardVersionId: whiteboardVersionId, createdFromSlug: createdFromSlug })=>{
    const { userId: accountId, cloudId: tenantId } = (0, $bQm3c.useSessionData)();
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled, platformFeatureFlagResolver: platformFeatureFlagResolver } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { userType: publicLinkUserType, isExternalShareRequest: isExternalShareRequest } = (0, $gwFzn.useContext)((0, $gXrHX.ExternalShareContext));
    const openTemplatePickerState = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.TEMPLATE_PICKER_QUERY_PARAM));
    const openTemplatePicker = openTemplatePickerState !== undefined ? openTemplatePickerState === 'true' : undefined;
    const jiraImportToolState = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM));
    const openJiraImportTool = jiraImportToolState !== undefined ? jiraImportToolState === 'true' : undefined;
    let openMiroImportTool = undefined;
    const miroImportToolState = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.MIRO_IMPORT_TOOL_QUERY_PARAM));
    if ((0, $6mKj3.expValEqualsNoExposure)('prompt_whiteboard_competitor_link', 'cohort', 'experiment')) openMiroImportTool = miroImportToolState !== undefined ? miroImportToolState === 'true' : undefined;
    const insertTemplateWithKey = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM));
    const parentProduct = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.PARENT_PRODUCT_QUERY_PARAM), false);
    const embeddedThemeState = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.EMBEDDED_THEME_STATE), false);
    const visualRefreshQueryState = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.VISUAL_REFRESH_PARAM), false);
    const visualRefresh = visualRefreshQueryState === undefined ? (0, $dh538.fg)('platform-component-visual-refresh') : visualRefreshQueryState === 'true';
    const createdAt = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM), false);
    const { commentService: commentService } = (0, $6hmtW.useCommentService)();
    const cloudId = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.CLOUD_ID));
    const projectUuid = (0, $iaHf1.useWhiteboardQueryParamState)(contentId, (0, $hQnHK.PROJECT_UUID));
    const { themingService: themingService, initialThemeSerialized: initialThemeSerialized } = (0, $5wU3V.useThemingService)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    // Keep the `src` attribute of the iframe the same, and instead use the iframe's
    // location API to update the URL. We *need* to do this, as directly updating the `src`
    // attribute will push to the history stack in addition to react-router, breaking the
    // browser back/forward button.
    const url = (0, $7LhUs.getWhiteboardURL)(referenceId, {
        // Don't show the template picker while the referenceId is loading
        openTemplatePicker: referenceId ? openTemplatePicker : undefined,
        openJiraImportTool: referenceId ? openJiraImportTool : undefined,
        openMiroImportTool: referenceId ? openMiroImportTool : undefined,
        cloudId: openJiraImportTool ? cloudId : undefined,
        projectUuid: openJiraImportTool ? projectUuid : undefined,
        insertTemplateWithKey: referenceId ? insertTemplateWithKey : undefined,
        headless: params?.headless,
        canvasServerSpot: serverSpot,
        canvasRelaySpot: relaySpot,
        whiteboardLocale: whiteboardLocale,
        whiteboardLinkedObject: whiteboardLinkedObject,
        initialTheme: embeddedThemeState || initialThemeSerialized,
        parentProduct: parentProduct,
        createdAt: createdAt,
        focusedCommentId: focusedCommentId,
        replyToComment: replyToComment,
        whiteboardVersionId: whiteboardVersionId,
        createdFromSlug: createdFromSlug,
        bifrostVersion: version ?? undefined,
        visualRefresh: visualRefresh
    });
    const initialUrl = (0, $gwFzn.useRef)(url);
    const tokenService = (0, $6attE.useTokenService)({
        tenantId: tenantId,
        space: space,
        referenceId: referenceId,
        shareToken: shareToken,
        contentId: contentId,
        dataSecurityPolicyPageExport: dataSecurityPolicyPageExport,
        refetch: refetch,
        onPermissionChange: onPermissionChange
    });
    const routeService = (0, $bEV5S.useRouteService)(url);
    const containerService = (0, $bLB3t.useContainerService)(space, spaceKey);
    const orgDataService = (0, $k6t2p.useOrgDataService)();
    const publicLinkService = (0, $6CkfA.usePublicLinkService)(contentId, tokenService);
    const contentDataService = (0, $9Yv7s.useContentDataService)({
        contentCreatorId: contentCreatorId
    });
    const detailsPanelService = (0, $9Zj7l.useDetailsPanelService)();
    const [bridgeApi] = (0, $gwFzn.useState)(()=>{
        const context = {
            sessionData: {
                accountId: // For anonymous users, pass in unidentified value so canvas can process
                !accountId ? 'unidentified' : accountId,
                tenantId: tenantId,
                publicLinkUserType: publicLinkUserType
            },
            isExternalShareRequest: isExternalShareRequest
        };
        const services = {
            aiAgentService: aiAgentService,
            containerService: containerService,
            experienceTracker: experienceTracker,
            isFeatureActive: isWhiteboardFeatureEnabled,
            platformFeatureFlagResolver: platformFeatureFlagResolver,
            navigationService: navigationService,
            onboardingService: onboardingService,
            orgDataService: orgDataService,
            routeService: routeService,
            tokenService: tokenService,
            editionUpgradeService: editionUpgradeService,
            themingService: themingService,
            feedbackService: feedbackService,
            onThemeLoaded: onThemeLoaded,
            eventService: eventService,
            whiteboardInternalModalService: whiteboardInternalModalService,
            flagService: flagService,
            integrationService: integrationService,
            whiteboardsVersionHistoryService: whiteboardsVersionHistoryService,
            publicLinkService: publicLinkService,
            contentDataService: contentDataService,
            detailsPanelService: detailsPanelService,
            objectSidebarService: objectSidebarService,
            commentService: commentService
        };
        return (0, $3nKIV.WhiteboardBridgeAPIBuilder).with(context, services).build();
    });
    // Don't add bridge API to window object in SSR
    if (!isSSR) window.contentAPI = bridgeApi;
    // Make sure we clean up the whiteboard bridge API when unmounting
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            delete window.contentAPI;
        };
    }, []);
    return {
        initialUrl: `${(0, $7LhUs.getWhiteboardURLBase)(parentProduct)}${initialUrl.current}`
    };
};

});
parcelRegister("bEV5S", function(module, exports) {

$parcel$export(module.exports, "useRouteService", () => $5e2c9a002d33dfc1$export$1f24f6fb274325bc);

var $gwFzn = parcelRequire("gwFzn");

var $7utkt = parcelRequire("7utkt");
const $5e2c9a002d33dfc1$export$1f24f6fb274325bc = (url)=>{
    const [routeService] = (0, $gwFzn.useState)(()=>new (0, $7utkt.ContentTypeRouteService)());
    const initialRender = (0, $gwFzn.useRef)(true);
    (0, $gwFzn.useEffect)(()=>{
        if (!initialRender.current) routeService.updateRoute(url);
        initialRender.current = false;
    }, [
        routeService,
        url
    ]);
    return routeService;
};

});
parcelRegister("7utkt", function(module, exports) {

$parcel$export(module.exports, "ContentTypeRouteService", () => $e7005ccd0cc6da3c$export$c0c098175edcb2b5);
class $e7005ccd0cc6da3c$export$c0c098175edcb2b5 {
    dispose() {
        this.handlers = [];
        this.bufferedRoutes = [];
    }
    updateRoute(route) {
        if (this.handlers.length === 0) this.bufferedRoutes.push(route);
        else this.handlers.forEach((handler)=>handler(route));
    }
    onRouteChange(cb) {
        this.handlers.push(cb);
        if (this.bufferedRoutes.length) {
            const latestRoute = this.bufferedRoutes[this.bufferedRoutes.length - 1];
            this.updateRoute(latestRoute);
            this.bufferedRoutes.length = 0;
        }
    }
    constructor(){
        this.handlers = void 0;
        this.bufferedRoutes = void 0;
        this.handlers = [];
        this.bufferedRoutes = [];
    }
}
const $e7005ccd0cc6da3c$export$2d5d3a20c9be43ab = new $e7005ccd0cc6da3c$export$c0c098175edcb2b5();

});


parcelRegister("3nKIV", function(module, exports) {

$parcel$export(module.exports, "WhiteboardBridgeAPIBuilder", () => $44ee39597d9d1444$export$29dfbda8a2dd3fb2);

var $irVI7 = parcelRequire("irVI7");

var $j96gu = parcelRequire("j96gu");
var $hzClJ = parcelRequire("hzClJ");
var $ckYtV = parcelRequire("ckYtV");
var $lUzNY = parcelRequire("lUzNY");

var $6ZZJK = parcelRequire("6ZZJK");

var $1ggpj = parcelRequire("1ggpj");

var $etZHd = parcelRequire("etZHd");
class $44ee39597d9d1444$export$29dfbda8a2dd3fb2 {
    static with(ctx, services) {
        return new $44ee39597d9d1444$export$29dfbda8a2dd3fb2(ctx, services);
    }
    build() {
        return {
            /**
       * Methods part of the shared content types bridge API.
       * See @confluence/content-types-bridge for more details.
       */ confluenceAPI: {
                sidebar: {
                    showDetailsPanel: ()=>this.services.detailsPanelService.showPanel(),
                    hideDetailsPanel: ()=>this.services.detailsPanelService.hidePanel(),
                    showCommentsPanel: (threadId)=>this.services.commentService.showPanel(threadId),
                    hideCommentsPanel: ()=>this.services.commentService.hidePanel(),
                    onConfluenceSidebarStateChange: (callback)=>{
                        this.services.objectSidebarService.registerChangeObjectSidebarShownHandler(callback);
                    }
                },
                comments: {
                    registerOnReopenResolvedComment: (cb)=>{
                        this.services.commentService.registerOnReopenResolvedComment(cb);
                    },
                    registerOnResolveComment: (callback)=>this.services.commentService.registerOnResolveComment(callback),
                    onCommentsPanelSelectThread: (callback)=>this.services.commentService.registerSelectThreadHandler(callback),
                    selectCommentThread: (threadId)=>this.services.commentService.selectCommentThread(threadId),
                    registerOnDeleteComment: (callback)=>this.services.commentService.registerOnDeleteComment(callback),
                    registerOnUpdateComment: (callback)=>this.services.commentService.registerOnUpdateComment(callback),
                    triggerCommentPanelRefresh: ()=>this.services.commentService.triggerCommentPanelRefresh(),
                    registerOnUpdateReaction: (callback)=>this.services.commentService.registerOnUpdateReaction(callback)
                }
            },
            /**
       * Methods below here are not part of the shared content types bridge API and are specific to Whiteboards.
       * Please consider moving them to the shared content types bridge API if they are useful for other content types.
       * See @confluence/content-types-bridge for more details.
       */ goToContent: (id, query)=>{
                this.services.tokenService.resetToken();
                this.services.navigationService.goToContent(id, query);
            },
            goToContentCreate: ()=>{
                this.services.tokenService.resetToken();
                this.services.navigationService.goToContentCreate();
            },
            goToHome: ()=>{
                this.services.tokenService.resetToken();
                this.services.navigationService.goToHome();
            },
            goToContainer: (containerKey)=>{
                this.services.tokenService.resetToken();
                this.services.navigationService.goToContainer(containerKey);
            },
            onTokenInit: (cb)=>{
                this.services.tokenService.onTokenInit(cb);
            },
            onTokenChange: (cb)=>{
                this.services.tokenService.onTokenChange(cb);
            },
            preloadToken: (id)=>{
                this.services.tokenService.preloadToken(id).catch((_err)=>{});
            },
            getToken: (id)=>{
                return this.services.tokenService.getToken(id);
            },
            refreshToken: (id)=>{
                return this.services.tokenService.refreshToken(id).catch((_err)=>{});
            },
            onContainerInit: (cb)=>{
                this.services.containerService.onContainerInit(cb);
            },
            onContainerChange: (cb)=>{
                this.services.containerService.onContainerChange(cb);
            },
            onRouteChange: (cb)=>{
                this.services.routeService.onRouteChange(cb);
            },
            updateCollaborators: (collaborators)=>{
                // TODO - Move this service away from singleton pattern
                (0, $hzClJ.contentCollaboratorsService).updateActions(collaborators);
            },
            updateMainActions: (actions)=>{
                // TODO - Move this service away from singleton pattern
                (0, $ckYtV.contentMainActionsService).updateActions(actions);
            },
            updateBoardStatus: (status)=>{
                // TODO - Move this service away from singleton pattern
                (0, $j96gu.contentBoardStatusService).updateActions(status);
            },
            updateMoreActions: (items)=>{
                // TODO - Move this service away from singleton pattern
                (0, $lUzNY.contentMoreActionsService).updateActions(items);
            },
            onContentLoadSucceeded: (attributes)=>{
                const { experienceTracker: experienceTracker } = this.services;
                experienceTracker.succeed({
                    name: (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
                    attributes: attributes
                });
                (0, $etZHd.WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT).stop({
                    // TODO - look into this type issue
                    // @ts-ignore
                    customData: attributes
                });
            },
            onContentLoadFailed: (error, attributes)=>{
                const { experienceTracker: experienceTracker } = this.services;
                error.message = `fabric error: ${error.message}`;
                experienceTracker.stopOnError({
                    name: (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
                    attributes: attributes,
                    error: error
                });
                (0, $etZHd.WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT).cancel();
            },
            onContentLoadAborted: (abortReason, attributes)=>{
                const { experienceTracker: experienceTracker } = this.services;
                experienceTracker.abort({
                    name: (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
                    reason: abortReason || 'unknown from whiteboard bridge',
                    attributes: attributes
                });
                (0, $etZHd.WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT).cancel();
            },
            setNavigationLockoutState: (lockoutState)=>{
                this.services.navigationService.setLockoutState(lockoutState);
            },
            isFeatureActive: (...args)=>this.services.isFeatureActive(...args),
            platformFeatureFlagResolver: (flagKey)=>this.services.platformFeatureFlagResolver(flagKey),
            registerStartOnboardingCallback: (cb)=>{
                this.services.onboardingService.registerStartOnboardingCallback(cb);
            },
            registerOnOnboardingEndCallback: (cb)=>{
                this.services.onboardingService.registerOnOnboardingEndCallback(cb);
            },
            startOnboarding: (initialSpotlightScreen)=>{
                this.services.onboardingService.startOnboarding(initialSpotlightScreen);
            },
            onOnboardingReady: (eligibleScreens)=>{
                const { onboardingService: onboardingService } = this.services;
                const { hasStartedWhiteboardOnboardingSpotlight: isEligibleForBetaOnboarding, isEligibleForGAOnboarding: isEligibleForGAOnboarding, isNewWhiteboard: isNewWhiteboard } = onboardingService;
                if (eligibleScreens.includes('spotlight-templates')) {
                    if (!isEligibleForGAOnboarding && isEligibleForBetaOnboarding) onboardingService.startOnboarding();
                }
                if (eligibleScreens.includes('spotlight-sticky-viewer')) {
                    if (isEligibleForGAOnboarding && !isNewWhiteboard) onboardingService.startOnboarding('spotlight-sticky-viewer');
                }
                if (eligibleScreens.includes('spotlight-sticky-creator')) {
                    if (isEligibleForGAOnboarding && isNewWhiteboard) onboardingService.showTitleSpotlight();
                }
                if (eligibleScreens.includes('spotlight-exports')) onboardingService.showHeaderSpotlight();
                if (eligibleScreens.includes('spotlight-follow-cursor')) onboardingService.showCollaboratorSpotlight();
            },
            onOnboardingChange: (screen)=>{
                this.services.onboardingService.onOnboardingChange(screen);
            },
            onOnboardingEnd: (screen)=>{
                this.services.onboardingService.onOnboardingEnd(screen);
            },
            getOnboardingSkipped: ()=>{
                return this.services.onboardingService.onboardingSkipped;
            },
            setOnboardingSkipped: (skipped)=>{
                this.services.onboardingService.onboardingSkipped = skipped;
            },
            onOrgIdChange: (cb)=>{
                this.services.orgDataService.onOrgIdChange(cb);
            },
            getOrgId: ()=>{
                return this.services.orgDataService.getId();
            },
            showEditionUpgradeCTA: (props)=>{
                return this.services.editionUpgradeService.showUpgradeExperience(props);
            },
            closeEditionUpgradeCTA: ()=>{
                this.services.editionUpgradeService.closeUpgradeExperience();
            },
            sessionData: this.context.sessionData,
            isExternalShareRequest: this.context.isExternalShareRequest,
            onThemeChange: (cb)=>{
                this.services.themingService.onThemeChange(cb);
            },
            getCurrentTheme: ()=>{
                return this.services.themingService.getTheme();
            },
            showFeedbackCollectorModal: (props)=>{
                return this.services.feedbackService.showFeedbackCollector({
                    ...props,
                    feedbackSource: (0, $6ZZJK.FeedbackSource).WHITEBOARD,
                    contentType: (0, $1ggpj.ContentType).WHITEBOARD,
                    showTypeField: true
                });
            },
            closeFeedbackCollectorModal: ()=>{
                this.services.feedbackService.closeFeedbackModal();
            },
            onThemeLoaded: this.services.onThemeLoaded,
            registerOnReopenResolvedComment: (cb)=>{
                this.services.commentService.registerOnReopenResolvedComment(cb);
            },
            showWhiteboardInternalModal: (props)=>{
                return this.services.whiteboardInternalModalService.showModal(props);
            },
            closeWhiteboardInternalModal: ()=>{
                this.services.whiteboardInternalModalService.closeModal();
            },
            showFlag: (props)=>{
                this.services.flagService.showFlag(props);
            },
            hideFlag: (flagId)=>{
                this.services.flagService.hideFlag(flagId);
            },
            triggerIntegration: (...props)=>this.services.integrationService.triggerIntegration(...props),
            checkIntegration: (...props)=>this.services.integrationService.checkIntegration(...props),
            triggerEvent: (event)=>this.services.eventService.triggerEvent(event),
            hasEventHandler: (event)=>this.services.eventService.hasEventHandler(event),
            unregisterEventHandler: (event)=>this.services.eventService.unregisterEventHandler(event),
            registerEventHandler: (event, cb)=>{
                this.services.eventService.registerEventHandler(event, cb);
            },
            getVersionName: ()=>this.services.whiteboardsVersionHistoryService.getVersionName(),
            getPublicLink: ()=>this.services.publicLinkService.getPublicLink(),
            refetchPublicLink: ()=>this.services.publicLinkService.refetchPublicLink(),
            getContentCreatorId: ()=>this.services.contentDataService.getContentCreatorId(),
            toggleAIAgentRightPanel: ()=>this.services.aiAgentService.toggleWhiteboardAIAgentRightPanel(),
            updateSmartActions: (availableActions)=>this.services.aiAgentService.updateSmartActions(availableActions),
            registerAIAgentToggleHandler: (cb)=>this.services.aiAgentService.registerAIAgentToggleHandler(cb),
            toggleAIAgentDialog: (properties)=>this.services.aiAgentService.toggleAIAgentDialog(properties),
            getAIAgentDialogMountPoint: ()=>this.services.aiAgentService.getAIAgentDialogMountPoint(),
            onUpdateAIAgentDialogState: (cb)=>this.services.aiAgentService.onUpdateAIAgentDialogState(cb),
            updateAIAgentDialogState: (state)=>this.services.aiAgentService.updateAIAgentDialogState(state),
            onConfluenceSidebarStateChange: (cb)=>this.services.aiAgentService.onConfluenceSidebarStateChange(cb),
            showDetailsPanel: ()=>this.services.detailsPanelService.showPanel(),
            showCommentsPanel: ()=>this.services.commentService.showPanel(),
            onCommentsPanelSelectThread: (callback)=>this.services.commentService.registerSelectThreadHandler(callback),
            selectCommentThread: (threadId)=>this.services.commentService.selectCommentThread(threadId)
        };
    }
    constructor(ctx, services){
        this.context = void 0;
        this.services = void 0;
        this.context = ctx;
        this.services = services;
    }
}

});
parcelRegister("j96gu", function(module, exports) {

$parcel$export(module.exports, "contentBoardStatusService", () => $a9fb895ec6d62898$export$f5a70a5466fbb969);

var $ajKhM = parcelRequire("ajKhM");
const $a9fb895ec6d62898$export$f5a70a5466fbb969 = new (0, $ajKhM.ContentTypesActionsService)();

});
parcelRegister("ajKhM", function(module, exports) {

$parcel$export(module.exports, "ContentTypesActionsService", () => $c2d4c8ee0dd05cbe$export$abca6ba7b5fccda8);
class $c2d4c8ee0dd05cbe$export$abca6ba7b5fccda8 {
    dispose() {
        this.handlers.clear();
    }
    updateActions(data) {
        this.handlers.forEach((handler)=>handler(data));
    }
    onActionsUpdate(cb) {
        this.handlers.add(cb);
        return ()=>{
            this.handlers.delete(cb);
        };
    }
    constructor(){
        this.handlers = new Set();
    }
}

});


parcelRegister("hzClJ", function(module, exports) {

$parcel$export(module.exports, "contentCollaboratorsService", () => $45deabb561664896$export$3cfba92d89128616);

var $ajKhM = parcelRequire("ajKhM");
const $45deabb561664896$export$3cfba92d89128616 = new (0, $ajKhM.ContentTypesActionsService)();

});

parcelRegister("ckYtV", function(module, exports) {

$parcel$export(module.exports, "contentMainActionsService", () => $98c75de9c6816705$export$b14be44a1e8054b7);

var $ajKhM = parcelRequire("ajKhM");
const $98c75de9c6816705$export$b14be44a1e8054b7 = new (0, $ajKhM.ContentTypesActionsService)();

});

parcelRegister("lUzNY", function(module, exports) {

$parcel$export(module.exports, "contentMoreActionsService", () => $abbf907a8bf3bb4c$export$86e1b013192cc9f6);

var $ajKhM = parcelRequire("ajKhM");
const $abbf907a8bf3bb4c$export$86e1b013192cc9f6 = new (0, $ajKhM.ContentTypesActionsService)();

});

parcelRegister("etZHd", function(module, exports) {

$parcel$export(module.exports, "WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT", () => $0034a3d52d751861$export$b983f59c6b7b6e79);
$parcel$export(module.exports, "StartWhiteboardPageLoad", () => $0034a3d52d751861$export$3e752997513cc02b);

var $gwFzn = parcelRequire("gwFzn");

var $lSOAM = parcelRequire("lSOAM");
var $i3c1S = parcelRequire("i3c1S");
var $6VdZc = parcelRequire("6VdZc");
var $7fw2E = parcelRequire("7fw2E");
var $jX1qB = parcelRequire("jX1qB");
var $1UCmC = parcelRequire("1UCmC");

var $5qUgM = parcelRequire("5qUgM");

var $aWrnw = parcelRequire("aWrnw");

var $8w1c1 = parcelRequire("8w1c1");

var $1q7H7 = parcelRequire("1q7H7");
const $0034a3d52d751861$export$b983f59c6b7b6e79 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $0034a3d52d751861$var$NOOP = ()=>{
// This is intentional
};
const $0034a3d52d751861$export$2d5e2a82ee58820b = ({ isInitialLoad: isInitialLoad })=>{
    const segments = [
        $0034a3d52d751861$export$b983f59c6b7b6e79,
        (0, $5qUgM.WHITEBOARD_HEADER_SEGMENT_METRIC)
    ];
    if (isInitialLoad) segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC), (0, $1q7H7.PAGE_TREE_METRIC));
    return segments;
};
const $0034a3d52d751861$export$3e752997513cc02b = ({ contentId: contentId })=>{
    const pageLoadMetricRef = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        const initialLoad = (0, $6VdZc.isInitial)();
        const expectedPageSegments = $0034a3d52d751861$export$2d5e2a82ee58820b({
            isInitialLoad: initialLoad
        });
        const untilPageSegments = expectedPageSegments.map((segment)=>({
                experience: segment,
                useFmpAsUntilStopTime: false
            }));
        pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
            key: (0, $1UCmC.WHITEBOARD_VIEW_PAGE_KEY),
            timings: (0, $i3c1S.getWaterfallTimings)(expectedPageSegments),
            include: expectedPageSegments,
            until: untilPageSegments
        });
        if (!initialLoad) {
            // Make sure all segments are re-started and not currently
            // marked as finished from a previous navigation.
            // Ensure any nested segments are restarted first. If you don't
            // do this with nested segments, you'll see some SPA-navigation
            // perf metrics not get fired (header & main page). You'll also
            // see errors like this if you enable platform browser-metrics
            // package debugging:
            // "BM log:  metric content-types-header has been stopped
            // with stopTime lower than startTime"
            (0, $5qUgM.WHITEBOARD_HEADER_SUBSEGMENT_METRICS).forEach((m)=>m.startFromPageLoad());
            // then restart the top-level segments
            expectedPageSegments.forEach((m)=>m.startFromPageLoad());
        }
        pageLoadMetricRef.current.startPageLoad({
            isInitial: initialLoad
        });
        pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $0034a3d52d751861$var$NOOP);
        // Cleanup on unmount or when dependencies have changed
        return ()=>{
            pageLoadMetricRef.current?.cancel();
        };
    }, [
        contentId
    ]);
    return null;
};

});


parcelRegister("7LhUs", function(module, exports) {

$parcel$export(module.exports, "getWhiteboardURLBase", () => $3842f3195c8d3bde$export$73c10f15a05d264d);
$parcel$export(module.exports, "getWhiteboardURL", () => $3842f3195c8d3bde$export$66374736c28fcdd);

var $hQnHK = parcelRequire("hQnHK");
const $3842f3195c8d3bde$export$73c10f15a05d264d = (parentProduct)=>{
    // When parent product is provided, the base canvas html need to load from canvas-server
    // to get the correct CSP header
    return parentProduct ? '/canvas-embed' : '/whiteboards';
};
const $3842f3195c8d3bde$var$queryParams = (params)=>{
    const paramsString = `${params}`;
    return paramsString ? `?${paramsString}` : '';
};
const $3842f3195c8d3bde$export$66374736c28fcdd = (referenceId, { openTemplatePicker: openTemplatePicker, insertTemplateWithKey: insertTemplateWithKey, headless: headless, canvasRelaySpot: canvasRelaySpot, canvasServerSpot: canvasServerSpot, whiteboardLocale: whiteboardLocale, whiteboardLinkedObject: whiteboardLinkedObject, initialTheme: initialTheme, openJiraImportTool: openJiraImportTool, cloudId: cloudId, projectUuid: projectUuid, parentProduct: parentProduct, parentDomain: parentDomain, createdAt: createdAt, focusedCommentId: focusedCommentId, replyToComment: replyToComment, whiteboardVersionId: whiteboardVersionId, createdFromSlug: createdFromSlug, bifrostVersion: bifrostVersion, visualRefresh: visualRefresh, openMiroImportTool: openMiroImportTool } = {})=>{
    const rawInputParams = {
        [(0, $hQnHK.HEADLESS_QUERY_PARAM)]: headless,
        [(0, $hQnHK.SERVER_SPOT_PARAM)]: canvasServerSpot,
        [(0, $hQnHK.RELAY_SPOT_PARAM)]: canvasRelaySpot,
        [(0, $hQnHK.WHITEBOARD_LOCALE)]: whiteboardLocale,
        [(0, $hQnHK.WHITEBOARD_LINKED_OBJECT)]: whiteboardLinkedObject,
        [(0, $hQnHK.INITIAL_THEME_PARAM)]: initialTheme,
        [(0, $hQnHK.PARENT_PRODUCT_QUERY_PARAM)]: parentProduct,
        [(0, $hQnHK.PARENT_DOMAIN_QUERY_PARAM)]: parentDomain,
        [(0, $hQnHK.EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM)]: createdAt,
        [(0, $hQnHK.FOCUSED_COMMENT_ID)]: focusedCommentId,
        [(0, $hQnHK.REPLY_TO_COMMENT)]: replyToComment
    };
    const inputParams = Object.entries(rawInputParams).filter(([, v])=>!!v).map(([k, v])=>[
            k,
            String(v)
        ]);
    const params = new URLSearchParams(inputParams);
    if (bifrostVersion) params.set((0, $hQnHK.BIFROST_OVERRIDE_PARAM), bifrostVersion);
    if (!referenceId) return `/whiteboard/loading${$3842f3195c8d3bde$var$queryParams(params)}`;
    openTemplatePicker !== undefined && params.set((0, $hQnHK.TEMPLATE_PICKER_QUERY_PARAM), openTemplatePicker ? 'true' : 'false');
    openJiraImportTool !== undefined && params.set((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM), openJiraImportTool ? 'true' : 'false');
    openMiroImportTool !== undefined && params.set((0, $hQnHK.MIRO_IMPORT_TOOL_QUERY_PARAM), openMiroImportTool ? 'true' : 'false');
    cloudId && params.set((0, $hQnHK.CLOUD_ID), cloudId);
    projectUuid && params.set((0, $hQnHK.PROJECT_UUID), projectUuid);
    insertTemplateWithKey && params.set((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM), insertTemplateWithKey);
    whiteboardVersionId && params.set((0, $hQnHK.WHITEBOARD_VERSION_ID), whiteboardVersionId);
    if (createdFromSlug) params.set((0, $hQnHK.CREATED_FROM_SLUG), createdFromSlug);
    if (visualRefresh) params.set((0, $hQnHK.VISUAL_REFRESH_PARAM), visualRefresh ? 'true' : 'false');
    return `/whiteboard/${referenceId}${$3842f3195c8d3bde$var$queryParams(params)}`;
};

});

parcelRegister("iaHf1", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardQueryParamState", () => $29f80e64f93e0226$export$4d298f046c5f9a7d);

var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");
const $29f80e64f93e0226$export$4d298f046c5f9a7d = (contentId, param, clearParam = true)=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const paramValue = getQueryParams()?.[param];
    const whiteboardParam = (0, $gwFzn.useRef)(paramValue);
    const prevContentId = (0, $gwFzn.useRef)(contentId);
    if (prevContentId.current !== contentId) whiteboardParam.current = undefined;
    if (paramValue) whiteboardParam.current = paramValue;
    if (paramValue && clearParam) setQueryParams({
        [param]: undefined
    }, true);
    prevContentId.current = contentId;
    return whiteboardParam.current;
};

});

parcelRegister("bLB3t", function(module, exports) {

$parcel$export(module.exports, "useContainerService", () => $8723dc70ada45736$export$c58860b7e114e292);

var $gwFzn = parcelRequire("gwFzn");

var $lGpsr = parcelRequire("lGpsr");

var $1NBp8 = parcelRequire("1NBp8");
const $8723dc70ada45736$export$c58860b7e114e292 = (space, spaceKey)=>{
    const [containerService] = (0, $gwFzn.useState)(()=>new (0, $lGpsr.ContentTypeContainerService)());
    // Update the current container whenever the space changes
    (0, $gwFzn.useEffect)(()=>{
        if (!space.name || !space.iconPath) return;
        containerService.updateContainer({
            key: spaceKey,
            name: space.name,
            iconPath: `${(0, $1NBp8.WIKI).pattern}/${space.iconPath}`
        });
        return ()=>containerService.resetContainer();
    }, [
        containerService,
        space.name,
        spaceKey,
        space.iconPath
    ]);
    return containerService;
};

});
parcelRegister("lGpsr", function(module, exports) {

$parcel$export(module.exports, "ContentTypeContainerService", () => $a40a6cb82586b6a8$export$b620178b175a20b9);
const $a40a6cb82586b6a8$var$emptyContainer = {
    key: '',
    name: '',
    iconPath: ''
};
class $a40a6cb82586b6a8$export$b620178b175a20b9 {
    dispose() {
        this.handlers = [];
        this.container = $a40a6cb82586b6a8$var$emptyContainer;
    }
    constructor(){
        this.handlers = void 0;
        this.container = void 0;
        /**
     * A method called on every change in container.
     * @returns <void> Calls any associated handlers.
     */ this.updateContainer = (container)=>{
            this.container = container;
            this.handlers.forEach((handler)=>handler(container));
        };
        /**
     * A method called on unmounting of a whiteboard frame.
     * @returns <void> Calls any associated handlers.
     */ this.resetContainer = ()=>{
            this.container = $a40a6cb82586b6a8$var$emptyContainer;
        };
        /**
     * Setup listeners for container changes.
     * @description Called everytime the container updates.
     */ this.onContainerChange = (cb)=>{
            this.handlers.push(cb);
        };
        /**
     * Setup listeners for container initialisation.
     * @description Called once on app init.
     */ this.onContainerInit = (cb)=>{
            cb(this.container);
        };
        this.handlers = [];
        this.container = $a40a6cb82586b6a8$var$emptyContainer;
    }
}
const $a40a6cb82586b6a8$export$f00286a8669021c9 = new $a40a6cb82586b6a8$export$b620178b175a20b9();

});


parcelRegister("k6t2p", function(module, exports) {

$parcel$export(module.exports, "useOrgDataService", () => $aa2a411f867f3dd3$export$4b7a04e4009c7f85);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $lqNxA = parcelRequire("lqNxA");
const $aa2a411f867f3dd3$export$4b7a04e4009c7f85 = ()=>{
    const [orgDataService] = (0, $gwFzn.useState)(()=>new (0, $lqNxA.WhiteboardOrgDataService)());
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    (0, $gwFzn.useEffect)(()=>{
        if (orgId) orgDataService.updateOrgId(orgId);
    }, [
        orgDataService,
        orgId
    ]);
    return orgDataService;
};

});
parcelRegister("lqNxA", function(module, exports) {

$parcel$export(module.exports, "WhiteboardOrgDataService", () => $1f11813e779beb5c$export$6c3f428f5c8efe05);
class $1f11813e779beb5c$export$6c3f428f5c8efe05 {
    dispose() {
        this.handlers.clear();
    }
    updateOrgId(id) {
        this.id = id;
        this.handlers.forEach((handler)=>handler(id));
    }
    onOrgIdChange(cb) {
        this.handlers.add(cb);
        return ()=>{
            this.handlers.delete(cb);
        };
    }
    getId() {
        return this.id;
    }
    constructor(){
        this.handlers = new Set();
        this.id = undefined;
    }
}

});


parcelRegister("6attE", function(module, exports) {

$parcel$export(module.exports, "useTokenService", () => $98eb6766d8546971$export$403c2a860d415c5b);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $6S5EB = parcelRequire("6S5EB");

var $flE5X = parcelRequire("flE5X");

var $7mpOv = parcelRequire("7mpOv");

var $P7iy7 = parcelRequire("P7iy7");
const $98eb6766d8546971$export$403c2a860d415c5b = ({ tenantId: tenantId, space: space, referenceId: referenceId, contentId: contentId, shareToken: shareToken, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, refetch: refetch, documentType: documentType = 'whiteboard', onPermissionChange: onPermissionChange })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [tokenService] = (0, $gwFzn.useState)(()=>new (0, $P7iy7.WhiteboardTokenService)(documentType));
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    (0, $gwFzn.useEffect)(()=>{
        tokenService.onInvalidToken(()=>{
            refetch?.();
        });
        tokenService.onTokenChange((token)=>{
            if (onPermissionChange) {
                const permissions = tokenService.getPermissions(token);
                onPermissionChange(permissions);
            }
        });
        tokenService.onTokenLoadError((error)=>{
            if ((0, $dIouf.isUnauthorizedError)(error)) refetch?.();
            else if ((0, $flE5X.containsNoNetworkError)(error)) experienceTracker.abort({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                reason: 'Network error while fetching token'
            });
            else if ((0, $dIouf.isNotFoundError)(error)) experienceTracker.abort({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                reason: 'Requested content not found while fetching token'
            });
            else experienceTracker.fail({
                name: (0, $irVI7.WHITEBOARD_EXPERIENCE),
                error: error
            });
        });
    }, [
        tokenService,
        refetch,
        experienceTracker,
        onPermissionChange
    ]);
    // Update the current token whenever the space or contentId changes
    (0, $gwFzn.useEffect)(()=>{
        if (!space.id) return;
        tokenService.setContext({
            spaceId: space.id,
            tenantId: tenantId,
            contentId: contentId,
            confluenceEdition: edition || '',
            isExternal: isExternal,
            shareToken: shareToken,
            dataSecurityPolicyPageExport: dataSecurityPolicyPageExport,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
        if (referenceId) tokenService.updateToken(referenceId).catch(()=>{
        // handled by the `onTokenLoadError` function defined in the useEffect above this
        });
        return ()=>tokenService.resetToken();
    }, [
        tokenService,
        tenantId,
        space.id,
        referenceId,
        contentId,
        edition,
        shareToken,
        isExternal,
        dataSecurityPolicyPageExport,
        isAIEnabledForContent,
        isRovoEnabledForContent
    ]);
    return tokenService;
};

});
parcelRegister("P7iy7", function(module, exports) {

$parcel$export(module.exports, "WhiteboardTokenService", () => $836053ad975c4b64$export$b957651e6c38f607);

var $fVAS9 = parcelRequire("fVAS9");

var $jUSbx = parcelRequire("jUSbx");

var $agiQB = parcelRequire("agiQB");

var $iFhxN = parcelRequire("iFhxN");

var $hp2SH = parcelRequire("hp2SH");

var $1AV5C = parcelRequire("1AV5C");

var $j5j6W = parcelRequire("j5j6W");

var $i9cO2 = parcelRequire("i9cO2");
const $836053ad975c4b64$var$emptyContext = ()=>({
        spaceId: '',
        tenantId: '',
        contentId: '',
        confluenceEdition: '',
        isExternal: false,
        shareToken: '',
        dataSecurityPolicyPageExport: null,
        isAIEnabledForContent: false,
        isRovoEnabledForContent: false
    });
/**
 * Used to refer to the 'home' view.
 */ const $836053ad975c4b64$var$FALLBACK_HOME_KEY = 'root';
/**
 * Used to refer to the 'create' view.
 */ const $836053ad975c4b64$var$FALLBACK_CREATE_KEY = 'create';
/**
 * Set to a value a little below the server timeout to account for networking delays and retries.
 */ const $836053ad975c4b64$var$EXPIRY_TIME_MILLSECONDS = 540000;
/**
 * Note: This is currently a module scope value as we recreate the token service on SPA transitions. This would cause us to fetch cached tokens on the first transition to a board which would result in a token expiry errors.
 * @see {@link https://atlassian.slack.com/archives/C027MLUFSFN/p1717038827909519?thread_ts=1716372417.294799&cid=C027MLUFSFN}
 */ let $836053ad975c4b64$var$isFirstLoad = true;
const $836053ad975c4b64$var$allowedDocumentTypes = [
    'whiteboard',
    'database'
];
class $836053ad975c4b64$export$b957651e6c38f607 {
    dispose() {
        this.handlers = [];
        this.context = $836053ad975c4b64$var$emptyContext();
        this.token = undefined;
        this.cache = new Map();
    }
    /**
   * Sets the context of the token service.
   * @description Used to fetch tokens pinned to space & site.
   */ setContext({ spaceId: spaceId, tenantId: tenantId, contentId: contentId, confluenceEdition: confluenceEdition, isExternal: isExternal, shareToken: shareToken, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent }) {
        this.context.spaceId = spaceId;
        this.context.tenantId = tenantId;
        this.context.contentId = contentId;
        this.context.confluenceEdition = confluenceEdition;
        this.context.isExternal = isExternal;
        this.context.shareToken = shareToken;
        this.context.dataSecurityPolicyPageExport = dataSecurityPolicyPageExport;
        this.context.isAIEnabledForContent = isAIEnabledForContent;
        this.context.isRovoEnabledForContent = isRovoEnabledForContent;
    }
    /**
   * @description Method for taking an encoded access token and determining whether or
   * not it has read permissions for the document
   * @returns boolean value indicating whether the provided token has sufficient
   * document permissions or not
   */ isValidToken(token, key) {
        if (token?.accessToken) {
            /**
       * If on home or create routes, existence of a token is enough to ensure
       * the user has permission to take the provided action (view home or create).
       */ if (key === $836053ad975c4b64$var$FALLBACK_HOME_KEY) return true;
            if (key === $836053ad975c4b64$var$FALLBACK_CREATE_KEY) return true;
            const decodedAccessToken = (0, $fVAS9.default)(token.accessToken);
            const documentARI = Object.keys(decodedAccessToken.access).find((ari)=>{
                return (0, $agiQB.CanvasBoardAri).check(ari) || (0, $iFhxN.CanvasDatabaseAri).check(ari);
            });
            if (documentARI) {
                const documentAccess = decodedAccessToken.access[documentARI];
                if (documentAccess && documentAccess.includes('read')) return true;
            }
        }
        return false;
    }
    /**
   * @description Method for taking an encoded access token and returning the permissions
   * @returns an empty array if no claims exist. An array with [read] for read only or [read, write] if editable
   */ getPermissions(token) {
        if (token?.accessToken) {
            const decodedAccessToken = (0, $fVAS9.default)(token.accessToken);
            const documentARI = Object.keys(decodedAccessToken.access).find((ari)=>{
                return (0, $agiQB.CanvasBoardAri).check(ari) || (0, $iFhxN.CanvasDatabaseAri).check(ari);
            });
            if (documentARI) return decodedAccessToken.access[documentARI];
        }
        return [];
    }
    /**
   * Loads a token by reaching out to a specific token URL.
   * @param referenceId
   */ async loadToken(referenceId) {
        // We cannot fetch a token without a context.
        // Hence, we default to 'empty'.
        if (!this.hasContext()) return undefined;
        const handleError = (err)=>{
            this.tokenErrorHandler(err);
            return undefined;
        };
        const { spaceId: spaceId, tenantId: tenantId, contentId: contentId, shareToken: shareToken, isExternal: isExternal, dataSecurityPolicyPageExport: dataSecurityPolicyPageExport, isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = this.context;
        try {
            const tokenPromise = isExternal && shareToken ? await $836053ad975c4b64$var$fetchExternalTokenDataByGraphQL(shareToken) : await $836053ad975c4b64$var$fetchTokenDataByGraphQL(contentId, $836053ad975c4b64$var$isFirstLoad);
            $836053ad975c4b64$var$isFirstLoad = false;
            const { accessToken: accessToken, mediaToken: mediaToken, mediaBaseUrl: mediaBaseUrl, whiteboardEntitlements: whiteboardEntitlements } = tokenPromise;
            if (!accessToken || !mediaToken || !mediaBaseUrl) {
                const missingItems = [
                    ...!accessToken ? [
                        'accessToken'
                    ] : [],
                    ...!mediaToken ? [
                        'mediaToken'
                    ] : [],
                    ...!mediaBaseUrl ? [
                        'mediaBaseUrl'
                    ] : []
                ];
                const missingTokenError = new Error(`missing token data for: ${missingItems.join(', ')}`);
                return handleError(missingTokenError);
            }
            const containerAri = (0, $jUSbx.ConfluenceSpaceAri).create({
                siteId: tenantId,
                spaceId: spaceId
            });
            const boardAri = referenceId ? this.getBoardAri(referenceId, tenantId) : '';
            const features = {
                whiteboards: {
                    ...whiteboardEntitlements.whiteboards,
                    aiGenerate: {
                        isEntitled: isAIEnabledForContent
                    },
                    aiClustering: {
                        isEntitled: isAIEnabledForContent
                    },
                    aiTeammate: {
                        isEntitled: isAIEnabledForContent && isRovoEnabledForContent
                    },
                    aiSmartButton: {
                        isEntitled: isAIEnabledForContent && isRovoEnabledForContent
                    }
                }
            };
            const policies = dataSecurityPolicyPageExport != null ? {
                policies: {
                    dataSecurityPolicy: {
                        pageExport: dataSecurityPolicyPageExport
                    }
                }
            } : {};
            return {
                container: containerAri.toString(),
                board: boardAri.toString(),
                accessToken: accessToken,
                mediaToken: mediaToken,
                mediaBaseUrl: mediaBaseUrl,
                mediaCollectionId: contentId,
                features: features,
                edition: this.context.confluenceEdition,
                ...policies
            };
        } catch (err) {
            return handleError(err);
        }
    }
    /**
   * Checks if there is enough data in {@link context} to fetch a token.
   */ hasContext() {
        const hasTenantId = this.context.tenantId.length > 0;
        const hasSpaceId = this.context.spaceId.length > 0;
        const hasContentId = this.context.contentId.length > 0;
        const hasConfluenceEdition = Boolean(this.context.confluenceEdition);
        return hasTenantId && hasSpaceId && hasContentId && hasConfluenceEdition;
    }
    /**
   * Checks if the {@link token} has expected data in it.
   */ hasToken(token) {
        return Boolean(token && token.accessToken && token.container);
    }
    constructor(documentType){
        this.documentType = void 0;
        this.handlers = void 0;
        this.context = void 0;
        this.token = void 0;
        this.cache = void 0;
        this.invalidTokenHandler = void 0;
        // @ts-ignore
        this.tokenErrorHandler = void 0;
        /**
     * A method called on every route transition on whiteboards.
     * @returns <void> Sets a fresh token with encoded permissions.
     */ this.updateToken = async (referenceId)=>{
            const token = await this.preloadToken(referenceId);
            this.token = token;
            this.handlers.forEach((handler)=>handler(token));
        };
        /**
     * A method called on every route transition on whiteboards to empty the existing token.
     * @returns <void> Sets an empty token with encoded permissions.
     */ this.resetToken = ()=>{
            this.token = undefined;
            this.context = $836053ad975c4b64$var$emptyContext();
            this.handlers.forEach((handler)=>handler(undefined));
        };
        /**
     * Setup listeners for token changes.
     * @description Called everytime the token updates.
     */ this.onTokenChange = (cb)=>{
            this.handlers.push(cb);
        };
        /**
     * Setup listener for invalid token
     * @description Called within preloadToken if the token is lacking sufficient whiteboard permissions.
     */ this.onInvalidToken = (cb)=>{
            this.invalidTokenHandler = cb;
        };
        /**
     * Setup listener for a token error
     * @description Called within loadToken's catch in case there is an error loading the token
     */ // @ts-ignore
        this.onTokenLoadError = (cb)=>{
            this.tokenErrorHandler = cb;
        };
        /**
     * Setup listeners for token initialisation.
     * @description Called once at the start of the lifetime of the whiteboard frame.
     */ this.onTokenInit = (cb)=>{
            cb(this.token);
        };
        this.getHashKey = (id)=>{
            return (0, $1AV5C.hashData)(JSON.stringify({
                id: id,
                ...this.context
            }));
        };
        /**
     * Starts preloading a token, and stores the result in {@link cache}.
     * @description Implements a mutex by keeping one promise per content id.
     */ this.preloadToken = (id)=>{
            const key = id ? this.getHashKey(id) : $836053ad975c4b64$var$FALLBACK_HOME_KEY;
            const entry = this.cache.get(key);
            const now = Date.now();
            const fetching = entry?.promise;
            const resolved = entry?.resolved;
            const expired = Boolean(entry?.expiresAt && now >= entry.expiresAt);
            if (fetching) {
                if (!resolved) return fetching;
                if (!expired) return fetching;
                else this.cache.delete(key);
            }
            const promise = this.loadToken(id);
            this.cache.set(key, {
                promise: promise,
                resolved: false
            });
            promise.then((token)=>{
                // Do not hold onto empty tokens
                if (!this.hasToken(token)) {
                    this.cache.delete(key);
                    return;
                }
                if (!this.isValidToken(token, key)) {
                    this.cache.delete(key);
                    this.invalidTokenHandler();
                    return;
                }
                this.cache.set(key, {
                    promise: promise,
                    resolved: true,
                    expiresAt: now + $836053ad975c4b64$var$EXPIRY_TIME_MILLSECONDS
                });
            }).catch((_err)=>{
                // Do not hold onto tokens which failed to be fetched
                this.cache.delete(key);
            });
            return promise;
        };
        /**
     * Gives the consumer the existing token for a route, or starts fetching one.
     * @description Uses the same mutex implemented in {@link preloadToken}
     */ this.getToken = (id)=>{
            return this.preloadToken(id);
        };
        /**
     * A method for forcing refresh of a token.
     * @description Used when permissions change on a whiteboard, forcing users
     * to refetch a new token.
     * @description Delegates to {@link revokeToken} to revoke the current token.
     * @returns <void>
     */ this.refreshToken = async (id)=>{
            this.revokeToken(id);
            await this.updateToken(id);
        };
        /**
     * A method for revoking a token.
     * @description Used when permissions change on a whiteboard, forcing users
     * to refetch a new token.
     * @returns <void>
     */ this.revokeToken = (id)=>{
            const key = id ? this.getHashKey(id) : $836053ad975c4b64$var$FALLBACK_HOME_KEY;
            this.token = undefined;
            this.cache.delete(key);
            this.handlers.forEach((handler)=>handler(undefined));
        };
        /**
     * A method for getting the board ari.
     * @description Used to determine the board ari for a given reference id and document type.
     * @param referenceId
     * @param tenantId
     * @private
     */ this.getBoardAri = (referenceId, tenantId)=>{
            return this.documentType == 'whiteboard' ? (0, $agiQB.CanvasBoardAri).create({
                siteId: tenantId,
                boardId: referenceId
            }) : (0, $iFhxN.CanvasDatabaseAri).create({
                siteId: tenantId,
                databaseId: referenceId
            });
        };
        this.documentType = documentType;
        this.handlers = [];
        this.context = $836053ad975c4b64$var$emptyContext();
        this.token = undefined;
        this.cache = new Map();
        this.invalidTokenHandler = ()=>{};
        this.tokenErrorHandler = ()=>{};
    }
}
const $836053ad975c4b64$var$fetchTokenDataByGraphQL = async (contentId, useCache = false)=>{
    const tokenQuery = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $j5j6W.WhiteboardTokenQuery),
        variables: {
            contentId: contentId
        },
        context: {
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        },
        fetchPolicy: useCache ? 'cache-first' : 'no-cache'
    });
    const accessToken = tokenQuery?.data?.canvasToken?.token;
    const readOnlyMediaToken = tokenQuery?.data?.contentMediaSession?.accessTokens?.readOnlyToken?.value;
    const readWriteMediaToken = tokenQuery?.data?.contentMediaSession?.accessTokens?.readWriteToken?.value;
    const mediaBaseUrl = tokenQuery?.data?.contentMediaSession?.configuration?.fileStoreUrl;
    const whiteboardEntitlements = tokenQuery?.data?.entitlements?.whiteboardFeatures;
    return {
        accessToken: accessToken,
        mediaToken: readWriteMediaToken || readOnlyMediaToken,
        mediaBaseUrl: mediaBaseUrl,
        whiteboardEntitlements: {
            whiteboards: whiteboardEntitlements
        }
    };
};
const $836053ad975c4b64$var$fetchExternalTokenDataByGraphQL = async (shareToken)=>{
    const tokenQuery = await (0, $hp2SH.getApolloClient)().query({
        query: (0, $i9cO2.ExternalWhiteboardTokenQuery),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true,
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        },
        fetchPolicy: 'no-cache'
    });
    const data = tokenQuery?.data;
    const accessToken = data?.externalCanvasToken?.token;
    const readOnlyMediaToken = data?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value;
    const readWriteMediaToken = data?.externalContentMediaSession?.accessTokens?.readWriteToken?.value;
    const mediaBaseUrl = tokenQuery?.data?.externalContentMediaSession?.configuration?.fileStoreUrl;
    const whiteboardEntitlements = data?.entitlements?.whiteboardFeatures;
    return {
        accessToken: accessToken,
        mediaToken: readWriteMediaToken || readOnlyMediaToken,
        mediaBaseUrl: mediaBaseUrl,
        whiteboardEntitlements: {
            whiteboards: whiteboardEntitlements
        }
    };
};

});
parcelRegister("agiQB", function(module, exports) {

$parcel$export(module.exports, "CanvasBoardAri", () => $778a04b0bd382540$export$4207164a16ce22a0);

var $ihLTT = parcelRequire("ihLTT");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/canvas/board/manifest.ts
var $778a04b0bd382540$var$canvasBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $ihLTT.CanvasBoardAriResourceOwner),
    resourceType: (0, $ihLTT.CanvasBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/canvas/board/index.ts
var $778a04b0bd382540$export$4207164a16ce22a0 = class _CanvasBoardAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $778a04b0bd382540$var$canvasBoardAriStaticOpts.qualifier,
            platformQualifier: $778a04b0bd382540$var$canvasBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $778a04b0bd382540$var$canvasBoardAriStaticOpts.resourceOwner,
            resourceType: $778a04b0bd382540$var$canvasBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $778a04b0bd382540$var$canvasBoardAriStaticOpts);
        return new _CanvasBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $778a04b0bd382540$var$canvasBoardAriStaticOpts);
        return new _CanvasBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
};

});
parcelRegister("ihLTT", function(module, exports) {

$parcel$export(module.exports, "CanvasBoardAriResourceOwner", () => $d4fef88e9f6ff4d9$export$1739c82bfccbe497);
$parcel$export(module.exports, "CanvasBoardAriResourceType", () => $d4fef88e9f6ff4d9$export$94992737b5e17ca5);
// src/canvas/board/types.ts
var $d4fef88e9f6ff4d9$export$1739c82bfccbe497 = "canvas", $d4fef88e9f6ff4d9$export$94992737b5e17ca5 = "board";

});


parcelRegister("iFhxN", function(module, exports) {

$parcel$export(module.exports, "CanvasDatabaseAri", () => $d969aa3b9e6583ba$export$b5af0e69d7a83a9e);

var $u9XDy = parcelRequire("u9XDy");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/canvas/database/manifest.ts
var $d969aa3b9e6583ba$var$canvasDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $u9XDy.CanvasDatabaseAriResourceOwner),
    resourceType: (0, $u9XDy.CanvasDatabaseAriResourceType),
    resourceIdSlug: "{databaseId}",
    resourceIdSegmentFormats: {
        databaseId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/canvas/database/index.ts
var $d969aa3b9e6583ba$export$b5af0e69d7a83a9e = class _CanvasDatabaseAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d969aa3b9e6583ba$var$canvasDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d969aa3b9e6583ba$var$canvasDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d969aa3b9e6583ba$var$canvasDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d969aa3b9e6583ba$var$canvasDatabaseAriStaticOpts.resourceType,
            resourceId: `${opts.databaseId}`,
            resourceIdSegmentValues: {
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $d969aa3b9e6583ba$var$canvasDatabaseAriStaticOpts);
        return new _CanvasDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $d969aa3b9e6583ba$var$canvasDatabaseAriStaticOpts);
        return new _CanvasDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};

});
parcelRegister("u9XDy", function(module, exports) {

$parcel$export(module.exports, "CanvasDatabaseAriResourceOwner", () => $05aa877b3b80a777$export$21d39021bd86ec6f);
$parcel$export(module.exports, "CanvasDatabaseAriResourceType", () => $05aa877b3b80a777$export$e7fab7e0dfc50566);
// src/canvas/database/types.ts
var $05aa877b3b80a777$export$21d39021bd86ec6f = "canvas", $05aa877b3b80a777$export$e7fab7e0dfc50566 = "database";

});


parcelRegister("j5j6W", function(module, exports) {

$parcel$export(module.exports, "WhiteboardTokenQuery", () => $68bcf5e0dd294dcb$export$7af3c7e5c4c08291);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $68bcf5e0dd294dcb$export$7af3c7e5c4c08291 = (0, $d2LG0.default)`query WhiteboardTokenQuery($contentId:ID!){canvasToken(contentId:$contentId){token}contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value}readWriteToken{value}}configuration{fileStoreUrl}}entitlements{whiteboardFeatures{smartConnectors{isEntitled}smartSections{isEntitled}}}}`;

});

parcelRegister("i9cO2", function(module, exports) {

$parcel$export(module.exports, "ExternalWhiteboardTokenQuery", () => $69a092ebfa4d47df$export$435620ef3a755b60);

var $d2LG0 = parcelRequire("d2LG0");
const $69a092ebfa4d47df$export$435620ef3a755b60 = (0, $d2LG0.default)`query ExternalWhiteboardTokenQuery($shareToken:String!){externalCanvasToken(shareToken:$shareToken){token}externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value}readWriteToken{value}}configuration{fileStoreUrl}}entitlements{whiteboardFeatures{smartConnectors{isEntitled}smartSections{isEntitled}}}}`;

});



parcelRegister("5wU3V", function(module, exports) {

$parcel$export(module.exports, "useThemingService", () => $3bf16ca42f9e188b$export$2bcebcd0d350d772);

var $gwFzn = parcelRequire("gwFzn");

var $j6S25 = parcelRequire("j6S25");
var $cOrQJ = parcelRequire("cOrQJ");

var $cMmuo = parcelRequire("cMmuo");

var $7J5Uc = parcelRequire("7J5Uc");

var $cu6eG = parcelRequire("cu6eG");
const $3bf16ca42f9e188b$export$2bcebcd0d350d772 = ()=>{
    const appliedTheme = (0, $cOrQJ.default)();
    const [{ isInitialized: themingInitialized }] = (0, $7J5Uc.useThemingState)();
    const effectiveThemeSerialized = (0, $gwFzn.useMemo)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        const theme = isSSR || !themingInitialized ? (0, $cMmuo.getSavedThemeLocal)() : appliedTheme;
        return theme ? (0, $j6S25.themeObjectToString)(theme) : undefined;
    }, [
        themingInitialized,
        appliedTheme
    ]);
    // Value should always reflect the originally calculated value
    const initialThemeSerialized = (0, $gwFzn.useRef)(effectiveThemeSerialized);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            (0, $cu6eG.whiteboardThemingService).dispose();
        };
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (appliedTheme) (0, $cu6eG.whiteboardThemingService).updateTheme(appliedTheme);
    }, [
        appliedTheme
    ]);
    return {
        themingService: (0, $cu6eG.whiteboardThemingService),
        initialThemeSerialized: initialThemeSerialized.current
    };
};

});
parcelRegister("cu6eG", function(module, exports) {

$parcel$export(module.exports, "whiteboardThemingService", () => $dc00d7996d97ffde$export$add900538e5d49b8);
class $dc00d7996d97ffde$export$9c1453fd5233c0aa {
    dispose() {
        this.handlers.clear();
    }
    updateTheme(theme) {
        this.theme = theme;
        this.handlers.forEach((handler)=>handler(theme));
    }
    onThemeChange(cb) {
        this.handlers.add(cb);
        return ()=>{
            this.handlers.delete(cb);
        };
    }
    getTheme() {
        return this.theme;
    }
    constructor(){
        this.handlers = new Set();
        this.theme = undefined;
    }
}
const $dc00d7996d97ffde$export$add900538e5d49b8 = new $dc00d7996d97ffde$export$9c1453fd5233c0aa();

});


parcelRegister("6CkfA", function(module, exports) {

$parcel$export(module.exports, "usePublicLinkService", () => $27faa5b7da681633$export$ae03a66b2e90dee2);

var $gwFzn = parcelRequire("gwFzn");

var $gabmL = parcelRequire("gabmL");

var $6S5EB = parcelRequire("6S5EB");

var $bmx5U = parcelRequire("bmx5U");
const $27faa5b7da681633$export$ae03a66b2e90dee2 = (contentId, tokenService)=>{
    const [publicLinkService] = (0, $gwFzn.useState)(()=>new (0, $bmx5U.PublicLinkService)());
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const { isLoading: isLoading, isPublicLinkFullyEnabled: isPublicLinkFullyEnabled, isEditPublicLink: isEditPublicLink, refetch: refetch } = (0, $gabmL.usePublicLinkData)({
        contentId: contentId,
        contentQueryProps: {
            skip: true,
            contentType: 'whiteboard'
        }
    });
    const getPublicLinkInfoFromGraphql = (0, $gwFzn.useCallback)(()=>{
        if (!isLoading) publicLinkService.setPublicLink({
            isEnabled: isPublicLinkFullyEnabled,
            isEditEnabled: isEditPublicLink,
            refetch: refetch
        });
    }, [
        publicLinkService,
        isLoading,
        isPublicLinkFullyEnabled,
        isEditPublicLink,
        refetch
    ]);
    // we can't make these calls on a public link
    (0, $gwFzn.useEffect)(()=>{
        if (!isExternal) getPublicLinkInfoFromGraphql();
    }, [
        isExternal,
        isLoading,
        publicLinkService,
        getPublicLinkInfoFromGraphql
    ]);
    const getPublicLinkInfoFromToken = (0, $gwFzn.useCallback)(async ()=>{
        const token = await tokenService.getToken();
        const permissions = tokenService.getPermissions(token);
        publicLinkService.setPublicLink({
            // really this should never be false by this point, since if we're in isExternal we have to be on a public link
            // and for us to get to this logic, the public link must be enabled. Checking the permissions.length is really just
            // an extra safety net
            isEnabled: permissions.length > 0,
            isEditEnabled: permissions.includes('write'),
            refetch: getPublicLinkInfoFromToken
        });
    }, [
        publicLinkService,
        tokenService
    ]);
    // since we can't make the queries encapsulated in usePublicLinkData, we need to parse the token to determine the public link info
    (0, $gwFzn.useEffect)(()=>{
        if (isExternal) getPublicLinkInfoFromToken();
    }, [
        isExternal,
        getPublicLinkInfoFromToken,
        publicLinkService
    ]);
    return publicLinkService;
};

});
parcelRegister("bmx5U", function(module, exports) {

$parcel$export(module.exports, "PublicLinkService", () => $ef2784119920386e$export$11f5e18ed3c49b69);
class $ef2784119920386e$export$11f5e18ed3c49b69 {
    setPublicLink(publicLink) {
        this.publicLink = publicLink;
    }
    getPublicLink() {
        return this.publicLink;
    }
    refetchPublicLink() {
        this.publicLink.refetch();
    }
    constructor(){
        this.publicLink = {
            isEnabled: false,
            isEditEnabled: false,
            refetch: ()=>{}
        };
    }
}

});


parcelRegister("9Yv7s", function(module, exports) {

$parcel$export(module.exports, "useContentDataService", () => $a7be7fbd61c3e0ed$export$f72c297886c0574a);

var $gwFzn = parcelRequire("gwFzn");

var $SlF1P = parcelRequire("SlF1P");
const $a7be7fbd61c3e0ed$export$f72c297886c0574a = ({ contentCreatorId: contentCreatorId })=>{
    const [contentDataService] = (0, $gwFzn.useState)(()=>new (0, $SlF1P.WhiteboardContentDataService)());
    (0, $gwFzn.useEffect)(()=>{
        contentDataService.setContentData({
            contentCreatorId: contentCreatorId
        });
    }, [
        contentDataService,
        contentCreatorId
    ]);
    return contentDataService;
};

});
parcelRegister("SlF1P", function(module, exports) {

$parcel$export(module.exports, "WhiteboardContentDataService", () => $e8ace3f439928bf1$export$6b038618ac029f97);
class $e8ace3f439928bf1$export$6b038618ac029f97 {
    setContentData(contentData) {
        this.contentData = contentData;
    }
    getContentCreatorId() {
        return this.contentData.contentCreatorId;
    }
    constructor(){
        this.contentData = {
            contentCreatorId: null
        };
    }
}

});


parcelRegister("9Zj7l", function(module, exports) {

$parcel$export(module.exports, "useDetailsPanelService", () => $b939c27ef0cabb4b$export$8a58354df2cc0213);

var $hysf6 = parcelRequire("hysf6");

var $aWwYt = parcelRequire("aWwYt");
const $b939c27ef0cabb4b$export$8a58354df2cc0213 = ()=>{
    const { showDetailsPanel: showDetailsPanel } = (0, $hysf6.useShowDetailsPanel)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const detailsPanelService = {
        showPanel: ()=>{
            showDetailsPanel();
        },
        hidePanel: ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            hideObjectSidebar();
        }
    };
    return detailsPanelService;
};

});
parcelRegister("hysf6", function(module, exports) {

$parcel$export(module.exports, "useShowDetailsPanel", () => $4119a6166d969e95$export$fd546c83bdd1393d);

var $2nPZH = parcelRequire("2nPZH");

var $jvYFk = parcelRequire("jvYFk");
var $aWwYt = parcelRequire("aWwYt");

var $7N9MO = parcelRequire("7N9MO");

var $9igqG = parcelRequire("9igqG");
const $4119a6166d969e95$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    }
});
const $4119a6166d969e95$export$fd546c83bdd1393d = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const showDetailsPanel = ()=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $7N9MO.DetailsPanelHeaderIcon),
                headerLabel: $4119a6166d969e95$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: (0, $9igqG.DetailsPanelBody)
        }, 'push');
    };
    return {
        isDetailsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).DetailsPanel,
        showDetailsPanel: showDetailsPanel
    };
};

});
parcelRegister("7N9MO", function(module, exports) {

$parcel$export(module.exports, "DetailsPanelHeaderIcon", () => $c3510951803c5233$export$b127d30889efe7fe);

var $gwFzn = parcelRequire("gwFzn");

var $8tSmd = parcelRequire("8tSmd");

var $1s5hv = parcelRequire("1s5hv");
const $c3510951803c5233$export$b127d30889efe7fe = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        label: ""
    }));
};

});

parcelRegister("9igqG", function(module, exports) {

$parcel$export(module.exports, "DetailsPanelBody", () => $27b90458aead410f$export$7b946ff6a74a6839);

var $gwFzn = parcelRequire("gwFzn");

var $eyWa4 = parcelRequire("eyWa4");

var $dIouf = parcelRequire("dIouf");

var $ep3mz = parcelRequire("ep3mz");

var $67Foi = parcelRequire("67Foi");

var $1eaCJ = parcelRequire("1eaCJ");
var $irVI7 = parcelRequire("irVI7");

var $TpyhM = parcelRequire("TpyhM");

var $8KAqe = parcelRequire("8KAqe");

var $b7jGt = parcelRequire("b7jGt");

var $hkxWH = parcelRequire("hkxWH");

var $5qLRP = parcelRequire("5qLRP");
const $27b90458aead410f$var$DetailsPanelComponent = ()=>{
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    const [contentType] = (0, $ep3mz.useContentType)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        testId: "details-panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $TpyhM.PeopleSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8KAqe.StatsSection), null), isElementVisible((0, $5qLRP.ELEMENTS).SECTIONS.PROPERTIES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b7jGt.InfoSection), null), isElementVisible((0, $5qLRP.ELEMENTS).SECTIONS.CONNECTIONS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hkxWH.ConnectionsSection), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
        name: "detailsPanelScreen",
        id: "detailsPanelScreen",
        attributes: {
            contentType: contentType
        }
    }));
};
const $27b90458aead410f$export$7b946ff6a74a6839 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).DISCO
})($27b90458aead410f$var$DetailsPanelComponent);

});
parcelRegister("TpyhM", function(module, exports) {

$parcel$export(module.exports, "PeopleSection", () => $a458f954e7688173$export$dd2d4d0b8ec52ff3);

var $gwFzn = parcelRequire("gwFzn");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $dIouf = parcelRequire("dIouf");

var $gJPfg = parcelRequire("gJPfg");

var $iePn3 = parcelRequire("iePn3");

var $kyQDO = parcelRequire("kyQDO");

var $9ZxQw = parcelRequire("9ZxQw");
const $a458f954e7688173$var$peopleSectionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $a458f954e7688173$var$secondaryPeopleStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $a458f954e7688173$export$dd2d4d0b8ec52ff3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $a458f954e7688173$var$peopleSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ZxQw.OwnerSection), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $a458f954e7688173$var$secondaryPeopleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iePn3.ContributorsRow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gJPfg.CreatorRow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kyQDO.LastUpdatedRow), null))));

});
parcelRegister("gJPfg", function(module, exports) {

$parcel$export(module.exports, "CreatorRow", () => $db34986343c8c2ca$export$8167c69147b0585a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $6767u = parcelRequire("6767u");

var $5bo6d = parcelRequire("5bo6d");

var $8KnnK = parcelRequire("8KnnK");
const $db34986343c8c2ca$var$i18n = (0, $2nPZH.defineMessages)({
    creator: {
        id: "details-panel.properties-section.creator-row",
        defaultMessage: "Creator"
    },
    accessibleAvatarLabel: {
        id: "details-panel.properties-section.creator-row.accessible-avatar-label",
        defaultMessage: "{displayName}\u2019s profile picture"
    }
});
const $db34986343c8c2ca$export$8167c69147b0585a = ()=>{
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $5bo6d.useContentCreator)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8KnnK.PersonRow), {
        loadingTestId: "creator-row-loading",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: ""
        }),
        analyticsRole: "creator",
        i18n: {
            accessibleAvatarLabel: $db34986343c8c2ca$var$i18n.accessibleAvatarLabel,
            personLabel: $db34986343c8c2ca$var$i18n.creator
        },
        data: data,
        error: error,
        refetch: refetch,
        loading: loading
    });
};

});
parcelRegister("5bo6d", function(module, exports) {

$parcel$export(module.exports, "useContentCreator", () => $977ba6942676c3d8$export$958c3f0906de8016);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $cD1qu = parcelRequire("cD1qu");

var $htsj6 = parcelRequire("htsj6");

var $ATHVa = parcelRequire("ATHVa");

var $rrdNq = parcelRequire("rrdNq");
const $977ba6942676c3d8$var$useContentCreatorDetailsPanelContentCreatedByQuery = (0, $d2LG0.default)`query useContentCreatorDetailsPanelContentCreatedByQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id history{createdBy{type displayName ...on KnownUser{accountId}...on User{accountId}profilePicture{path}}}}}}`;
const $977ba6942676c3d8$export$958c3f0906de8016 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const isContentStatusDraft = contentStatus === (0, $cD1qu.ContentStatus).DRAFT;
    const { data: createdByData, loading: isCreatedByLoading, error: createdByError, refetch: refetchCreatedBy } = (0, $j1Ss3.useQuery)($977ba6942676c3d8$var$useContentCreatorDetailsPanelContentCreatedByQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? ''
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId || isContentStatusDraft
    });
    const normalizedCreatedByData = (0, $gwFzn.useMemo)(()=>(0, $ATHVa.normalizeContentCreatorData)(createdByData), [
        createdByData
    ]);
    const { data: contentOwnerData, loading: isContentOwnerLoading, error: contentOwnerError, refetch: refetchContentOwner } = (0, $rrdNq.useContentOwner)({
        skip: !isContentStatusDraft
    });
    const refetchUserData = isContentStatusDraft ? refetchContentOwner : refetchCreatedBy;
    return {
        data: isContentStatusDraft ? contentOwnerData : normalizedCreatedByData,
        loading: isContentStatusLoading || isCreatedByLoading || isContentOwnerLoading,
        error: contentStatusError || createdByError || contentOwnerError,
        refetch: contentStatusError ? refetchContentStatus : refetchUserData
    };
};

});
parcelRegister("ATHVa", function(module, exports) {

$parcel$export(module.exports, "normalizeContentCreatorData", () => $4ed8f2cda16eb725$export$275ac55729c181ca);

var $iQ1H0 = parcelRequire("iQ1H0");
const $4ed8f2cda16eb725$export$275ac55729c181ca = (data)=>{
    const createdBy = data?.content?.nodes?.[0]?.history?.createdBy;
    return {
        accountId: (0, $iQ1H0.hasAccountId)(createdBy) ? createdBy?.accountId : '',
        displayName: createdBy?.displayName ?? '',
        profilePicturePath: createdBy?.profilePicture?.path
    };
};

});
parcelRegister("iQ1H0", function(module, exports) {

$parcel$export(module.exports, "hasAccountId", () => $f8025aa33ba82d7f$export$90053f8722608fdd);
$parcel$export(module.exports, "truncateName", () => $f8025aa33ba82d7f$export$988945b3d699075c);
const $f8025aa33ba82d7f$export$90053f8722608fdd = (ownedBy)=>!!ownedBy && 'accountId' in ownedBy;
const $f8025aa33ba82d7f$export$988945b3d699075c = (name, maxChar)=>{
    if (name.length <= maxChar) return name;
    return `${name.slice(0, maxChar)}...`;
};

});


parcelRegister("rrdNq", function(module, exports) {

$parcel$export(module.exports, "useContentOwner", () => $9771e03e1c2beb91$export$952bbc51fdbffa6e);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $htsj6 = parcelRequire("htsj6");

var $5TgVt = parcelRequire("5TgVt");
const $9771e03e1c2beb91$var$useContentOwnerDetailsPanelContentOwnerQuery = (0, $d2LG0.default)`query useContentOwnerDetailsPanelContentOwnerQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id history{ownedBy{type displayName ...on KnownUser{accountId}...on User{accountId}profilePicture{path}}}}}}`;
const $9771e03e1c2beb91$export$952bbc51fdbffa6e = ({ skip: skip = false } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)({
        skip: skip
    });
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($9771e03e1c2beb91$var$useContentOwnerDetailsPanelContentOwnerQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? ''
        },
        skip: skip || isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $5TgVt.normalizeContentOwnerData)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};

});
parcelRegister("5TgVt", function(module, exports) {

$parcel$export(module.exports, "normalizeContentOwnerData", () => $498256fa12521bbe$export$cb2464d13a6f2491);

var $iQ1H0 = parcelRequire("iQ1H0");
const $498256fa12521bbe$export$cb2464d13a6f2491 = (data)=>{
    const ownedBy = data?.content?.nodes?.[0]?.history?.ownedBy;
    return {
        accountId: (0, $iQ1H0.hasAccountId)(ownedBy) ? ownedBy?.accountId : '',
        displayName: ownedBy?.displayName ?? '',
        profilePicturePath: ownedBy?.profilePicture?.path
    };
};

});



parcelRegister("8KnnK", function(module, exports) {

$parcel$export(module.exports, "PersonRow", () => $5787f3e4addf8e3a$export$2360cd0b07b95057);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $esRft = parcelRequire("esRft");

var $u9agA = parcelRequire("u9agA");

var $3gadb = parcelRequire("3gadb");

var $2Nwuj = parcelRequire("2Nwuj");

var $kpYGL = parcelRequire("kpYGL");

var $a6t12 = parcelRequire("a6t12");

var $1NBp8 = parcelRequire("1NBp8");

var $iQ1H0 = parcelRequire("iQ1H0");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");
const $5787f3e4addf8e3a$var$MAX_DISPLAY_NAME_LENGTH = 25;
const $5787f3e4addf8e3a$var$PEOPLE_DIRECTORY_URL = (0, $1NBp8.PEOPLE_DIRECTORY).toUrl();
const $5787f3e4addf8e3a$var$noop = ()=>{};
const $5787f3e4addf8e3a$export$2360cd0b07b95057 = ({ loadingTestId: loadingTestId, icon: icon, analyticsRole: analyticsRole, i18n: { personLabel: personLabel, accessibleAvatarLabel: accessibleAvatarLabel }, data: { accountId: accountId, displayName: displayName, profilePicturePath: profilePicturePath }, error: error, refetch: refetch, loading: loading })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const renderPersonRow = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
            width: "80px",
            height: "24px",
            borderRadius: 3,
            testId: loadingTestId
        });
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        const profileURL = accountId ? `${$5787f3e4addf8e3a$var$PEOPLE_DIRECTORY_URL}/${accountId}` : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            alignInline: "center",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
            content: displayName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
            appearance: "subtle",
            href: profileURL,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    role: analyticsRole,
                    name: 'profileName'
                }
            }
        }, (0, $iQ1H0.truncateName)(displayName, $5787f3e4addf8e3a$var$MAX_DISPLAY_NAME_LENGTH))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: accountId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
            size: "small",
            href: profileURL,
            src: profilePicturePath ?? undefined,
            name: formatMessage(accessibleAvatarLabel, {
                displayName: displayName
            }),
            onClick: /* an analytics event is only fired if onClick is provided,
        	but providing onClick will change behavior if href is not provided */ profileURL ? $5787f3e4addf8e3a$var$noop : undefined,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    role: analyticsRole,
                    name: 'profileImage'
                }
            }
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage(personLabel),
        icon: icon
    }, renderPersonRow());
};

});
parcelRegister("5nUIg", function(module, exports) {

$parcel$export(module.exports, "DetailRow", () => $7489de58f9d21175$export$3ea9d70abca6f185);

var $gwFzn = parcelRequire("gwFzn");

var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");
const $7489de58f9d21175$var$detailRowStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    height: 'size.200'
});
const $7489de58f9d21175$export$3ea9d70abca6f185 = ({ icon: icon, itemName: itemName, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $7489de58f9d21175$var$detailRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, icon, itemName), children);
};

});

parcelRegister("28V34", function(module, exports) {

$parcel$export(module.exports, "InlineRetryError", () => $c5268d744aecc17b$export$51c55327f05e286f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $iEKnc = parcelRequire("iEKnc");

var $dcJ7R = parcelRequire("dcJ7R");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");

var $dIouf = parcelRequire("dIouf");
const $c5268d744aecc17b$var$retryStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.information'
});
const $c5268d744aecc17b$var$i18n = (0, $2nPZH.defineMessages)({
    retry: {
        id: "details-panel.error-retry",
        defaultMessage: "Retry"
    },
    errorInfo: {
        id: "details-panel.error-info",
        defaultMessage: "Failed to load"
    },
    errorIconLabel: {
        id: "details-panel.error-icon-label",
        defaultMessage: "error icon"
    }
});
const $c5268d744aecc17b$export$51c55327f05e286f = ({ error: error, refetch: refetch })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "bottom",
        content: formatMessage($c5268d744aecc17b$var$i18n.errorInfo)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iEKnc))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: formatMessage($c5268d744aecc17b$var$i18n.errorIconLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        xcss: $c5268d744aecc17b$var$retryStyle,
        onClick: ()=>refetch()
    }, formatMessage($c5268d744aecc17b$var$i18n.retry))));
};

});



parcelRegister("iePn3", function(module, exports) {

$parcel$export(module.exports, "ContributorsRow", () => $3ab98a3e7bf32b9d$export$9904cc2fa820959);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2Pg7f = parcelRequire("2Pg7f");

var $lebfc = parcelRequire("lebfc");

var $kpYGL = parcelRequire("kpYGL");

var $k9v9c = parcelRequire("k9v9c");

var $28V34 = parcelRequire("28V34");

var $5nUIg = parcelRequire("5nUIg");
const $3ab98a3e7bf32b9d$var$i18n = (0, $2nPZH.defineMessages)({
    contributors: {
        id: "details-panel.contributor-row.contributors",
        defaultMessage: "Contributors"
    }
});
const $3ab98a3e7bf32b9d$var$noop = ()=>{};
const $3ab98a3e7bf32b9d$export$9904cc2fa820959 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $k9v9c.useContentContributors)();
    const { nodes: nodes } = data;
    const safeNodes = nodes ?? [];
    if (safeNodes.length === 0 && !error) return null;
    const nodesWithAnalyticsContext = safeNodes.map((node)=>({
            ...node,
            /* an analytics event is only fired if onClick is provided,
    	 but providing onClick will change behavior if href is not provided */ onClick: node.href ? $3ab98a3e7bf32b9d$var$noop : undefined,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    role: 'contributor',
                    name: 'profileImage'
                }
            }
        }));
    const renderContributorsSectionContent = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
            width: "80px",
            height: "24px",
            borderRadius: 3,
            testId: "contributors-row-loading"
        });
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pg7f.default), {
            size: "small",
            maxCount: 3,
            appearance: "stack",
            data: nodesWithAnalyticsContext
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($3ab98a3e7bf32b9d$var$i18n.contributors),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
            label: ""
        })
    }, renderContributorsSectionContent());
};

});
parcelRegister("k9v9c", function(module, exports) {

$parcel$export(module.exports, "useContentContributors", () => $351541e5ad9e9537$export$ff0c1b4124f50967);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $4mjuc = parcelRequire("4mjuc");

var $rrdNq = parcelRequire("rrdNq");

var $9QmIK = parcelRequire("9QmIK");
const $351541e5ad9e9537$var$useContentContributorsDetailsPanelContentContributorsQuery = (0, $d2LG0.default)`query useContentContributorsDetailsPanelContentContributorsQuery($contentId:ID!$contributorLimit:Int!){contentContributors(id:$contentId limit:$contributorLimit){nodes{type displayName ...on KnownUser{accountId}...on User{accountId}profilePicture{path}}}}`;
const $351541e5ad9e9537$export$71c38423f4606a00 = 2147483647;
const $351541e5ad9e9537$export$ff0c1b4124f50967 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: contentOwnerData, refetch: refetchContentOwner, error: contentOwnerError, loading: isContentOwnerLoading } = (0, $rrdNq.useContentOwner)();
    const { accountId: ownerAccountId } = contentOwnerData;
    const { data: contentContributorsData, loading: isContentContributorsLoading, error: contentContributorsError, refetch: refetchContentContributors } = (0, $j1Ss3.useQuery)($351541e5ad9e9537$var$useContentContributorsDetailsPanelContentContributorsQuery, {
        variables: {
            contentId: contentId ?? '',
            contributorLimit: $351541e5ad9e9537$export$71c38423f4606a00
        },
        skip: !contentId
    });
    const formattedNodes = (0, $gwFzn.useMemo)(()=>{
        const { nodes: nodes } = (0, $4mjuc.normalizeContentContributorsData)(contentContributorsData);
        return (0, $9QmIK.getFormattedNodes)({
            nodes: nodes,
            ownerAccountId: ownerAccountId
        });
    }, [
        contentContributorsData,
        ownerAccountId
    ]);
    return {
        data: {
            nodes: formattedNodes,
            count: formattedNodes.length
        },
        loading: isContentOwnerLoading || isContentContributorsLoading,
        error: contentOwnerError || contentContributorsError,
        refetch: contentOwnerError ? refetchContentOwner : refetchContentContributors
    };
};

});
parcelRegister("4mjuc", function(module, exports) {

$parcel$export(module.exports, "normalizeContentContributorsData", () => $3c80799d096a63bb$export$d6b021e12eff4360);
const $3c80799d096a63bb$export$d6b021e12eff4360 = (data)=>({
        nodes: data?.contentContributors?.nodes ?? []
    });

});

parcelRegister("9QmIK", function(module, exports) {

$parcel$export(module.exports, "getFormattedNodes", () => $986c400a3d0a417e$export$a068fd1ce1bc7e);

var $4qzKl = parcelRequire("4qzKl");

var $jlIaF = parcelRequire("jlIaF");

var $iQ1H0 = parcelRequire("iQ1H0");
const $986c400a3d0a417e$export$a068fd1ce1bc7e = ({ nodes: nodes, ownerAccountId: ownerAccountId })=>nodes.filter((contributor)=>{
        if (!contributor) return false; // Exclude null contributors
        if (!(0, $iQ1H0.hasAccountId)(contributor)) return true; // Include contributors without an accountId, as they can't be the owner
        return contributor.accountId !== ownerAccountId; // Exclude contributors whose accountId matches the owner's accountId
    }).map((contributor)=>{
        const accountId = (0, $iQ1H0.hasAccountId)(contributor) ? contributor.accountId : null;
        return {
            name: contributor.displayName || '',
            href: (0, $4qzKl.getAtlassianPeopleProfileUrl)(accountId, '', (0, $jlIaF.CONTEXT_PATH)),
            src: contributor.profilePicture?.path || ''
        };
    });

});



parcelRegister("kyQDO", function(module, exports) {

$parcel$export(module.exports, "LastUpdatedRow", () => $2d63f9c687d4cb76$export$f546c79bd733f286);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $1Zr9M = parcelRequire("1Zr9M");

var $jJQtk = parcelRequire("jJQtk");

var $8KnnK = parcelRequire("8KnnK");
const $2d63f9c687d4cb76$var$i18n = (0, $2nPZH.defineMessages)({
    lastUpdatedBy: {
        id: "details-panel.properties-section.last-updated-row",
        defaultMessage: "Last updated by"
    },
    accessibleAvatarLabel: {
        id: "details-panel.properties-section.last-updated-row.accessible-avatar-label",
        defaultMessage: "{displayName}\u2019s profile picture"
    }
});
const $2d63f9c687d4cb76$export$f546c79bd733f286 = ()=>{
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $jJQtk.useContentLastUpdated)();
    if (!loading && !error && !data.accountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8KnnK.PersonRow), {
        loadingTestId: "last-updated-row-loading",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: ""
        }),
        analyticsRole: "lastUpdater",
        i18n: {
            accessibleAvatarLabel: $2d63f9c687d4cb76$var$i18n.accessibleAvatarLabel,
            personLabel: $2d63f9c687d4cb76$var$i18n.lastUpdatedBy
        },
        data: data,
        error: error,
        refetch: refetch,
        loading: loading
    });
};

});
parcelRegister("jJQtk", function(module, exports) {

$parcel$export(module.exports, "useContentLastUpdated", () => $d8f8c1c8c95f9c6a$export$151985ea30c617ee);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $htsj6 = parcelRequire("htsj6");

var $2HlsG = parcelRequire("2HlsG");
const $d8f8c1c8c95f9c6a$var$useContentLastUpdatedDetailsPanelContentLastUpdatedQuery = (0, $d2LG0.default)`query useContentLastUpdatedDetailsPanelContentLastUpdatedQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id history{lastUpdated{by{type displayName ...on KnownUser{accountId}...on User{accountId}profilePicture{path}}}}}}}`;
const $d8f8c1c8c95f9c6a$export$151985ea30c617ee = ({ skip: skip = false } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)({
        skip: skip
    });
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($d8f8c1c8c95f9c6a$var$useContentLastUpdatedDetailsPanelContentLastUpdatedQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? ''
        },
        skip: skip || isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $2HlsG.normalizeContentLastUpdatedData)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};

});
parcelRegister("2HlsG", function(module, exports) {

$parcel$export(module.exports, "normalizeContentLastUpdatedData", () => $c6ba6157f312bb22$export$8fdb104004fb8098);

var $iQ1H0 = parcelRequire("iQ1H0");
const $c6ba6157f312bb22$export$8fdb104004fb8098 = (data)=>{
    const lastUpdatedBy = data?.content?.nodes?.[0]?.history?.lastUpdated?.by;
    return {
        accountId: (0, $iQ1H0.hasAccountId)(lastUpdatedBy) ? lastUpdatedBy?.accountId : '',
        displayName: lastUpdatedBy?.displayName ?? '',
        profilePicturePath: lastUpdatedBy?.profilePicture?.path
    };
};

});



parcelRegister("9ZxQw", function(module, exports) {

$parcel$export(module.exports, "OwnerSection", () => $f7dbfed1c486b1fb$export$cfad9ff853a9b88);

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $kpYGL = parcelRequire("kpYGL");

var $bW9BK = parcelRequire("bW9BK");

var $htsj6 = parcelRequire("htsj6");

var $4Kc7p = parcelRequire("4Kc7p");

var $rrdNq = parcelRequire("rrdNq");

var $k9v9c = parcelRequire("k9v9c");

var $28V34 = parcelRequire("28V34");
const $f7dbfed1c486b1fb$export$cfad9ff853a9b88 = ()=>{
    const { type: contentType, contentStatus: contentStatus, loading: contentStatusLoading, error: contentStatusError, refetch: contentStatusRefetch } = (0, $htsj6.useContentStatus)();
    const { data: contentOwnerData, loading: contentOwnerLoading, error: contentOwnerError, refetch: contentOwnerRefetch } = (0, $rrdNq.useContentOwner)();
    const { data: spaceAdminData, loading: spaceAdminLoading, error: spaceAdminError, refetch: spaceAdminRefetch } = (0, $4Kc7p.useSpaceAdmin)();
    const { data: contentContributors, loading: contentContributorsLoading, error: contentContributorsError, refetch: contentContributorsRefetch } = (0, $k9v9c.useContentContributors)();
    const noOtherContributors = contentContributorsLoading ? undefined : contentContributors?.count === 0;
    const error = contentStatusError || contentOwnerError || spaceAdminError || contentContributorsError;
    const refetch = (0, $gwFzn.useCallback)(()=>{
        if (contentStatusError) contentStatusRefetch();
        if (contentOwnerError) contentOwnerRefetch();
        if (spaceAdminError) spaceAdminRefetch();
        if (contentContributorsError) contentContributorsRefetch();
    }, [
        contentStatusError,
        contentStatusRefetch,
        contentOwnerError,
        contentOwnerRefetch,
        spaceAdminError,
        spaceAdminRefetch,
        contentContributorsError,
        contentContributorsRefetch
    ]);
    const renderOwnerSectionContent = ()=>{
        if (contentStatusLoading || contentOwnerLoading || spaceAdminLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.150",
            testId: "owner-section-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
            width: "40px",
            height: "40px",
            borderRadius: 200
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
            width: "154px",
            height: "32px",
            borderRadius: 4
        }));
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        const { accountId: accountId, profilePicturePath: profilePicturePath, displayName: displayName } = contentOwnerData;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bW9BK.ContentOwnerItemForDetailsPanel), {
            ownerAccountId: accountId,
            ownerName: displayName,
            ownerAvatarUrl: profilePicturePath,
            contentType: contentType,
            contentStatus: contentStatus,
            noOtherContributors: noOtherContributors,
            isCurrentUserSpaceAdmin: spaceAdminData.isCurrentUserSpaceAdmin,
            analyticsSource: "contentWrapper"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        paddingBlockStart: "space.025",
        testId: "owner-section"
    }, renderOwnerSectionContent());
};

});
parcelRegister("bW9BK", function(module, exports) {

$parcel$export(module.exports, "ContentOwnerItemForDetailsPanel", () => $e14ff18a942ab015$export$6753f78cf3cd0bfa);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $esRft = parcelRequire("esRft");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");

var $2Nwuj = parcelRequire("2Nwuj");

var $a6t12 = parcelRequire("a6t12");

var $1NBp8 = parcelRequire("1NBp8");

var $jFm04 = parcelRequire("jFm04");

var $eq5ww = parcelRequire("eq5ww");

var $bkahn = parcelRequire("bkahn");

var $873qR = parcelRequire("873qR");

var $hJe2K = parcelRequire("hJe2K");
const $e14ff18a942ab015$var$i18n = (0, $2nPZH.defineMessages)({
    owner: {
        id: "content-ownership.content-owner-item.owner",
        defaultMessage: "Owner"
    },
    creator: {
        id: "content-ownership.content-owner-item.creator",
        defaultMessage: "Creator"
    },
    ownerOrCreatorWithContributors: {
        id: "content-ownership.content-owner-item.owner-or-creator-with-contributors",
        defaultMessage: "{isBlogpost, select, true {Creator} other {Owner}}{noOtherContributors, select, true {, no contributors} other {}}"
    },
    changeOwner: {
        id: "content-ownership.content-owner-item.change-owner",
        defaultMessage: "Change owner"
    },
    accessibleAvatarLabel: {
        id: "content-ownership.content-owner-item.accessible-avatar-label",
        defaultMessage: "{displayName}\u2019s profile picture"
    }
});
function $e14ff18a942ab015$var$noop() {
// intentionally empty
}
const $e14ff18a942ab015$export$6753f78cf3cd0bfa = ({ ownerAccountId: ownerAccountId, ownerName: ownerName, ownerAvatarUrl: ownerAvatarUrl, contentType: contentType, contentStatus: contentStatus, noOtherContributors: noOtherContributors, isCurrentUserSpaceAdmin: isCurrentUserSpaceAdmin, analyticsSource: analyticsSource })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const ownerProfileUrl = ownerAccountId ? `${(0, $1NBp8.PEOPLE_DIRECTORY).toUrl()}/${ownerAccountId}` : '';
    const avatarLabel = formatMessage($e14ff18a942ab015$var$i18n.accessibleAvatarLabel, {
        displayName: ownerName
    });
    const userTitle = (0, $873qR.useUserTitle)({
        contentType: contentType,
        noOtherContributors: noOtherContributors
    });
    const isChangeOwnerAvailable = (0, $bkahn.useIsChangeOwnerAvailable)({
        ownerAccountId: ownerAccountId,
        isCurrentUserSpaceAdmin: isCurrentUserSpaceAdmin,
        contentType: contentType,
        contentStatus: contentStatus
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: ownerAccountId,
        position: "left",
        trigger: "hover",
        fullName: ownerName ?? undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        size: "large",
        borderColor: "transparent",
        href: ownerProfileUrl,
        src: ownerAvatarUrl ?? undefined,
        name: avatarLabel,
        onClick: /* an analytics event is only fired if onClick is provided,
                             but providing onClick will change behavior if href is not provided */ ownerProfileUrl ? $e14ff18a942ab015$var$noop : undefined,
        analyticsContext: {
            source: analyticsSource,
            attributes: {
                role: 'owner',
                name: 'profileImage'
            }
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        appearance: "subtle",
        href: ownerProfileUrl,
        analyticsContext: {
            source: analyticsSource,
            attributes: {
                role: 'owner',
                name: 'profileName'
            }
        }
    }, ownerName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, userTitle)))), isChangeOwnerAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eq5ww.ChangeContentOwnerButton), {
            onClick: openModal,
            analyticsContext: (0, $hJe2K.getChangeOwnerButtonAnalyticsContext)(analyticsSource, 'false')
        });
    })));
};

});
parcelRegister("eq5ww", function(module, exports) {

$parcel$export(module.exports, "ChangeContentOwnerButton", () => $45d696de3043f8ab$export$6b112712167c447a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $4BqOc = parcelRequire("4BqOc");

var $1qfLF = parcelRequire("1qfLF");

var $3gadb = parcelRequire("3gadb");
const $45d696de3043f8ab$var$i18n = (0, $2nPZH.defineMessages)({
    changeOwner: {
        id: "content-ownership.content-owner-item.change-owner",
        defaultMessage: "Change owner"
    }
});
const $45d696de3043f8ab$export$6b112712167c447a = ({ onClick: onClick, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: formatMessage($45d696de3043f8ab$var$i18n.changeOwner)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4BqOc))),
        label: formatMessage($45d696de3043f8ab$var$i18n.changeOwner),
        onClick: onClick,
        analyticsContext: analyticsContext
    }));
};

});

parcelRegister("bkahn", function(module, exports) {

$parcel$export(module.exports, "useIsChangeOwnerAvailable", () => $b264719f611e66ea$export$a2a0daf9c87360fa);

var $9wGTI = parcelRequire("9wGTI");

var $cD1qu = parcelRequire("cD1qu");

var $bQm3c = parcelRequire("bQm3c");

var $lfBMY = parcelRequire("lfBMY");
var $2wo33 = parcelRequire("2wo33");

var $ep3mz = parcelRequire("ep3mz");
const $b264719f611e66ea$export$a2a0daf9c87360fa = ({ ownerAccountId: ownerAccountId, isCurrentUserSpaceAdmin: isCurrentUserSpaceAdmin, contentType: contentType, contentStatus: contentStatus })=>{
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [canUpdateContent] = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE,
        status: contentStatus === (0, $cD1qu.ContentStatus).DRAFT ? (0, $cD1qu.DRAFT_STATUS) : (0, $cD1qu.CURRENT_STATUS)
    });
    if (!contentType || !contentStatus) return false;
    const isNotBlogpost = contentType !== 'blogpost';
    const isNotDraft = contentStatus !== (0, $cD1qu.ContentStatus).DRAFT;
    const isNotArchived = contentStatus !== (0, $cD1qu.ContentStatus).ARCHIVED;
    // true if FF is off or canUpdateContent is undefined
    const hasWriteAccess = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? canUpdateContent ?? true : true;
    const isContentOwner = ownerAccountId === currentUserId;
    return isNotBlogpost && isNotDraft && isNotArchived && hasWriteAccess && (isContentOwner || isCurrentUserSpaceAdmin);
};

});

parcelRegister("873qR", function(module, exports) {

$parcel$export(module.exports, "useUserTitle", () => $9d914014ecc6077c$export$2fe514110a70adb2);

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9wGTI = parcelRequire("9wGTI");
const $9d914014ecc6077c$var$i18n = (0, $2nPZH.defineMessages)({
    owner: {
        id: "content-ownership.content-owner-item.owner",
        defaultMessage: "Owner"
    },
    creator: {
        id: "content-ownership.content-owner-item.creator",
        defaultMessage: "Creator"
    },
    ownerOrCreatorWithContributors: {
        id: "content-ownership.content-owner-item.owner-or-creator-with-contributors",
        defaultMessage: "{isBlogpost, select, true {Creator} other {Owner}}{noOtherContributors, select, true {, no contributors} other {}}"
    }
});
const $9d914014ecc6077c$export$2fe514110a70adb2 = ({ contentType: contentType, noOtherContributors: noOtherContributors })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isBlogpost = contentType === 'blogpost';
    if ((0, $9wGTI.fg)('page_byline_owner_and_contributors_dropdown')) return formatMessage($9d914014ecc6077c$var$i18n.ownerOrCreatorWithContributors, {
        isBlogpost: isBlogpost,
        noOtherContributors: noOtherContributors
    });
    // blogposts dont have the "owner" concept because they arent meant to be living objects live pages are. so we just refer to the creator.
    return isBlogpost ? formatMessage($9d914014ecc6077c$var$i18n.creator) : formatMessage($9d914014ecc6077c$var$i18n.owner);
};

});

parcelRegister("hJe2K", function(module, exports) {

$parcel$export(module.exports, "getChangeOwnerButtonAnalyticsContext", () => $4b21d1f0b17794f0$export$ad763d6e8f557da2);
const $4b21d1f0b17794f0$export$f2131260de83d7ff = {
    role: 'owner',
    name: 'changeOwner',
    override: 'true'
};
const $4b21d1f0b17794f0$export$ad763d6e8f557da2 = (analyticsSource, override)=>({
        source: analyticsSource,
        attributes: {
            role: 'owner',
            name: 'changeOwner',
            override: override
        }
    });

});


parcelRegister("4Kc7p", function(module, exports) {

$parcel$export(module.exports, "useSpaceAdmin", () => $6a049aa03dd83dd3$export$fbe9dbcc8265d013);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $4VXL7 = parcelRequire("4VXL7");
const $6a049aa03dd83dd3$var$useSpaceAdminDetailsPanelSpaceAdminQuery = (0, $d2LG0.default)`query useSpaceAdminDetailsPanelSpaceAdminQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}}}`;
const $6a049aa03dd83dd3$export$fbe9dbcc8265d013 = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($6a049aa03dd83dd3$var$useSpaceAdminDetailsPanelSpaceAdminQuery, {
        skip: !spaceKey,
        variables: {
            spaceKey: spaceKey ?? ''
        }
    });
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $4VXL7.normalizeSpaceAdminData)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: error,
        refetch: refetch
    };
};

});
parcelRegister("4VXL7", function(module, exports) {

$parcel$export(module.exports, "normalizeSpaceAdminData", () => $0644a504f6f1ed16$export$2cf64df9c654b040);
const $0644a504f6f1ed16$export$2cf64df9c654b040 = (data)=>({
        isCurrentUserSpaceAdmin: data?.space?.currentUser.isAdmin ?? false
    });

});




parcelRegister("8KAqe", function(module, exports) {

$parcel$export(module.exports, "StatsSection", () => $d646f513af901061$export$49e22b3583223277);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $dIouf = parcelRequire("dIouf");

var $5qLRP = parcelRequire("5qLRP");

var $aD40Y = parcelRequire("aD40Y");

var $hDzue = parcelRequire("hDzue");

var $cs8Ld = parcelRequire("cs8Ld");
const $d646f513af901061$var$i18n = (0, $2nPZH.defineMessages)({
    statsSectionTitle: {
        id: "details-panel.stats-section.title",
        defaultMessage: "Stats"
    }
});
const $d646f513af901061$var$statsSectionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginTop: 'space.300'
});
const $d646f513af901061$export$49e22b3583223277 = ()=>{
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $d646f513af901061$var$statsSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$d646f513af901061$var$i18n.statsSectionTitle,
        tagName: "h4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, isElementVisible((0, $5qLRP.ELEMENTS).ROWS.VIEWS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cs8Ld.ViewsRowWrapper), null), isElementVisible((0, $5qLRP.ELEMENTS).ROWS.LENGTH) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hDzue.LengthRow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aD40Y.CreatedRow), null))));
};

});
parcelRegister("5qLRP", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS", () => $db5b264ea04b1a6b$export$a6d18b072e3b7ccb);
$parcel$export(module.exports, "useElementVisibility", () => $db5b264ea04b1a6b$export$6aadc312a449609d);

var $gEtAQ = parcelRequire("gEtAQ");

var $ep3mz = parcelRequire("ep3mz");

var $bMPhU = parcelRequire("bMPhU");

var $1ggpj = parcelRequire("1ggpj");

var $9wGTI = parcelRequire("9wGTI");
const $db5b264ea04b1a6b$export$a6d18b072e3b7ccb = {
    ROWS: {
        CUSTOM_CONTENT: 'customContent',
        VIEWS: 'views',
        LENGTH: 'length',
        STATUS: 'status',
        REDACTIONS: 'redactions',
        LABELS: 'labels'
    },
    SECTIONS: {
        PROPERTIES: 'properties',
        CONNECTIONS: 'connections'
    }
};
const $db5b264ea04b1a6b$export$e09a3109414746fb = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.CUSTOM_CONTENT]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false
};
const $db5b264ea04b1a6b$export$28f9a36e98aa9cf4 = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.VIEWS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LENGTH]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.SECTIONS.CONNECTIONS]: false
};
const $db5b264ea04b1a6b$export$e96bb3f3767bc352 = {
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.VIEWS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LENGTH]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.STATUS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.REDACTIONS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS]: false,
    [$db5b264ea04b1a6b$export$a6d18b072e3b7ccb.SECTIONS.CONNECTIONS]: false
};
const $db5b264ea04b1a6b$export$6aadc312a449609d = ()=>{
    const isSpaceOverviewViewMode = (0, $gEtAQ.isSpaceOverview)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const isSpaceOverviewEditMode = homepageId === contentId;
    const isSpaceOverviewPage = isSpaceOverviewViewMode || isSpaceOverviewEditMode;
    const getVisibilityConfig = ()=>{
        if (isSpaceOverviewPage) return $db5b264ea04b1a6b$export$e09a3109414746fb;
        if (contentType === (0, $1ggpj.ContentType).DATABASE) return $db5b264ea04b1a6b$export$28f9a36e98aa9cf4;
        if (contentType === (0, $1ggpj.ContentType).WHITEBOARD) return $db5b264ea04b1a6b$export$e96bb3f3767bc352;
        return null;
    };
    const isElementVisible = (element)=>{
        if (element === $db5b264ea04b1a6b$export$a6d18b072e3b7ccb.ROWS.LABELS && (contentType === (0, $1ggpj.ContentType).DATABASE || contentType === (0, $1ggpj.ContentType).WHITEBOARD)) return (0, $9wGTI.fg)('confluence_frontend_labels_wb_db');
        const visibilityConfig = getVisibilityConfig();
        return (visibilityConfig && visibilityConfig[element]) ?? true;
    };
    return {
        isElementVisible: isElementVisible
    };
};

});

parcelRegister("aD40Y", function(module, exports) {

$parcel$export(module.exports, "CreatedRow", () => $53ff80f51b06f91e$export$4e325fd01f4587a7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $iXCQx = parcelRequire("iXCQx");

var $kevJM = parcelRequire("kevJM");

var $kpYGL = parcelRequire("kpYGL");

var $eSHCk = parcelRequire("eSHCk");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");
const $53ff80f51b06f91e$var$i18n = (0, $2nPZH.defineMessages)({
    created: {
        id: "details-panel.properties-section.created-row",
        defaultMessage: "Created"
    }
});
const $53ff80f51b06f91e$export$4e325fd01f4587a7 = ()=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $dBxQj.default)();
    const { data: data, error: error, refetch: refetch, loading: loading } = (0, $eSHCk.useContentCreatedDate)();
    const { date: date } = data;
    const renderCreatedItem = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
            width: "80px",
            height: "24px",
            borderRadius: 3,
            testId: "created-row-loading"
        });
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), null, formatDate(new Date(date ?? ''), {
            year: 'numeric',
            month: 'long',
            day: '2-digit'
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($53ff80f51b06f91e$var$i18n.created),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: ""
        })
    }, renderCreatedItem());
};

});
parcelRegister("eSHCk", function(module, exports) {

$parcel$export(module.exports, "useContentCreatedDate", () => $30db04ac345f7e3d$export$12ec296467271c17);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $htsj6 = parcelRequire("htsj6");

var $4bCNW = parcelRequire("4bCNW");
const $30db04ac345f7e3d$var$useContentCreatedDateDetailsPanelContentCreatedDateQuery = (0, $d2LG0.default)`query useContentCreatedDateDetailsPanelContentCreatedDateQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id metadata{createdDate}}}}`;
const $30db04ac345f7e3d$export$12ec296467271c17 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($30db04ac345f7e3d$var$useContentCreatedDateDetailsPanelContentCreatedDateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? ''
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $4bCNW.normalizeContentCreatedData)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};

});
parcelRegister("4bCNW", function(module, exports) {

$parcel$export(module.exports, "normalizeContentCreatedData", () => $328740414a8a528a$export$3c7c438d43cf7462);
const $328740414a8a528a$export$3c7c438d43cf7462 = (data)=>({
        date: data?.content?.nodes?.[0]?.metadata.createdDate
    });

});



parcelRegister("hDzue", function(module, exports) {

$parcel$export(module.exports, "LengthRow", () => $85a07c25d450f933$export$8f2787e5ba19fef6);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $cUQMr = parcelRequire("cUQMr");

var $bth99 = parcelRequire("bth99");

var $ep3mz = parcelRequire("ep3mz");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $kDhla = parcelRequire("kDhla");

var $5nUIg = parcelRequire("5nUIg");
const $85a07c25d450f933$var$i18n = (0, $2nPZH.defineMessages)({
    length: {
        id: "details-panel.properties-section.length-row",
        defaultMessage: "Length"
    }
});
const $85a07c25d450f933$export$8f2787e5ba19fef6 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($85a07c25d450f933$var$i18n.length),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bth99.ReadTime), {
        editorApi: fullPageEditorPresetAPI,
        contentId: contentId ?? '',
        isAbbreviatedReadTime: false,
        isInEditor: pageMode !== (0, $cD1qu.PageMode).VIEW,
        isDetailsPanel: true,
        showWordCount: true
    }));
};

});

parcelRegister("cs8Ld", function(module, exports) {

$parcel$export(module.exports, "ViewsRowWrapper", () => $be8d014ae40f1f99$export$45a1c12e916e9584);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $8cjip = parcelRequire("8cjip");

var $kpYGL = parcelRequire("kpYGL");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $ep3mz = parcelRequire("ep3mz");

var $1NBp8 = parcelRequire("1NBp8");

var $3hJpA = parcelRequire("3hJpA");

var $5nUIg = parcelRequire("5nUIg");

var $icONe = parcelRequire("icONe");

var $28V34 = parcelRequire("28V34");
const $be8d014ae40f1f99$var$i18n = (0, $2nPZH.defineMessages)({
    viewsSection: {
        id: "details-panel.activity-section.views-row",
        defaultMessage: "Views"
    }
});
const $be8d014ae40f1f99$var$ViewsRow = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, error: error, refetch: refetch, loading: loading, shouldHideViewsAnalytics: shouldHideViewsAnalytics } = (0, $3hJpA.useContentViews)();
    const { count: count } = data;
    const renderViewsItem = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
            width: "48px",
            height: "24px",
            borderRadius: 3,
            testId: "views-row-loading"
        });
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icONe.SubtleLink), {
            href: (0, $1NBp8.PAGE_ANALYTICS).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            }),
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    name: 'views'
                }
            }
        }, count);
    };
    return !shouldHideViewsAnalytics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($be8d014ae40f1f99$var$i18n.viewsSection),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: ""
        })
    }, renderViewsItem()) : null;
};
const $be8d014ae40f1f99$export$45a1c12e916e9584 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isNotFreeEdition = edition !== (0, $d9tcB.ConfluenceEdition).FREE;
    return isNotFreeEdition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($be8d014ae40f1f99$var$ViewsRow, null) : null;
};

});
parcelRegister("3hJpA", function(module, exports) {

$parcel$export(module.exports, "useContentViews", () => $e1afb2c18c2938ee$export$1a13176cfacebb13);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $cD1qu = parcelRequire("cD1qu");

var $htsj6 = parcelRequire("htsj6");

var $6nwwi = parcelRequire("6nwwi");

var $l8SzT = parcelRequire("l8SzT");
const $e1afb2c18c2938ee$var$useContentViewsDetailsPanelContentViewsQuery = (0, $d2LG0.default)`query useContentViewsDetailsPanelContentViewsQuery($contentId:ID!$isDraft:Boolean!){contentAnalyticsViewers(contentId:$contentId)@skip(if:$isDraft){count}user:confluence_atlassianUser(current:true){id confluence{permissionType}}}`;
const $e1afb2c18c2938ee$export$1a13176cfacebb13 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($e1afb2c18c2938ee$var$useContentViewsDetailsPanelContentViewsQuery, {
        variables: {
            contentId: contentId ?? '',
            isDraft: contentStatus === (0, $cD1qu.ContentStatus).DRAFT
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const isPermissionError = error && (0, $6nwwi.errorContainsCodes)(error, (0, $6nwwi.PERMISSION_ERROR_CODES));
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $l8SzT.normalizeContentViewsData)(data), [
        data
    ]);
    const { count: count, isInternalUser: isInternalUser, isSSRError: isSSRError } = normalizedData;
    const contentViewsError = contentStatusError || error;
    // It should not be possible for the user to see "0 views", since the user is technically viewing the page
    // at that moment. However, due to the eventually consistent behavior of the analytics data, it is possible
    // that 0 comes back from the analytics service.
    const adjustedCount = count === 0 ? 1 : count;
    return {
        data: {
            ...normalizedData,
            count: adjustedCount
        },
        loading: loading,
        error: contentViewsError,
        refetch: !!contentStatusError ? refetchContentStatus : refetch,
        shouldHideViewsAnalytics: Boolean(isPermissionError || !isInternalUser || isSSRError || contentViewsError || loading)
    };
};

});
parcelRegister("6nwwi", function(module, exports) {

$parcel$export(module.exports, "PERMISSION_ERROR_CODES", () => $8e5e49c94bc995d9$export$894159de174be35c);
$parcel$export(module.exports, "errorContainsCodes", () => $8e5e49c94bc995d9$export$8389c83400af11e2);

var $aTqya = parcelRequire("aTqya");
const $8e5e49c94bc995d9$export$894159de174be35c = [
    400,
    401,
    403
];
const $8e5e49c94bc995d9$export$8389c83400af11e2 = (error, expectedCodes)=>{
    if ((0, $aTqya.isApolloError)(error)) return error.graphQLErrors.some((e)=>expectedCodes.includes(e?.extensions?.statusCode));
    else return expectedCodes.includes(error?.extensions?.statusCode);
};

});

parcelRegister("l8SzT", function(module, exports) {

$parcel$export(module.exports, "normalizeContentViewsData", () => $1eee0af454f19ff4$export$468b695a94ab1e9b);

var $htgY9 = parcelRequire("htgY9");
const $1eee0af454f19ff4$export$468b695a94ab1e9b = (data)=>{
    const contentAnalyticsViewers = data?.contentAnalyticsViewers;
    const user = data?.user;
    return {
        count: contentAnalyticsViewers?.count,
        isInternalUser: user?.confluence?.permissionType === (0, $htgY9.SitePermissionType).INTERNAL,
        isSSRError: contentAnalyticsViewers === null
    };
};

});
parcelRegister("htgY9", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $f900541107f8b546$export$8995abb8169b2cb8);
/**
 * @generated SignedSource<<39d2453dc7c13b5654cfb1c99310e98e>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f900541107f8b546$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});



parcelRegister("icONe", function(module, exports) {

$parcel$export(module.exports, "SubtleLink", () => $a99dcf3b2d873545$export$902dde2c01bb0707);

var $gwFzn = parcelRequire("gwFzn");

var $6R5uz = parcelRequire("6R5uz");

var $8tdj3 = parcelRequire("8tdj3");

var $2Nwuj = parcelRequire("2Nwuj");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $2W0qg = parcelRequire("2W0qg");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");
const $a99dcf3b2d873545$var$pressableStyles = (0, $ecnYn.xcss)({
    ':hover': {
        textDecoration: 'underline'
    }
});
const $a99dcf3b2d873545$export$902dde2c01bb0707 = ({ href: href, children: children, onClick: onClick, onClickDisabled: onClickDisabled = false, analyticsContext: analyticsContext })=>{
    const linkContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.150"
    }, children, href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
        label: "",
        color: "var(--ds-icon-subtlest, #626F86)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: "",
        size: "small"
    })));
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        appearance: "subtle",
        href: href,
        analyticsContext: analyticsContext,
        onClick: onClick
    }, linkContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        onClick: onClick,
        analyticsContext: analyticsContext,
        padding: "space.100",
        backgroundColor: "color.background.neutral.subtle",
        xcss: $a99dcf3b2d873545$var$pressableStyles,
        isDisabled: onClickDisabled
    }, linkContent);
};

});



parcelRegister("b7jGt", function(module, exports) {

$parcel$export(module.exports, "InfoSection", () => $8b1e24b6aff8f803$export$b04644a04c64ee0c);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $5zuN8 = parcelRequire("5zuN8");

var $9wGTI = parcelRequire("9wGTI");

var $ep3mz = parcelRequire("ep3mz");

var $1ggpj = parcelRequire("1ggpj");

var $dIouf = parcelRequire("dIouf");

var $5qLRP = parcelRequire("5qLRP");

var $7Ewzl = parcelRequire("7Ewzl");

var $4e7cN = parcelRequire("4e7cN");

var $7KLbi = parcelRequire("7KLbi");

var $9peb5 = parcelRequire("9peb5");

var $2GaXa = parcelRequire("2GaXa");
const $8b1e24b6aff8f803$var$i18n = (0, $2nPZH.defineMessages)({
    propertiesSectionTitle: {
        id: "details-panel.info-section.title",
        defaultMessage: "Info"
    }
});
const $8b1e24b6aff8f803$var$propertiesSectionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginTop: 'space.300'
});
const $8b1e24b6aff8f803$export$b04644a04c64ee0c = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    const isClassificationRowVisible = (0, $7Ewzl.useClassificationVisibility)();
    const rowsToRender = [];
    if (isElementVisible((0, $5qLRP.ELEMENTS).ROWS.STATUS)) rowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $5zuN8.ContentStateStateContainer)
        ],
        key: (0, $5qLRP.ELEMENTS).ROWS.STATUS
    }, ({ state: state })=>{
        const { name: name = null, restrictionLevel: restrictionLevel, color: color = null } = state?.contentState ?? {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4e7cN.StatusRow), {
            name: name,
            restrictionLevel: restrictionLevel,
            color: color,
            isContentStateAvailable: !!state?.contentState
        });
    }));
    if (isClassificationRowVisible) rowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7KLbi.ClassificationRow), {
        key: "classification"
    }));
    if (isElementVisible((0, $5qLRP.ELEMENTS).ROWS.REDACTIONS) && (0, $9wGTI.fg)('dlp_cc-redactions-metadata-modal')) rowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2GaXa.RedactionsRow), {
        key: (0, $5qLRP.ELEMENTS).ROWS.REDACTIONS
    }));
    if (isElementVisible((0, $5qLRP.ELEMENTS).ROWS.LABELS)) rowsToRender.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9peb5.LabelsSection), {
        key: (0, $5qLRP.ELEMENTS).ROWS.LABELS
    }));
    let isInfoSectionTitleVisible = true;
    if (contentType === (0, $1ggpj.ContentType).WHITEBOARD && (0, $9wGTI.fg)('confluence_frontend_whiteboards_content_wrapper')) isInfoSectionTitleVisible = rowsToRender.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $8b1e24b6aff8f803$var$propertiesSectionStyles
    }, isInfoSectionTitleVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$8b1e24b6aff8f803$var$i18n.propertiesSectionTitle,
        tagName: "h4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, rowsToRender)));
};

});
parcelRegister("7Ewzl", function(module, exports) {

$parcel$export(module.exports, "useClassificationVisibility", () => $818e9fd1178a0334$export$fa044869294621ea);

var $ep3mz = parcelRequire("ep3mz");

var $aSsfA = parcelRequire("aSsfA");

var $a1qSg = parcelRequire("a1qSg");

var $cD1qu = parcelRequire("cD1qu");

var $1ggpj = parcelRequire("1ggpj");

var $7NYmK = parcelRequire("7NYmK");
const $818e9fd1178a0334$export$fa044869294621ea = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: data } = (0, $7NYmK.useContentClassification)();
    const { isEnabled: isDataClassificationEnabled } = (0, $a1qSg.useIsDataClassificationEnabledForOrg)();
    const isDataClassificationEmptyOnViewPage = pageMode === (0, $cD1qu.PageMode).VIEW && !data.classification;
    const isDataClassificationEnabledForContentType = contentType === (0, $1ggpj.ContentType).DATABASE || contentType === (0, $1ggpj.ContentType).WHITEBOARD;
    return isDataClassificationEnabled && (!isDataClassificationEmptyOnViewPage || isDataClassificationEnabledForContentType);
};

});
parcelRegister("7NYmK", function(module, exports) {

$parcel$export(module.exports, "useContentClassification", () => $99d8376f24017f55$export$e948ce957637ade5);

var $ep3mz = parcelRequire("ep3mz");

var $bFMG7 = parcelRequire("bFMG7");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $htsj6 = parcelRequire("htsj6");
const $99d8376f24017f55$export$e948ce957637ade5 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: contentStatus === (0, $cD1qu.ContentStatus).DRAFT || pageMode === (0, $cD1qu.PageMode).EDIT ? 'draft-only' : 'current-and-draft',
        shouldSkipQueries: !contentStatus,
        shouldReadFromQueries: true
    });
    const isContentClassificationMetadataLoading = contentClassificationMetadata.contentLevelLoading || contentClassificationMetadata.spaceLevelLoading;
    return {
        data: contentClassificationMetadata,
        loading: isContentStatusLoading || isContentClassificationMetadataLoading,
        error: contentStatusError,
        refetch: refetchContentStatus
    };
};

});


parcelRegister("4e7cN", function(module, exports) {

$parcel$export(module.exports, "StatusRow", () => $1645549588f034e2$export$8247e1fed55911f6);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $f2ref = parcelRequire("f2ref");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $5zuN8 = parcelRequire("5zuN8");

var $lfBMY = parcelRequire("lfBMY");
var $2wo33 = parcelRequire("2wo33");

var $efvKr = parcelRequire("efvKr");

var $ep3mz = parcelRequire("ep3mz");

var $aSsfA = parcelRequire("aSsfA");

var $htsj6 = parcelRequire("htsj6");

var $cD1qu = parcelRequire("cD1qu");

var $kcW5o = parcelRequire("kcW5o");

var $cgWYg = parcelRequire("cgWYg");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");
const $1645549588f034e2$var$i18n = (0, $2nPZH.defineMessages)({
    status: {
        id: "details-panel.properties-section.status-row",
        defaultMessage: "Status"
    }
});
const $1645549588f034e2$var$readOnlyStatusStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.025'
});
const $1645549588f034e2$var$readOnlyTextStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.025',
    marginRight: 'space.025'
});
const $1645549588f034e2$var$StatusRowComponent = ({ color: color, restrictionLevel: restrictionLevel, name: name, contentId: contentId, contentType: contentType, userOffline: userOffline, isEditAllowed: isEditAllowed })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `button`,
                actionSubjectId: 'SidePanelStatus',
                source: 'contentWrapper'
            }
        }).fire();
    };
    return isEditAllowed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.EditorContentState), {
        contentId: contentId,
        contentType: contentType,
        userOffline: userOffline,
        renderPlusButtonEmptyState: true,
        isDetailsPanel: true,
        onClick: onClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        xcss: [
            $1645549588f034e2$var$readOnlyStatusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5zuN8.ContentStateColor), {
        color: color,
        // (Make sure that the colorAppearance is set to the same value as used in the editable
        //  version found in next/packages/content-state/src/EditorContentState/ContentStateButton.tsx)
        appearance: "rendererContentState",
        restrictionLevel: restrictionLevel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            $1645549588f034e2$var$readOnlyTextStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), null, name)));
};
const $1645549588f034e2$export$8247e1fed55911f6 = (contentState)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { data: data, error: error, refetch: refetch } = (0, $kcW5o.useContentState)(contentState);
    const { color: color, restrictionLevel: restrictionLevel, name: name } = data;
    const isContentStateAvailable = !!color || !!restrictionLevel || !!name;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const isDisconnected = (0, $cgWYg.useIsDisconnected)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const isContentStateEditable = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode;
    const [canUpdateContent] = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE,
        status: contentStatus === (0, $cD1qu.ContentStatus).DRAFT ? (0, $cD1qu.DRAFT_STATUS) : (0, $cD1qu.CURRENT_STATUS)
    });
    const hasEditPermission = canUpdateContent ?? false;
    const isEditAllowed = isContentStateEditable && hasEditPermission;
    // If we don't have a content state and the user is unable to add one (either from the content
    // mode they're in or because they don't have permissions), we should hide the entire row.  But
    // if there is an error, we should show the row with an error message.
    if (!isContentStateAvailable && !isEditAllowed && !error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($1645549588f034e2$var$i18n.status),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f2ref))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1645549588f034e2$var$StatusRowComponent, {
        name: name,
        color: color,
        restrictionLevel: restrictionLevel,
        contentId: contentId,
        contentType: contentType,
        userOffline: isDisconnected,
        isEditAllowed: isEditAllowed
    }));
};

});
parcelRegister("f2ref", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71ef751f533bce45a13de245b7790ab8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af2c29fb252cdc34$var$_react = $af2c29fb252cdc34$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $af2c29fb252cdc34$var$_baseNew = $af2c29fb252cdc34$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $af2c29fb252cdc34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ProjectStatus".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing project status in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af2c29fb252cdc34$var$ProjectStatusIcon = (props)=>/*#__PURE__*/ $af2c29fb252cdc34$var$_react.default.createElement($af2c29fb252cdc34$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.625A2.625 2.625 0 0 1 6.125 0h3.75A2.625 2.625 0 0 1 12.5 2.625v8.75A2.625 2.625 0 0 1 9.875 14H8.75v2h-1.5v-2H6.125A2.625 2.625 0 0 1 3.5 11.375zM6.125 1.5C5.504 1.5 5 2.004 5 2.625v8.75c0 .621.504 1.125 1.125 1.125h3.75c.621 0 1.125-.504 1.125-1.125v-8.75c0-.621-.504-1.125-1.125-1.125zM6.5 4.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$af2c29fb252cdc34$var$ProjectStatusIcon.displayName = 'ProjectStatusIcon';
var $af2c29fb252cdc34$var$_default = module.exports.default = $af2c29fb252cdc34$var$ProjectStatusIcon;

});

parcelRegister("kcW5o", function(module, exports) {

$parcel$export(module.exports, "useContentState", () => $dee56617ba39171d$export$b49d63386d42e7ce);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $htsj6 = parcelRequire("htsj6");

var $dcvEe = parcelRequire("dcvEe");
const $dee56617ba39171d$var$useContentStateDetailsPanelSingleContentStateQuery = (0, $d2LG0.default)`query useContentStateDetailsPanelSingleContentStateQuery($contentId:ID!$isDraft:Boolean!$status:String!){singleContent(id:$contentId status:[$status]){contentState(isDraft:$isDraft){id name color restrictionLevel}}}`;
const $dee56617ba39171d$export$b49d63386d42e7ce = ({ isContentStateAvailable: isContentStateAvailable, ...contentState })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)({
        skip: isContentStateAvailable
    });
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($dee56617ba39171d$var$useContentStateDetailsPanelSingleContentStateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? '',
            isDraft: contentStatus === (0, $cD1qu.ContentStatus).DRAFT || pageMode === (0, $cD1qu.PageMode).EDIT
        },
        skip: isContentStateAvailable || isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $dcvEe.normalizeContentStatusData)(data), [
        data
    ]);
    return {
        data: isContentStateAvailable ? contentState : normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};

});
parcelRegister("dcvEe", function(module, exports) {

$parcel$export(module.exports, "normalizeContentStatusData", () => $dab8395378de95b8$export$2a267772604a148a);
const $dab8395378de95b8$export$2a267772604a148a = (data)=>{
    const singleContentState = data?.singleContent?.contentState;
    return {
        color: singleContentState?.color ?? '',
        restrictionLevel: singleContentState?.restrictionLevel,
        name: singleContentState?.name ?? ''
    };
};

});


parcelRegister("cgWYg", function(module, exports) {

$parcel$export(module.exports, "useIsDisconnected", () => $2b51e0f1dd6c16f4$export$e5d3711429b4ff8);

var $gwFzn = parcelRequire("gwFzn");

var $jXpbL = parcelRequire("jXpbL");
const $2b51e0f1dd6c16f4$export$e5d3711429b4ff8 = ()=>{
    const [isDisconnected, setIsDisconnected] = (0, $gwFzn.useState)(false);
    const [{ collabEditProvider: collabEditProvider }] = (0, $jXpbL.useNativeCollabState)();
    const handleDisconnected = ()=>{
        setIsDisconnected(true);
    };
    const handleConnected = ()=>{
        setIsDisconnected(false);
    };
    (0, $gwFzn.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('connected', handleConnected);
        collabEditProvider.on('disconnected', handleDisconnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
            collabEditProvider.off('disconnected', handleDisconnected);
        };
    });
    return isDisconnected;
};

});


parcelRegister("7KLbi", function(module, exports) {

$parcel$export(module.exports, "ClassificationRow", () => $ad489d36268c3761$export$b3b8c7ca0930ec22);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $4GKfl = parcelRequire("4GKfl");

var $kpYGL = parcelRequire("kpYGL");

var $a1qSg = parcelRequire("a1qSg");

var $ep3mz = parcelRequire("ep3mz");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $1ggpj = parcelRequire("1ggpj");

var $7NYmK = parcelRequire("7NYmK");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");

var $57Lsu = parcelRequire("57Lsu");
const $ad489d36268c3761$var$i18n = (0, $2nPZH.defineMessages)({
    classificationSection: {
        id: "details-panel.activity-section.classification-row",
        defaultMessage: "Classification"
    }
});
const $ad489d36268c3761$export$b3b8c7ca0930ec22 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $7NYmK.useContentClassification)();
    const shouldRenderContentClassificationTag = contentType === (0, $1ggpj.ContentType).PAGE && (pageMode === (0, $cD1qu.PageMode).VIEW || data.flagStatus === (0, $a1qSg.FlagStatus).LOADING);
    const renderClassificationItem = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
            width: "80px",
            height: "24px",
            borderRadius: 3,
            testId: "classification-row-loading"
        });
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        return shouldRenderContentClassificationTag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a1qSg.ContentClassificationTag), {
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            contentClassificationMetadata: data
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $57Lsu.ContentClassifier), {
            contentClassificationMetadata: data
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($ad489d36268c3761$var$i18n.classificationSection),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GKfl))), {
            label: ""
        })
    }, renderClassificationItem());
};

});
parcelRegister("57Lsu", function(module, exports) {

$parcel$export(module.exports, "ContentClassifier", () => $1ff51c643c4d2c97$export$97f94bd873b44a4d);

var $gwFzn = parcelRequire("gwFzn");

var $a1qSg = parcelRequire("a1qSg");

var $ep3mz = parcelRequire("ep3mz");

var $lfBMY = parcelRequire("lfBMY");
var $2wo33 = parcelRequire("2wo33");

var $htsj6 = parcelRequire("htsj6");

var $cD1qu = parcelRequire("cD1qu");

var $cgWYg = parcelRequire("cgWYg");

var $dgM7K = parcelRequire("dgM7K");
const $1ff51c643c4d2c97$export$97f94bd873b44a4d = ({ contentClassificationMetadata: contentClassificationMetadata })=>{
    const isDisconnected = (0, $cgWYg.useIsDisconnected)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const [canUpdateContent] = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE,
        status: contentStatus === (0, $cD1qu.ContentStatus).DRAFT ? (0, $cD1qu.DRAFT_STATUS) : (0, $cD1qu.CURRENT_STATUS)
    });
    const hasEditPermission = canUpdateContent ?? false;
    return contentClassificationMetadata.classification ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a1qSg.ContentTypeClassification), {
        spaceKey: spaceKey ?? '',
        contentId: contentId ?? '',
        userOffline: isDisconnected,
        readOnly: !hasEditPermission,
        contentType: contentType ?? '',
        contentClassificationMetadata: contentClassificationMetadata,
        popupPlacementOverride: "bottom-end"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a1qSg.ClassificationModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dgM7K.AddClassification), {
        contentClassificationMetadata: contentClassificationMetadata,
        hasEditPermission: hasEditPermission
    }));
};

});
parcelRegister("dgM7K", function(module, exports) {

$parcel$export(module.exports, "AddClassification", () => $1e6ecfc6de672e3a$export$f0f12fa5eded4386);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $g5gZt = parcelRequire("g5gZt");

var $1qfLF = parcelRequire("1qfLF");

var $inPa6 = parcelRequire("inPa6");

var $a1qSg = parcelRequire("a1qSg");

var $hyiip = parcelRequire("hyiip");

var $ep3mz = parcelRequire("ep3mz");
const $1e6ecfc6de672e3a$var$i18n = (0, $2nPZH.defineMessages)({
    addClassificationLabel: {
        id: "details-panel.activity-section.classification-row.add-classification-label",
        defaultMessage: "Add classification"
    }
});
const $1e6ecfc6de672e3a$export$f0f12fa5eded4386 = ({ contentClassificationMetadata: contentClassificationMetadata, hasEditPermission: hasEditPermission })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $a1qSg.useClassificationModalDispatchContext)();
    const preloadClassificationEditorQueries = (0, $hyiip.usePreloadClassificationEditorQueries)({
        spaceKey: spaceKey
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = ()=>{
        setIsClassificationModalOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `button`,
                actionSubjectId: 'SidePanelClassification',
                source: 'contentWrapper'
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
        label: formatMessage($1e6ecfc6de672e3a$var$i18n.addClassificationLabel),
        onClick: onClick,
        isDisabled: !hasEditPermission,
        onMouseEnter: preloadClassificationEditorQueries
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a1qSg.ClassificationEditModal), {
        contentId: contentId ?? '',
        spaceKey: spaceKey ?? '',
        contentClassificationMetadata: contentClassificationMetadata
    }));
};

});



parcelRegister("9peb5", function(module, exports) {

$parcel$export(module.exports, "LabelsSection", () => $a85fb67b97f12834$export$875bcf10b1b6719c);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $g5gZt = parcelRequire("g5gZt");

var $av0Vd = parcelRequire("av0Vd");

var $eyWa4 = parcelRequire("eyWa4");

var $ep3mz = parcelRequire("ep3mz");

var $8aF6s = parcelRequire("8aF6s");

var $4vaoM = parcelRequire("4vaoM");

var $3l7KO = parcelRequire("3l7KO");

var $28V34 = parcelRequire("28V34");

var $5nUIg = parcelRequire("5nUIg");

var $24Xaw = parcelRequire("24Xaw");
const $a85fb67b97f12834$var$i18n = (0, $2nPZH.defineMessages)({
    labelsSectionTitle: {
        id: "details-panel.labels-section.title",
        defaultMessage: "Labels"
    },
    addButtonLabel: {
        id: "details-panel.labels-section.add-button-label",
        defaultMessage: "Add label"
    }
});
const $a85fb67b97f12834$export$875bcf10b1b6719c = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { data: data, error: error, refetch: refetch, handleDeleteLabelClick: handleDeleteLabelClick, loading: loading } = (0, $3l7KO.useContentLabels)();
    const { labels: labels, hasEditPermissions: hasEditPermissions } = data;
    const renderLabelsSectionContent = ()=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        return hasEditPermissions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
            label: formatMessage($a85fb67b97f12834$var$i18n.addButtonLabel),
            onClick: ()=>showModal((0, $4vaoM.EditLabelDialogLoader), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    source: 'detailsPanel'
                }),
            isDisabled: !contentId || !spaceKey || loading,
            testId: "add-label-button"
        }) : null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.050",
        testId: "labels-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($a85fb67b97f12834$var$i18n.labelsSectionTitle),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
            label: ""
        })
    }, renderLabelsSectionContent()), labels.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $24Xaw.Labels), {
        labels: labels,
        refetch: refetch,
        hasEditPermissions: hasEditPermissions,
        handleDeleteLabelClick: handleDeleteLabelClick
    }));
};

});
parcelRegister("3l7KO", function(module, exports) {

$parcel$export(module.exports, "useContentLabels", () => $b684b72ae3cf6eec$export$6a1788a7b791cea2);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $a9Ftk = parcelRequire("a9Ftk");
const $b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelsQuery = (0, $d2LG0.default)`query useContentLabelsDetailsPanelContentLabelsQuery($contentId:ID!){singleContent(id:$contentId){id labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){count nodes{id label name prefix}}}content(id:$contentId status:["archived" "current" "draft"]){nodes{id type operations{operation targetType}}}}`;
const $b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelDeleteMutation = (0, $d2LG0.default)`mutation useContentLabelsDetailsPanelContentLabelDeleteMutation($contentId:ID!$label:String!){deleteLabel(input:{contentId:$contentId label:$label}){contentId}}`;
const $b684b72ae3cf6eec$export$6a1788a7b791cea2 = ()=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelsQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    const [handleDeleteLabelClick] = (0, $j1Ss3.useMutation)($b684b72ae3cf6eec$var$useContentLabelsDetailsPanelContentLabelDeleteMutation);
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $a9Ftk.normalizeContentLabelsData)(data), [
        data
    ]);
    return {
        data: normalizedData,
        handleDeleteLabelClick: handleDeleteLabelClick,
        loading: loading,
        error: error,
        refetch: refetch
    };
};

});
parcelRegister("a9Ftk", function(module, exports) {

$parcel$export(module.exports, "normalizeContentLabelsData", () => $02e404c086402fb8$export$1dee72c052fd59a0);
const $02e404c086402fb8$export$1dee72c052fd59a0 = (data)=>{
    const labels = data?.singleContent?.labels;
    const firstNode = data?.content?.nodes?.[0];
    const operations = firstNode?.operations ?? [];
    const type = firstNode?.type;
    const hasEditPermissions = Boolean(operations?.find((item)=>item?.operation === 'update' && item?.targetType === type));
    return {
        labels: labels?.nodes ?? [],
        hasEditPermissions: hasEditPermissions
    };
};

});


parcelRegister("24Xaw", function(module, exports) {

$parcel$export(module.exports, "Labels", () => $2f2b8fc01346dbda$export$c9ed62821215deda);
/* Labels.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $3WVxj = parcelRequire("3WVxj");
var $ho4zm = parcelRequire("ho4zm");

var $9wGTI = parcelRequire("9wGTI");

var $ep3mz = parcelRequire("ep3mz");

var $1NBp8 = parcelRequire("1NBp8");
const $2f2b8fc01346dbda$var$labelsStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.250'
});
const $2f2b8fc01346dbda$var$labelLinkStyles = null;
const $2f2b8fc01346dbda$var$Label = ({ label: label, hasEditPermissions: hasEditPermissions, refetch: refetch, handleDeleteLabelClick: handleDeleteLabelClick })=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const [spaceKey = ''] = (0, $ep3mz.usePageSpaceKey)();
    const handleRemove = async ()=>{
        await handleDeleteLabelClick({
            variables: {
                contentId: contentId,
                label: label
            }
        });
        await refetch();
    };
    if ((0, $9wGTI.fg)('confluence_make_labels_clickable_content_wrapper')) {
        const labelUrl = (0, $1NBp8.LABELLED_CONTENT).toUrl({
            spaceKey: spaceKey,
            labelName: encodeURIComponent(label)
        });
        return hasEditPermissions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3WVxj.default), {
            key: label,
            text: label,
            onAfterRemoveAction: handleRemove,
            href: labelUrl,
            linkComponent: ({ href: href, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                    href: href,
                    className: (0, $35pXk.default)([
                        "_4bfu18uv _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _syaz1kw7 _1bto1l2s _o5721q9c _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _10531kw7"
                    ])
                }, children)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ho4zm.default), {
            testId: "readonly-label",
            key: label,
            text: label,
            href: labelUrl,
            linkComponent: ({ href: href, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                    href: href,
                    className: (0, $35pXk.default)([
                        "_4bfu18uv _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _syaz1kw7 _1bto1l2s _o5721q9c _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8h1kw7 _f8pj1kw7 _30l31kw7 _10531kw7"
                    ])
                }, children)
        });
    } else return hasEditPermissions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3WVxj.default), {
        key: label,
        text: label,
        onAfterRemoveAction: handleRemove
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ho4zm.default), {
        testId: "readonly-label",
        key: label,
        text: label
    });
};
const $2f2b8fc01346dbda$export$c9ed62821215deda = ({ labels: labels, refetch: refetch, hasEditPermissions: hasEditPermissions, handleDeleteLabelClick: handleDeleteLabelClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $2f2b8fc01346dbda$var$labelsStyles,
        direction: "row",
        alignItems: "center",
        wrap: "wrap"
    }, labels.map((labelNode)=>labelNode?.label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2f2b8fc01346dbda$var$Label, {
            refetch: refetch,
            key: labelNode.label,
            label: labelNode.label,
            hasEditPermissions: hasEditPermissions,
            handleDeleteLabelClick: handleDeleteLabelClick
        }) : null));

});


parcelRegister("2GaXa", function(module, exports) {

$parcel$export(module.exports, "RedactionsRow", () => $9c39d074e22d6463$export$e1c60e781522ee95);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6ZUmE = parcelRequire("6ZUmE");

var $a2EO8 = parcelRequire("a2EO8");

var $8aF6s = parcelRequire("8aF6s");

var $ep3mz = parcelRequire("ep3mz");

var $bUyqE = parcelRequire("bUyqE");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");

var $icONe = parcelRequire("icONe");
const $9c39d074e22d6463$var$i18n = (0, $2nPZH.defineMessages)({
    redactionsSection: {
        id: "details-panel.properties-section.redaction-row",
        defaultMessage: "Redactions"
    }
});
const $9c39d074e22d6463$export$e1c60e781522ee95 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { redactionMetadataCount: redactionMetadataCount, error: error, refetch: refetch } = (0, $bUyqE.useContentRedactions)();
    const handleRedactionsItemClick = (0, $gwFzn.useCallback)(()=>{
        showModal((0, $a2EO8.RedactionsDialogLoader), {
            contentId: contentId
        });
    }, [
        showModal,
        contentId
    ]);
    if (!redactionMetadataCount && !error) return null;
    const renderRedactionsItem = ()=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icONe.SubtleLink), {
            onClick: handleRedactionsItemClick,
            onClickDisabled: !contentId,
            analyticsContext: {
                source: 'contentWrapper',
                attributes: {
                    name: 'redactions',
                    count: redactionMetadataCount
                }
            }
        }, `${redactionMetadataCount}`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($9c39d074e22d6463$var$i18n.redactionsSection),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6ZUmE))), {
            label: ""
        })
    }, renderRedactionsItem());
};

});
parcelRegister("6ZUmE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ae0b716cc084036e713588fae9ee233>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $51842962f4cce9a4$var$_react = $51842962f4cce9a4$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $51842962f4cce9a4$var$_baseNew = $51842962f4cce9a4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $51842962f4cce9a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MinusSquare".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Remove feature' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $51842962f4cce9a4$var$MinusSquareIcon = (props)=>/*#__PURE__*/ $51842962f4cce9a4$var$_react.default.createElement($51842962f4cce9a4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 7.25v1.5H4v-1.5zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$51842962f4cce9a4$var$MinusSquareIcon.displayName = 'MinusSquareIcon';
var $51842962f4cce9a4$var$_default = module.exports.default = $51842962f4cce9a4$var$MinusSquareIcon;

});

parcelRegister("a2EO8", function(module, exports) {

$parcel$export(module.exports, "RedactionsDialogLoader", () => $657b32c3d4149a70$export$4f8d688880428f81);

var $jmjWc = parcelRequire("jmjWc");

const $657b32c3d4149a70$export$4f8d688880428f81 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Hu3kQ",
    name: "RedactionsDialogLoader",
    loader: async ()=>(await (parcelRequire("csMtY"))).RedactionsDialog
});

});
parcelRegister("csMtY", function(module, exports) {

let $912db524ba8d873f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $912db524ba8d873f$var$load("gYKCE"),
    $912db524ba8d873f$var$load("1FzbR")
]).then(()=>parcelRequire('iWY6a'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("bUyqE", function(module, exports) {

$parcel$export(module.exports, "useContentRedactions", () => $5cac77383b408187$export$5eb1a235a3599ccb);
/**
 * @graphql cc
 */ 
var $j1Ss3 = parcelRequire("j1Ss3");

var $lfBMY = parcelRequire("lfBMY");
var $2wo33 = parcelRequire("2wo33");

var $aMcHK = parcelRequire("aMcHK");

var $7Sm4c = parcelRequire("7Sm4c");

var $ep3mz = parcelRequire("ep3mz");

var $byF4U = parcelRequire("byF4U");
const $5cac77383b408187$export$5eb1a235a3599ccb = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    // Only users with "Edit" permission should be able to see the redaction metadata
    const [canUpdateContent] = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE
    });
    const { data: data, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $byF4U.DetailsPanelRedactionsRowQuery), {
        skip: !contentId || !canUpdateContent,
        variables: {
            contentId: contentId ?? ''
        },
        errorPolicy: 'all'
    });
    if ((0, $aMcHK.isStatusCodeError)(error, '404')) (0, $7Sm4c.markErrorAsHandled)(error);
    // As we will render nothing for the item, if loading, unentitled, or no redactions,
    // zero is fine as a default
    const redactionMetadataCount = data?.singleContent?.redactionMetadataCount ?? 0;
    return {
        redactionMetadataCount: redactionMetadataCount,
        error: !(0, $aMcHK.isStatusCodeError)(error, '404') ? error : null,
        refetch: refetch
    };
};

});
parcelRegister("byF4U", function(module, exports) {

$parcel$export(module.exports, "DetailsPanelRedactionsRowQuery", () => $a8249b7ea6acc225$export$41d44f18573bbe1d);

var $d2LG0 = parcelRequire("d2LG0");
const $a8249b7ea6acc225$export$41d44f18573bbe1d = (0, $d2LG0.default)`query DetailsPanelRedactionsRowQuery($contentId:ID!){singleContent(id:$contentId){id redactionMetadataCount}}`;

});




parcelRegister("hkxWH", function(module, exports) {

$parcel$export(module.exports, "ConnectionsSection", () => $78f5f8494339f666$export$62aa1e9cfa771dff);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $dIouf = parcelRequire("dIouf");

var $5qLRP = parcelRequire("5qLRP");

var $apvBW = parcelRequire("apvBW");

var $74jHm = parcelRequire("74jHm");

var $5qSDQ = parcelRequire("5qSDQ");

var $2ifi0 = parcelRequire("2ifi0");

var $g7mkQ = parcelRequire("g7mkQ");
const $78f5f8494339f666$var$i18n = (0, $2nPZH.defineMessages)({
    connectionsSectionTitle: {
        id: "details-panel.connections-section.title",
        defaultMessage: "Connections"
    }
});
const $78f5f8494339f666$var$connectionsSectionStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginTop: 'space.300'
});
const $78f5f8494339f666$export$62aa1e9cfa771dff = ()=>{
    const { isElementVisible: isElementVisible } = (0, $5qLRP.useElementVisibility)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        testId: "connections-section",
        xcss: $78f5f8494339f666$var$connectionsSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$78f5f8494339f666$var$i18n.connectionsSectionTitle,
        tagName: "h4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $apvBW.IncomingLinksRow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $74jHm.OutgoingLinksRow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g7mkQ.FilesRow), null), isElementVisible((0, $5qLRP.ELEMENTS).ROWS.CUSTOM_CONTENT) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2ifi0.CustomContentRow), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5qSDQ.JiraWorkItemsRow), null))));
};

});
parcelRegister("apvBW", function(module, exports) {

$parcel$export(module.exports, "IncomingLinksRow", () => $d3938577f77dcc89$export$73809ff06e5069c3);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $h3IRN = parcelRequire("h3IRN");

var $jlIaF = parcelRequire("jlIaF");

var $ep3mz = parcelRequire("ep3mz");

var $dhPe7 = parcelRequire("dhPe7");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");

var $icONe = parcelRequire("icONe");
const $d3938577f77dcc89$var$i18n = (0, $2nPZH.defineMessages)({
    incomingLinks: {
        id: "details-panel.links-section.incoming-links-row",
        defaultMessage: "Incoming links"
    }
});
const $d3938577f77dcc89$var$linkLimit = 50;
const $d3938577f77dcc89$export$73809ff06e5069c3 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, error: error, refetch: refetch } = (0, $dhPe7.useContentLinks)($d3938577f77dcc89$var$linkLimit);
    const { incomingLinksCount: incomingLinksCount, incomingLinksHasMore: incomingLinksHasMore } = data;
    if (!incomingLinksCount && !error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "incoming-links-empty-row"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($d3938577f77dcc89$var$i18n.incomingLinks),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h3IRN))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icONe.SubtleLink), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewinfo.action?pageId=${contentId}`,
        analyticsContext: {
            source: 'contentWrapper',
            attributes: {
                name: 'incomingLinks',
                count: incomingLinksCount,
                hasMore: incomingLinksHasMore
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "incoming-links-count"
    }, incomingLinksCount, incomingLinksHasMore ? '+' : '')));
};

});
parcelRegister("h3IRN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ffff7202cd67f8c9c302ff5b8d43ddd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6b5850b2c5125f3$var$_react = $c6b5850b2c5125f3$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c6b5850b2c5125f3$var$_baseNew = $c6b5850b2c5125f3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c6b5850b2c5125f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDownLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Adding content from Rovo Chat into Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6b5850b2c5125f3$var$ArrowDownLeftIcon = (props)=>/*#__PURE__*/ $c6b5850b2c5125f3$var$_react.default.createElement($c6b5850b2c5125f3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.06 12h5.19v1.5h-7a.75.75 0 0 1-.75-.75v-7H4v5.19l8.47-8.47 1.06 1.06z" clip-rule="evenodd"/>`
    }, props));
$c6b5850b2c5125f3$var$ArrowDownLeftIcon.displayName = 'ArrowDownLeftIcon';
var $c6b5850b2c5125f3$var$_default = module.exports.default = $c6b5850b2c5125f3$var$ArrowDownLeftIcon;

});

parcelRegister("dhPe7", function(module, exports) {

$parcel$export(module.exports, "useContentLinks", () => $63c497c9210162c7$export$f8e4890e95352afe);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $htsj6 = parcelRequire("htsj6");

var $3HBPy = parcelRequire("3HBPy");
const $63c497c9210162c7$var$useContentLinksDetailsPanelContentLinksQuery = (0, $d2LG0.default)`query useContentLinksDetailsPanelContentLinksQuery($contentId:ID!$status:String!$limit:Int!){singleContent(id:$contentId status:[$status]){id incomingLinks(first:$limit){count pageInfo{hasNextPage}}outgoingLinks{internalOutgoingLinks(first:$limit){count pageInfo{hasNextPage}}externalOutgoingLinks(first:$limit){count pageInfo{hasNextPage}}}}}`;
const $63c497c9210162c7$export$f8e4890e95352afe = (linkLimit)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($63c497c9210162c7$var$useContentLinksDetailsPanelContentLinksQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? '',
            limit: linkLimit
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $3HBPy.normalizeContentLinksData)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};

});
parcelRegister("3HBPy", function(module, exports) {

$parcel$export(module.exports, "normalizeContentLinksData", () => $add3920876d5aeb4$export$51d7c1016ebf3ff1);
const $add3920876d5aeb4$export$51d7c1016ebf3ff1 = (data)=>({
        incomingLinksCount: data?.singleContent?.incomingLinks?.count ?? 0,
        incomingLinksHasMore: data?.singleContent?.incomingLinks?.pageInfo?.hasNextPage ?? false,
        internalOutgoingLinksCount: data?.singleContent?.outgoingLinks?.internalOutgoingLinks?.count ?? 0,
        internalOutgoingLinksHasMore: data?.singleContent?.outgoingLinks?.internalOutgoingLinks?.pageInfo?.hasNextPage ?? false,
        externalOutgoingLinksCount: data?.singleContent?.outgoingLinks?.externalOutgoingLinks?.count ?? 0,
        externalOutgoingLinksHasMore: data?.singleContent?.outgoingLinks?.externalOutgoingLinks?.pageInfo?.hasNextPage ?? false
    });

});



parcelRegister("74jHm", function(module, exports) {

$parcel$export(module.exports, "OutgoingLinksRow", () => $54c4b47034898c7f$export$745e6d0a4023e79a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $69PnT = parcelRequire("69PnT");

var $jlIaF = parcelRequire("jlIaF");

var $ep3mz = parcelRequire("ep3mz");

var $dhPe7 = parcelRequire("dhPe7");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");

var $icONe = parcelRequire("icONe");
const $54c4b47034898c7f$var$i18n = (0, $2nPZH.defineMessages)({
    outgoingLinks: {
        id: "details-panel.links-section.outgoing-links-row",
        defaultMessage: "Outgoing links"
    }
});
const $54c4b47034898c7f$var$linkLimit = 50;
const $54c4b47034898c7f$export$745e6d0a4023e79a = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, error: error, refetch: refetch } = (0, $dhPe7.useContentLinks)($54c4b47034898c7f$var$linkLimit);
    const { internalOutgoingLinksCount: internalOutgoingLinksCount, internalOutgoingLinksHasMore: internalOutgoingLinksHasMore, externalOutgoingLinksCount: externalOutgoingLinksCount, externalOutgoingLinksHasMore: externalOutgoingLinksHasMore } = data;
    let outgoingLinksCount = internalOutgoingLinksCount + externalOutgoingLinksCount;
    let hasMoreOutgoingLinks = internalOutgoingLinksHasMore || externalOutgoingLinksHasMore;
    if (outgoingLinksCount > $54c4b47034898c7f$var$linkLimit) {
        outgoingLinksCount = $54c4b47034898c7f$var$linkLimit;
        hasMoreOutgoingLinks = true;
    }
    if (!outgoingLinksCount && !error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "outgoing-links-empty-row"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($54c4b47034898c7f$var$i18n.outgoingLinks),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($69PnT))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icONe.SubtleLink), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewinfo.action?pageId=${contentId}`,
        analyticsContext: {
            source: 'contentWrapper',
            attributes: {
                name: 'outgoingLinks',
                count: outgoingLinksCount,
                hasMore: hasMoreOutgoingLinks
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "outgoing-links-count"
    }, outgoingLinksCount, hasMoreOutgoingLinks ? '+' : '')));
};

});

parcelRegister("5qSDQ", function(module, exports) {

$parcel$export(module.exports, "JiraWorkItemsRow", () => $99e0d826fd8e4a43$export$ffa1ac485496a25b);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $7ZcJJ = parcelRequire("7ZcJJ");

var $inPa6 = parcelRequire("inPa6");

var $3jwuS = parcelRequire("3jwuS");

var $de2j9 = parcelRequire("de2j9");

var $cQncU = parcelRequire("cQncU");

var $1ni5F = parcelRequire("1ni5F");

var $5nUIg = parcelRequire("5nUIg");

var $icONe = parcelRequire("icONe");

var $28V34 = parcelRequire("28V34");
const $99e0d826fd8e4a43$var$i18n = (0, $2nPZH.defineMessages)({
    jiraWorkItems: {
        id: "details-panel.links-section.jira-work-items-row",
        defaultMessage: "Jira work items"
    },
    jiraWorkItem: {
        id: "details-panel.links-section.jira-work-item-row",
        defaultMessage: "Jira work item"
    }
});
const $99e0d826fd8e4a43$export$ffa1ac485496a25b = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, isLoading: isLoading, error: error, refetch: refetch } = (0, $1ni5F.useGetJiraMetadata)();
    const { showJiraWorkItemsPanel: showJiraWorkItemsPanel } = (0, $cQncU.useShowJiraWorkItemsPanel)(data);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const shouldRenderDetailRow = (0, $gwFzn.useMemo)(()=>!isLivePage && !isOnEditRoute && !isLoading && (data && data.count > 0 || error), [
        isLivePage,
        isOnEditRoute,
        isLoading,
        data,
        error
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldRenderDetailRow && !error) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: 'jiraWorkItemsRow',
                source: 'linkedJiraWorkItems',
                attributes: {
                    count: data?.count
                }
            }
        }).fire();
    }, [
        shouldRenderDetailRow,
        error,
        createAnalyticsEvent,
        data
    ]);
    return shouldRenderDetailRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage(data && data.count > 1 ? $99e0d826fd8e4a43$var$i18n.jiraWorkItems : $99e0d826fd8e4a43$var$i18n.jiraWorkItem),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icONe.SubtleLink), {
        onClick: showJiraWorkItemsPanel,
        analyticsContext: {
            source: 'contentWrapper',
            attributes: {
                name: 'jiraWorkItems',
                count: data?.count
            }
        }
    }, data?.count)) : null;
};

});
parcelRegister("cQncU", function(module, exports) {

$parcel$export(module.exports, "useShowJiraWorkItemsPanel", () => $6413d1effe174ea4$export$11974192ac11a6be);

var $2nPZH = parcelRequire("2nPZH");

var $aWwYt = parcelRequire("aWwYt");

var $5Hdxs = parcelRequire("5Hdxs");

var $dSBea = parcelRequire("dSBea");

var $dT4iS = parcelRequire("dT4iS");
const $6413d1effe174ea4$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    jiraWorkItemsPanelHeaderLabel: {
        id: "details-panel.jira-work-items.header.label",
        defaultMessage: "Jira work items"
    }
});
const $6413d1effe174ea4$export$11974192ac11a6be = (jiraMetaData)=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panelId = 'jiraWorkItemsPanel';
    const showJiraWorkItemsPanel = ()=>{
        showObjectSidebar({
            id: panelId,
            headerComponentElements: {
                HeaderIcon: (0, $dSBea.JiraWorkItemsPanelIcon),
                headerLabel: $6413d1effe174ea4$export$a7357cdd1f0b0168.jiraWorkItemsPanelHeaderLabel,
                HeaderBeforeIconElement: (0, $dT4iS.JiraWorkItemsHeaderNavigation)
            },
            BodyComponent: ()=>(0, $5Hdxs.JiraWorkItemsPanelBody)(jiraMetaData)
        }, 'push');
    };
    return {
        isJiraWorkItemsPanelShown: isObjectSidebarShown && panel?.id === panelId,
        showJiraWorkItemsPanel: showJiraWorkItemsPanel
    };
};

});
parcelRegister("5Hdxs", function(module, exports) {

$parcel$export(module.exports, "JiraWorkItemsPanelBody", () => $379586560174b3c0$export$b5fd1500b92a9599);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $hpUsb = parcelRequire("hpUsb");

var $bYRk6 = parcelRequire("bYRk6");

var $7hXDW = parcelRequire("7hXDW");

var $2Nwuj = parcelRequire("2Nwuj");

var $aoVih = parcelRequire("aoVih");
var $iHPbg = parcelRequire("iHPbg");

var $9wGTI = parcelRequire("9wGTI");

var $6M71K = parcelRequire("6M71K");
const $379586560174b3c0$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    viewMoreInJiraLinkText: {
        id: "details-panel.links-section.jira-work-items-panel-body.view-more-link-text",
        defaultMessage: "View {count} more in System Jira"
    },
    workItemsCount: {
        id: "details-panel.links-section.jira-work-items-panel-body.work-items-count",
        defaultMessage: "{count, plural, one {# work item} other {# work items}}"
    },
    authenticationNeeded: {
        id: "details-panel.links-section.jira-work-items-panel-body.authentication-needed",
        defaultMessage: "Authentication Needed"
    },
    loginToRetrieveData: {
        id: "details-panel.links-section.jira-work-items-panel-body.login-to-retrieve-data",
        defaultMessage: "Login to retrieve data from:"
    },
    reloadPage: {
        id: "details-panel.links-section.jira-work-items-panel-body.reload-page",
        defaultMessage: "Please reload the page to try again"
    }
});
const $379586560174b3c0$var$panelBodyStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.400'
});
const $379586560174b3c0$export$b5fd1500b92a9599 = (jiraMetadata)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const jiraWorkItemsMetadata = jiraMetadata.groups.find((group)=>group.type === 'ISSUES');
    const jiraAppLinksMetadata = jiraMetadata.unauthorisedAppLinks;
    const workItemsJQLSearchUrl = jiraWorkItemsMetadata?.links.find((link)=>link.appName === 'System Jira')?.url;
    const totalJiraLinksCount = jiraMetadata.count;
    const workItems = jiraWorkItemsMetadata?.items;
    const openInNewTab = (issueUrl)=>{
        window.open(issueUrl, '_blank', 'noopener,noreferrer');
    };
    if (!workItems || !totalJiraLinksCount) return null;
    const context = {
        source: 'linkedJiraWorkItems'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6M71K.ConfluenceSmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $379586560174b3c0$var$panelBodyStyles,
        alignBlock: "start",
        space: "space.200",
        testId: "jira-work-items-panel-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "jira-work-items-panel-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "small"
    }, formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.workItemsCount, {
        count: totalJiraLinksCount
    }))), workItems.map((issue, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            testId: "smartlink-item-wrapper",
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bYRk6.default), {
            data: context
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hpUsb.Card), {
            url: issue.url,
            appearance: "inline",
            onClick: ()=>openInNewTab(issue.url)
        })))), workItemsJQLSearchUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "jira-work-items-panel-jql-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: workItemsJQLSearchUrl
    }, formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.viewMoreInJiraLinkText, {
        count: jiraMetadata.count - workItems.length
    }))), jiraAppLinksMetadata.length > 0 && (0, $9wGTI.fg)('confluence-jira-issue-applinks') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        title: formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.authenticationNeeded),
        appearance: "warning",
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("ul", {
                key: "auth-links"
            }, jiraAppLinksMetadata.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", {
                    key: item.htmlSafeName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iHPbg.default), null, item.authorisationUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                    href: item.authorisationUrl,
                    target: "_blank",
                    rel: "noopener,noreferrer"
                }, item.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, item.name, " - ", formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.reloadPage))))))
        ]
    }, formatMessage($379586560174b3c0$export$a7357cdd1f0b0168.loginToRetrieveData))));
};

});

parcelRegister("dSBea", function(module, exports) {

$parcel$export(module.exports, "JiraWorkItemsPanelIcon", () => $64fc2a01f5307e91$export$4f6ac55ab232a72a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $7ZcJJ = parcelRequire("7ZcJJ");
const $64fc2a01f5307e91$var$i18n = (0, $2nPZH.defineMessages)({
    jiraWorkItemsPanelHeaderIcon: {
        id: "details-panel.jira-work-items.header.icon.label",
        defaultMessage: "Jira work items Icon"
    }
});
const $64fc2a01f5307e91$export$4f6ac55ab232a72a = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
        label: formatMessage($64fc2a01f5307e91$var$i18n.jiraWorkItemsPanelHeaderIcon)
    });
};

});

parcelRegister("dT4iS", function(module, exports) {

$parcel$export(module.exports, "JiraWorkItemsHeaderNavigation", () => $338642815de47c2a$export$4b70900bd141d903);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bPdpL = parcelRequire("bPdpL");

var $1qfLF = parcelRequire("1qfLF");

var $jvYFk = parcelRequire("jvYFk");
var $aWwYt = parcelRequire("aWwYt");

var $7N9MO = parcelRequire("7N9MO");

var $9igqG = parcelRequire("9igqG");
const $338642815de47c2a$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    detailsPanelHeaderLabel: {
        id: "details-panel.panel.header.label",
        defaultMessage: "Details"
    },
    iconButtonLabel: {
        id: "details-panel.jira-work-items-panel.header-navigation.icon-button",
        defaultMessage: "return-to-content-details"
    },
    leftArrowIconLabel: {
        id: "details-panel.jira-work-items-panel.header-navigation.left-arrow-icon",
        defaultMessage: "back-icon"
    }
});
const $338642815de47c2a$export$4b70900bd141d903 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const showDetailsPanel = ()=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).DetailsPanel,
            headerComponentElements: {
                HeaderIcon: (0, $7N9MO.DetailsPanelHeaderIcon),
                headerLabel: $338642815de47c2a$export$a7357cdd1f0b0168.detailsPanelHeaderLabel
            },
            BodyComponent: (0, $9igqG.DetailsPanelBody)
        }, 'push');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                label: formatMessage($338642815de47c2a$export$a7357cdd1f0b0168.leftArrowIconLabel),
                spacing: "none"
            }),
        appearance: "subtle",
        label: formatMessage($338642815de47c2a$export$a7357cdd1f0b0168.iconButtonLabel),
        onClick: showDetailsPanel,
        testId: "naviagte-back-to-details-panel-button"
    });
};

});


parcelRegister("1ni5F", function(module, exports) {

$parcel$export(module.exports, "useGetJiraMetadata", () => $e947a3a1489ee888$export$1bd5cee589f02d6d);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $ep3mz = parcelRequire("ep3mz");

var $4R19I = parcelRequire("4R19I");
const $e947a3a1489ee888$export$1bd5cee589f02d6d = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [data, setData] = (0, $gwFzn.useState)(null);
    const [fetchError, setFetchError] = (0, $gwFzn.useState)(null);
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const fireSuccessAnalytics = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'success',
                actionSubject: 'fetchJiraMetadata',
                source: 'linkedJiraWorkItems'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireFailureAnalytics = (0, $gwFzn.useCallback)((error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failure',
                actionSubject: 'fetchJiraMetadata',
                source: 'linkedJiraWorkItems',
                attributes: {
                    error: error
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const getJiraMetadata = (0, $gwFzn.useCallback)(async ()=>{
        if (!contentId) return;
        setIsLoading(true);
        try {
            const jiraMetaData = await (0, $4R19I.fetchJiraMetadata)(contentId);
            if (!jiraMetaData) throw new Error('No Jira metadata has been fetched');
            fireSuccessAnalytics();
            setData(jiraMetaData);
        } catch (error) {
            fireFailureAnalytics(error);
            setFetchError(error instanceof Error ? error : new Error('Request to getJiraMetadata failed'));
        } finally{
            setIsLoading(false);
        }
    }, [
        contentId,
        fireSuccessAnalytics,
        fireFailureAnalytics
    ]);
    (0, $gwFzn.useEffect)(()=>{
        getJiraMetadata();
    }, [
        getJiraMetadata
    ]);
    return {
        data: data,
        error: fetchError,
        isLoading: isLoading,
        refetch: getJiraMetadata
    };
};

});
parcelRegister("4R19I", function(module, exports) {

$parcel$export(module.exports, "fetchJiraMetadata", () => $e40838b1edee5144$export$e5f56020a6ff0318);

var $f7B1p = parcelRequire("f7B1p");
const $e40838b1edee5144$var$getJiraMetadataEndpoint = (contentId)=>{
    return `/wiki/rest/jira-metadata/1.0/metadata?pageId=${contentId}`;
};
const $e40838b1edee5144$export$e5f56020a6ff0318 = async (contentId)=>{
    const response = await (0, $f7B1p.cfetch)($e40838b1edee5144$var$getJiraMetadataEndpoint(contentId), {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        },
        credentials: 'include'
    });
    return response.json();
};

});



parcelRegister("2ifi0", function(module, exports) {

$parcel$export(module.exports, "CustomContentRow", () => $1ca3a459c0e0ae69$export$472cb29981ee8ce0);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $jdPfT = parcelRequire("jdPfT");

var $1NBp8 = parcelRequire("1NBp8");

var $ep3mz = parcelRequire("ep3mz");

var $dA2qY = parcelRequire("dA2qY");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");

var $icONe = parcelRequire("icONe");
const $1ca3a459c0e0ae69$var$i18n = (0, $2nPZH.defineMessages)({
    customContent: {
        id: "details-panel.links-section.custom-content-row",
        defaultMessage: "Custom content"
    }
});
const $1ca3a459c0e0ae69$export$472cb29981ee8ce0 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, error: error, refetch: refetch } = (0, $dA2qY.useCustomContent)();
    const { customContentCount: customContentCount } = data;
    if (!customContentCount && !error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "custom-content-empty-row"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($1ca3a459c0e0ae69$var$i18n.customContent),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: ""
        })
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
        error: error,
        refetch: refetch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icONe.SubtleLink), {
        href: (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST).toUrl({
            contentId: contentId,
            spaceKey: spaceKey
        }),
        analyticsContext: {
            source: 'contentWrapper',
            attributes: {
                name: 'customContent',
                count: customContentCount
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "custom-content-count"
    }, customContentCount)));
};

});
parcelRegister("dA2qY", function(module, exports) {

$parcel$export(module.exports, "useCustomContent", () => $dd3706d0c3f7c313$export$1a2b9ee3778620e7);

var $gwFzn = parcelRequire("gwFzn");

var $ep3mz = parcelRequire("ep3mz");

var $htsj6 = parcelRequire("htsj6");

var $f6obR = parcelRequire("f6obR");
const $dd3706d0c3f7c313$export$1a2b9ee3778620e7 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { type: contentType } = (0, $htsj6.useContentStatus)();
    const [customContentCount, setCustomContentCount] = (0, $gwFzn.useState)(0);
    const [customContentError, setCustomContentError] = (0, $gwFzn.useState)(undefined);
    const [loading, setLoading] = (0, $gwFzn.useState)(false);
    const fetchCustomContent = (0, $gwFzn.useCallback)(async ()=>{
        if (!contentId) return;
        setCustomContentError(undefined);
        setCustomContentCount(0);
        if (navigator.onLine) {
            setLoading(true);
            try {
                const response = await (0, $f6obR.getCustomContent)(contentId, contentType);
                if ('errors' in response) setCustomContentError(new Error(response.errors.map(({ code: code, detail: detail, status: status, title: title })=>`${status} - ${code} - ${title} - ${detail}`).join(',')));
                else setCustomContentCount(response.results.length);
            } catch (error) {
                setCustomContentError(new Error(`500 - unknown - Error - ${error.message}`));
            } finally{
                setLoading(false);
            }
        }
    }, [
        contentId,
        contentType
    ]);
    (0, $gwFzn.useEffect)(()=>{
        fetchCustomContent();
    }, [
        fetchCustomContent
    ]);
    return {
        data: {
            customContentCount: customContentCount
        },
        error: customContentError,
        loading: loading,
        refetch: fetchCustomContent
    };
};

});
parcelRegister("f6obR", function(module, exports) {

$parcel$export(module.exports, "getCustomContent", () => $f15f4d9d482cc07b$export$2b23b879dbd3c7c4);

var $f7B1p = parcelRequire("f7B1p");
const $f15f4d9d482cc07b$export$2b23b879dbd3c7c4 = async (contentId, contentType)=>{
    try {
        // v2 APIs pluralise all the content types... and if we don't get a type, default to pages
        const contentTypeForApi = contentType ? `${contentType}s` : 'pages';
        const response = await (0, $f7B1p.cfetch)(`/wiki/api/v2/${contentTypeForApi}/${contentId}/custom-content`);
        return response.json();
    } catch (error) {
        return {
            errors: [
                {
                    status: 500,
                    code: 'unknown',
                    title: 'Error',
                    detail: error.message
                }
            ]
        };
    }
};

});



parcelRegister("g7mkQ", function(module, exports) {

$parcel$export(module.exports, "FilesRow", () => $c41027314eaa1306$export$8826d53c085deb93);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $kpYGL = parcelRequire("kpYGL");

var $9lz2c = parcelRequire("9lz2c");

var $inPa6 = parcelRequire("inPa6");

var $jlIaF = parcelRequire("jlIaF");

var $ep3mz = parcelRequire("ep3mz");

var $2IlTE = parcelRequire("2IlTE");

var $5nUIg = parcelRequire("5nUIg");

var $28V34 = parcelRequire("28V34");

var $icONe = parcelRequire("icONe");
const $c41027314eaa1306$var$i18n = (0, $2nPZH.defineMessages)({
    files: {
        id: "details-panel.links-section.files-row",
        defaultMessage: "Files"
    }
});
const $c41027314eaa1306$var$attachmentsLimit = 50;
const $c41027314eaa1306$export$8826d53c085deb93 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $2IlTE.useContentAttachments)($c41027314eaa1306$var$attachmentsLimit);
    const { attachmentsCount: attachmentsCount, hasMoreAttachments: hasMoreAttachments } = data;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `button`,
                actionSubjectId: 'SidePanelFiles',
                source: 'contentWrapper'
            }
        }).fire();
    };
    const renderFilesContent = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpYGL.default), {
            width: "48px",
            height: "24px",
            borderRadius: 3,
            testId: "files-row-loading"
        });
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $28V34.InlineRetryError), {
            error: error,
            refetch: refetch
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icONe.SubtleLink), {
            href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewpageattachments.action?pageId=${contentId}`,
            onClick: onClick
        }, attachmentsCount, hasMoreAttachments ? '+' : '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nUIg.DetailRow), {
        itemName: formatMessage($c41027314eaa1306$var$i18n.files),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
            label: ""
        })
    }, renderFilesContent());
};

});
parcelRegister("2IlTE", function(module, exports) {

$parcel$export(module.exports, "useContentAttachments", () => $7131f83e62ec8e0d$export$54932d90334e20cc);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $htsj6 = parcelRequire("htsj6");

var $jxCoH = parcelRequire("jxCoH");
const $7131f83e62ec8e0d$var$useContentAttachmentsDetailsPanelContentAttachmentsQuery = (0, $d2LG0.default)`query useContentAttachmentsDetailsPanelContentAttachmentsQuery($contentId:ID!$status:String!$limit:Int!){singleContent(id:$contentId status:[$status]){id attachments(first:$limit){count pageInfo{hasNextPage}}}}`;
const $7131f83e62ec8e0d$export$54932d90334e20cc = (attachmentsLimit)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { contentStatus: contentStatus, loading: isContentStatusLoading, error: contentStatusError, refetch: refetchContentStatus } = (0, $htsj6.useContentStatus)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($7131f83e62ec8e0d$var$useContentAttachmentsDetailsPanelContentAttachmentsQuery, {
        variables: {
            contentId: contentId ?? '',
            status: contentStatus ?? '',
            limit: attachmentsLimit
        },
        skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId
    });
    const normalizedData = (0, $gwFzn.useMemo)(()=>(0, $jxCoH.normalizeContentAttachmentsData)(data), [
        data
    ]);
    return {
        data: normalizedData,
        loading: loading,
        error: contentStatusError || error,
        refetch: !!contentStatusError ? refetchContentStatus : refetch
    };
};

});
parcelRegister("jxCoH", function(module, exports) {

$parcel$export(module.exports, "normalizeContentAttachmentsData", () => $35280d2dcde04e20$export$7005b14840b4a0d4);
const $35280d2dcde04e20$export$7005b14840b4a0d4 = (data)=>({
        attachmentsCount: data?.singleContent?.attachments?.count ?? 0,
        hasMoreAttachments: data?.singleContent?.attachments?.pageInfo?.hasNextPage ?? false
    });

});








parcelRegister("b1RVt", function(module, exports) {

$parcel$export(module.exports, "useSpace", () => $89b9eefc89dd0029$export$450c36e0b0e62ccd);
/**
 * @graphql cc
 */ 
var $diswb = parcelRequire("diswb");

var $aVmIf = parcelRequire("aVmIf");
const $89b9eefc89dd0029$export$450c36e0b0e62ccd = (spaceKey, spaceFromProps)=>{
    const result = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $aVmIf.SpaceQuery), {
        skip: !!spaceFromProps,
        variables: {
            spaceKey: spaceKey
        }
    });
    if (spaceFromProps) return {
        id: spaceFromProps.id,
        name: spaceFromProps.name,
        iconPath: spaceFromProps.iconPath ?? ''
    };
    else {
        const space = result.data?.space;
        return {
            id: space?.id,
            name: space?.name,
            iconPath: space?.icon?.path
        };
    }
};

});

parcelRegister("aWJgU", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardHeaderActions", () => $a877eefafeee91d4$export$87b03f598cdfd61c);

var $gwFzn = parcelRequire("gwFzn");

var $j96gu = parcelRequire("j96gu");
var $hzClJ = parcelRequire("hzClJ");
var $ckYtV = parcelRequire("ckYtV");
var $lUzNY = parcelRequire("lUzNY");
const $a877eefafeee91d4$export$87b03f598cdfd61c = ()=>{
    const [mainActions, setMainActions] = (0, $gwFzn.useState)(null);
    const [collaborators, setCollaborators] = (0, $gwFzn.useState)({
        collaborators: [],
        me: null
    });
    const [boardStatus, setBoardStatus] = (0, $gwFzn.useState)(null);
    const [moreActions, setMoreActions] = (0, $gwFzn.useState)(null);
    (0, $gwFzn.useEffect)(()=>{
        (0, $ckYtV.contentMainActionsService).onActionsUpdate((mainAction)=>{
            setMainActions(mainAction);
        });
        (0, $hzClJ.contentCollaboratorsService).onActionsUpdate((collaborator)=>{
            setCollaborators(collaborator);
        });
        (0, $j96gu.contentBoardStatusService).onActionsUpdate((status)=>{
            setBoardStatus(status);
        });
        (0, $lUzNY.contentMoreActionsService).onActionsUpdate((moreAction)=>{
            setMoreActions(moreAction);
        });
    }, [
        setMainActions,
        setCollaborators,
        setBoardStatus,
        setMoreActions
    ]);
    return {
        mainActions: mainActions,
        collaborators: collaborators,
        contentStatus: boardStatus,
        moreActions: moreActions
    };
};

});

parcelRegister("pgUwo", function(module, exports) {

$parcel$export(module.exports, "MobileWebView", () => $b2be9fd40955bb13$export$7101457c6893431b);
/* WhiteboardMobileWebView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $iXCQx = parcelRequire("iXCQx");

var $1eaCJ = parcelRequire("1eaCJ");
var $irVI7 = parcelRequire("irVI7");

var $iJSsV = parcelRequire("iJSsV");
const $b2be9fd40955bb13$var$MobileWebViewContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { headerHeight: headerHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_3ioxf9": (0, $iAWao.default)(`${__cmplp.headerHeight}px`),
            "--_yo5j46": (0, $iAWao.default)(`calc(100vh - ${__cmplp.headerHeight}px)`)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41ckr _kqswstnw _154i5h89 _4t3i2s19 _vchhusvi _1bsb1osq _1e0c1txw _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $b2be9fd40955bb13$var$MobileWebViewTextContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _1bsb2hgv _1e0c1txw _4cvr1h6o _1bah1h6o _y3gn1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $b2be9fd40955bb13$var$MobileWebViewHeader = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8lodh _1bsb1fja",
            __cmplp.className
        ])
    });
});
const $b2be9fd40955bb13$var$MobileWebViewText = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $b2be9fd40955bb13$var$i18n = (0, $2nPZH.defineMessages)({
    title: {
        id: "whiteboard-common.mobile-web-view-title",
        defaultMessage: "Whiteboards aren\u2019t available on mobile yet"
    },
    description: {
        id: "whiteboard-common.mobile-web-view-description",
        defaultMessage: "View on Confluence Cloud for web."
    },
    details: {
        id: "whiteboard-common.mobile-web-view-details",
        defaultMessage: "Use whiteboards for visual brainstorming and collaboration when inspiration strikes."
    }
});
const $b2be9fd40955bb13$export$7101457c6893431b = ({ bannerState: bannerState })=>{
    const headerHeight = (0, $gwFzn.useMemo)(()=>bannerState.getTotalHeight(), [
        bannerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b2be9fd40955bb13$var$MobileWebViewContainer, {
        headerHeight: headerHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iJSsV))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b2be9fd40955bb13$var$MobileWebViewTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b2be9fd40955bb13$var$MobileWebViewHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b2be9fd40955bb13$var$i18n.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b2be9fd40955bb13$var$i18n.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b2be9fd40955bb13$var$MobileWebViewText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b2be9fd40955bb13$var$i18n.details))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        attributes: {
            isConfluenceRenderedMobileView: true
        }
    }));
};

});
parcelRegister("iJSsV", function(module, exports) {
module.exports = new URL("Whiteboards.0d1dad24.svg", import.meta.url).toString();

});


parcelRegister("eR152", function(module, exports) {

$parcel$export(module.exports, "getWhiteboardSpot", () => $cc05ccd3825cf29a$export$d65fcbc7ac1679a1);
// @ts-nocheck

var $e9zUf = parcelRequire("e9zUf");
const $cc05ccd3825cf29a$export$d65fcbc7ac1679a1 = (params, name)=>{
    const spot = params[name];
    if (spot) {
        try {
            // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
            (0, $e9zUf.confluenceLocalStorageInstance).setItem(name, spot);
        } catch (err) {}
        return spot;
    }
    const savedItem = (0, $e9zUf.confluenceLocalStorageInstance).getItem(name);
    if (!savedItem) return;
    const maybeSpot = parseInt(savedItem);
    if (Number.isNaN(maybeSpot)) return;
    return maybeSpot;
};

});

parcelRegister("8O6cX", function(module, exports) {

$parcel$export(module.exports, "WhiteboardEditionUpgradeService", () => $9b751da612a633f4$export$af34703665279117);
function $9b751da612a633f4$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $9b751da612a633f4$var$id = 0;
function $9b751da612a633f4$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $9b751da612a633f4$var$id++ + "_" + e;
}
var $9b751da612a633f4$var$_upgradeHandler = /*#__PURE__*/ $9b751da612a633f4$var$_classPrivateFieldLooseKey("upgradeHandler");
var $9b751da612a633f4$var$_closeHandler = /*#__PURE__*/ $9b751da612a633f4$var$_classPrivateFieldLooseKey("closeHandler");
class $9b751da612a633f4$export$af34703665279117 {
    registerUpgradeHandler(upgradeHandler) {
        $9b751da612a633f4$var$_classPrivateFieldLooseBase(this, $9b751da612a633f4$var$_upgradeHandler)[$9b751da612a633f4$var$_upgradeHandler] = upgradeHandler;
    }
    registerCloseHandler(closeHandler) {
        $9b751da612a633f4$var$_classPrivateFieldLooseBase(this, $9b751da612a633f4$var$_closeHandler)[$9b751da612a633f4$var$_closeHandler] = closeHandler;
    }
    // Show CTA with provided options
    // Upgrade handler returns deferred Promise that resolves when CTA is closed
    showUpgradeExperience(options) {
        return $9b751da612a633f4$var$_classPrivateFieldLooseBase(this, $9b751da612a633f4$var$_upgradeHandler)[$9b751da612a633f4$var$_upgradeHandler](options);
    }
    // Method exposed to bridge API for allowing whiteboards to
    // close paywall CTA
    closeUpgradeExperience() {
        $9b751da612a633f4$var$_classPrivateFieldLooseBase(this, $9b751da612a633f4$var$_closeHandler)[$9b751da612a633f4$var$_closeHandler]();
    }
    constructor(){
        Object.defineProperty(this, $9b751da612a633f4$var$_upgradeHandler, {
            writable: true,
            value: async ()=>{}
        });
        Object.defineProperty(this, $9b751da612a633f4$var$_closeHandler, {
            writable: true,
            value: ()=>{}
        });
    }
}

});

parcelRegister("2rcwI", function(module, exports) {

$parcel$export(module.exports, "WhiteboardEditionUpgradeCTA", () => $fe49d3f230be28ab$export$7fd16ab10c651c7a);
/* WhiteboardEditionUpgradeCTA.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $kpfjJ = parcelRequire("kpfjJ");

var $iaTTL = parcelRequire("iaTTL");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fe49d3f230be28ab$var$CTAContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqswstnw _1bsb1vif _154ixncg _1xi2utpp",
            __cmplp.className
        ])
    });
});
const $fe49d3f230be28ab$export$7fd16ab10c651c7a = ({ editionUpgradeService: editionUpgradeService })=>{
    const modalState = (0, $iaTTL.useEditionUpgradeCTA)(editionUpgradeService);
    if (!modalState.isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($fe49d3f230be28ab$var$CTAContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kpfjJ.WhiteboardUpsell), {
        ...modalState.modalProps,
        onDismissRequest: modalState.closeModal
    }));
};

});
parcelRegister("kpfjJ", function(module, exports) {

$parcel$export(module.exports, "WhiteboardUpsell", () => $3fdcde6ef6c83a8a$export$a6cc3aedacb0f374);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gj7hi = parcelRequire("gj7hi");

var $eEA8O = parcelRequire("eEA8O");

var $lnqHu = parcelRequire("lnqHu");

var $dIouf = parcelRequire("dIouf");

var $hQnHK = parcelRequire("hQnHK");

var $lHQAj = parcelRequire("lHQAj");

var $euL71 = parcelRequire("euL71");

var $k4Vdy = parcelRequire("k4Vdy");

var $iC1wS = parcelRequire("iC1wS");
const $3fdcde6ef6c83a8a$var$i18n = (0, $2nPZH.defineMessages)({
    cardDismissButton: {
        id: "change-edition.card.dismiss-modal-btn",
        defaultMessage: "Close modal"
    }
});
const $3fdcde6ef6c83a8a$export$8226cc22557258e4 = ({ onClick: onClick, actionSubjectId: actionSubjectId, source: source, attributes: attributes, ...otherButtonProps })=>{
    const intl = (0, $dBxQj.default)();
    const { wrapAnalyticsEventPayload: wrapAnalyticsEventPayload } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const wrappedOnClick = (0, $gwFzn.useCallback)((_, analyticsEvent)=>{
        analyticsEvent.update((payload)=>wrapAnalyticsEventPayload({
                type: 'sendUIEvent',
                data: {
                    action: payload.action,
                    actionSubject: payload.actionSubject,
                    actionSubjectId: actionSubjectId,
                    source: source,
                    attributes: {
                        ...payload?.attributes,
                        ...attributes
                    }
                }
            })).fire();
        onClick();
    }, [
        onClick,
        actionSubjectId,
        source,
        attributes,
        wrapAnalyticsEventPayload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "link",
        onClick: wrappedOnClick,
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
            label: intl.formatMessage($3fdcde6ef6c83a8a$var$i18n.cardDismissButton),
            color: "var(--ds-icon, #44546F)"
        }),
        testId: (0, $k4Vdy.calculateTestId)({
            actionSubjectId: actionSubjectId,
            source: source
        }),
        ...otherButtonProps
    });
};
const $3fdcde6ef6c83a8a$export$5854008db518bf54 = 'whiteboardsUpsellCtaScreen';
const $3fdcde6ef6c83a8a$var$WhiteboardUpsellComponent = ({ title: title, body: body, image: image, learnMoreLink: learnMoreLink, feature: feature, onDismissRequest: onDismissRequest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iC1wS.AnalyticsProvider), {
        customAttributes: {
            feature: feature
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lHQAj.CardContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lHQAj.Card), {
        withTasteAndToneStyling: true,
        title: title,
        body: body,
        learnMoreLink: {
            ...learnMoreLink,
            messageDescriptor: {
                id: 'change-edition.whiteboards.learn-more',
                defaultMessage: learnMoreLink.message
            },
            actionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID)
        },
        source: $3fdcde6ef6c83a8a$export$5854008db518bf54,
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        upgradeEditionActionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID),
        buttonGroupAlignment: "right",
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3fdcde6ef6c83a8a$export$8226cc22557258e4, {
            onClick: onDismissRequest,
            source: $3fdcde6ef6c83a8a$export$5854008db518bf54,
            actionSubjectId: "dismissButton"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        src: image.src.default,
        srcDark: image.src.dark,
        alt: image.alt,
        width: "100%",
        testId: (0, $k4Vdy.calculateTestId)({
            actionSubjectId: 'image',
            source: $3fdcde6ef6c83a8a$export$5854008db518bf54
        })
    }))));
};
const $3fdcde6ef6c83a8a$export$a6cc3aedacb0f374 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).WHITEBOARDS
})($3fdcde6ef6c83a8a$var$WhiteboardUpsellComponent);

});

parcelRegister("iaTTL", function(module, exports) {

$parcel$export(module.exports, "useEditionUpgradeCTA", () => $15bf64ebc945eb71$export$77f0db1c7930e0df);

var $gwFzn = parcelRequire("gwFzn");

var $iXDsc = parcelRequire("iXDsc");
const $15bf64ebc945eb71$export$77f0db1c7930e0df = (editionUpgradeService)=>{
    const [modalState, setModalState] = (0, $gwFzn.useState)({
        isModalOpen: false
    });
    const closeModal = (0, $gwFzn.useCallback)(()=>{
        if (modalState.isModalOpen) modalState.modalCloseDeferrable.resolve();
        setModalState({
            isModalOpen: false
        });
    }, [
        modalState
    ]);
    const editionUpgradeHandler = (0, $gwFzn.useCallback)((modalProps)=>{
        const deferrable = new (0, $iXDsc.Deferrable)();
        setModalState({
            isModalOpen: true,
            modalProps: modalProps,
            modalCloseDeferrable: deferrable
        });
        return deferrable.get();
    }, []);
    editionUpgradeService.registerUpgradeHandler(editionUpgradeHandler);
    editionUpgradeService.registerCloseHandler(closeModal);
    return modalState.isModalOpen ? {
        isModalOpen: modalState.isModalOpen,
        modalProps: modalState.modalProps,
        closeModal: closeModal
    } : modalState;
};

});
parcelRegister("iXDsc", function(module, exports) {

$parcel$export(module.exports, "Deferrable", () => $f4cb918d12f2a305$export$bb373f2025a3840b);
function $f4cb918d12f2a305$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $f4cb918d12f2a305$var$id = 0;
function $f4cb918d12f2a305$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $f4cb918d12f2a305$var$id++ + "_" + e;
}
var $f4cb918d12f2a305$var$_promise = /*#__PURE__*/ $f4cb918d12f2a305$var$_classPrivateFieldLooseKey("promise");
var $f4cb918d12f2a305$var$_resolve = /*#__PURE__*/ $f4cb918d12f2a305$var$_classPrivateFieldLooseKey("resolve");
var $f4cb918d12f2a305$var$_reject = /*#__PURE__*/ $f4cb918d12f2a305$var$_classPrivateFieldLooseKey("reject");
class $f4cb918d12f2a305$export$bb373f2025a3840b {
    resolve(value) {
        $f4cb918d12f2a305$var$_classPrivateFieldLooseBase(this, $f4cb918d12f2a305$var$_resolve)[$f4cb918d12f2a305$var$_resolve](value);
    }
    reject(reason) {
        $f4cb918d12f2a305$var$_classPrivateFieldLooseBase(this, $f4cb918d12f2a305$var$_reject)[$f4cb918d12f2a305$var$_reject](reason);
    }
    get() {
        return $f4cb918d12f2a305$var$_classPrivateFieldLooseBase(this, $f4cb918d12f2a305$var$_promise)[$f4cb918d12f2a305$var$_promise];
    }
    constructor(){
        Object.defineProperty(this, $f4cb918d12f2a305$var$_promise, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f4cb918d12f2a305$var$_resolve, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f4cb918d12f2a305$var$_reject, {
            writable: true,
            value: void 0
        });
        $f4cb918d12f2a305$var$_classPrivateFieldLooseBase(this, $f4cb918d12f2a305$var$_promise)[$f4cb918d12f2a305$var$_promise] = new Promise((resolve, reject)=>{
            $f4cb918d12f2a305$var$_classPrivateFieldLooseBase(this, $f4cb918d12f2a305$var$_resolve)[$f4cb918d12f2a305$var$_resolve] = resolve;
            $f4cb918d12f2a305$var$_classPrivateFieldLooseBase(this, $f4cb918d12f2a305$var$_reject)[$f4cb918d12f2a305$var$_reject] = reject;
        });
        this.resolve = this.resolve.bind(this);
        this.reject = this.reject.bind(this);
    }
}

});



parcelRegister("jzHIJ", function(module, exports) {

$parcel$export(module.exports, "useOnboardingService", () => $24f85972004b2500$export$df4cf7f032c0f91f);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $9oezN = parcelRequire("9oezN");

var $kDja4 = parcelRequire("kDja4");

var $8fj5s = parcelRequire("8fj5s");

var $dvLUu = parcelRequire("dvLUu");
const $24f85972004b2500$export$df4cf7f032c0f91f = ({ isNewWhiteboard: isNewWhiteboard = false } = {})=>{
    const { isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isGAOnboardingEnabled = isWhiteboardGAOnboardingEnabled();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [hasStartedWhiteboardGAOnboardingSpotlights, stopWhiteboardGAOnboardingSpotlights] = (0, $8fj5s.useSkippableCoordination)('cc-whiteboards-ga-onboarding-spotlight', !isGAOnboardingEnabled);
    const handleOnboardingChange = (0, $gwFzn.useCallback)((screen)=>{
        (0, $dvLUu.onboardingService).previousOnboardingScreen = (0, $dvLUu.onboardingService).currentOnboardingScreen;
        (0, $dvLUu.onboardingService).currentOnboardingScreen = screen;
        if ((0, $dvLUu.onboardingService).previousOnboardingScreen === 'spotlight-sticky-viewer') (0, $9oezN.popOnboardingConfetti)();
    }, []);
    const handleOnboardingEnd = (0, $gwFzn.useCallback)((screen)=>{
        stopWhiteboardGAOnboardingSpotlights();
        if (screen === 'spotlight-sticky-creator') (0, $9oezN.popOnboardingConfetti)();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'onboardingSpotlight',
                action: 'closed',
                actionSubject: 'onboardingSpotlight',
                attributes: {
                    spotlight: screen
                }
            }
        }).fire();
    }, [
        stopWhiteboardGAOnboardingSpotlights,
        createAnalyticsEvent
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $dvLUu.onboardingService).registerOnOnboardingChangeCallback(handleOnboardingChange);
    }, [
        handleOnboardingChange
    ]);
    (0, $gwFzn.useMemo)(()=>{
        (0, $dvLUu.onboardingService).registerOnOnboardingEndCallback(handleOnboardingEnd);
    }, [
        handleOnboardingEnd
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $dvLUu.onboardingService).isEligibleForGAOnboarding = isGAOnboardingEnabled && hasStartedWhiteboardGAOnboardingSpotlights;
    }, [
        hasStartedWhiteboardGAOnboardingSpotlights,
        isGAOnboardingEnabled
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $dvLUu.onboardingService).isNewWhiteboard = isNewWhiteboard;
    }, [
        isNewWhiteboard
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            (0, $dvLUu.onboardingService).dispose();
        };
    }, []);
    return 0, $dvLUu.onboardingService;
};

});
parcelRegister("dvLUu", function(module, exports) {

$parcel$export(module.exports, "onboardingService", () => $d6d1beda986aaf1b$export$66f3fb1d40113cac);
class $d6d1beda986aaf1b$export$e08330274746fce9 {
    dispose() {
        this.handleShowTitleSpotlight = ()=>{};
        this.startOnboardingCallback = ()=>{};
        this.onOnboardingChangeCallback = ()=>{};
        this.onOnboardingEndCallback = ()=>{};
        this.handleShowHeaderSpotlight = ()=>{};
        this.handleShowCollaboratorSpotlight = ()=>{};
        this._previousOnboardingScreen = undefined;
        this._currentOnboardingScreen = undefined;
        this._onboardingSkipped = false;
        this._hasStartedWhiteboardOnboardingSpotlight = false;
        this._isEligibleForGAOnboarding = false;
        this._isNewWhiteboard = false;
    }
    /**
   * This is called in Canvas to register the startOnboarding callback in
   * Confluence, which will be used to let Canvas know when it should start its
   * spotlight onboarding flow.
   *
   * @param callback A callback that indicates to Canvas to start it's onboarding
   */ registerStartOnboardingCallback(callback) {
        this.startOnboardingCallback = callback;
    }
    /**
   * This is called in Confluence to register the onOnboardingChange callback
   * which will be called in Canvas via the Bridge API whenever a new onboarding
   * screen is shown.
   *
   * @param callback A callback that is passed the new onboarding screen name
   * whenever it changes
   */ registerOnOnboardingChangeCallback(callback) {
        this.onOnboardingChangeCallback = callback;
    }
    /**
   * This is called in Confluence to register the onOnboardingEnd callback
   * which will be called in Canvas once the onboarding flow is finished there.
   * The callback that is registered will handle ending the onboarding tour.
   *
   * @param callback A callback that handles ending the onboarding tour
   */ registerOnOnboardingEndCallback(callback) {
        this.onOnboardingEndCallback = callback;
    }
    /**
   * This is called in Confluence when we have finished the section of
   * the whiteboards spotlight onboarding that happens here. It lets Canvas know
   * that we are ready to start the spotlight onboarding flow there.
   */ startOnboarding(initialSpotlightScreen) {
        this.startOnboardingCallback(initialSpotlightScreen);
    }
    /**
   * This is called in Canvas via the Bridge API whenever the onboarding screen
   * changes
   *
   * @param {string} screen The new onboarding screen name
   */ onOnboardingChange(screen) {
        this.onOnboardingChangeCallback(screen);
    }
    /**
   * This is called in Canvas once its onboarding is finished. It calls the
   * function that's been registered to handle ending the onboarding tour.
   *
   * @param {string} screen The name of the onboarding screen that the flow ended on
   */ onOnboardingEnd(screen) {
        this.onOnboardingEndCallback(screen);
    }
    /**
   * This is called by Confluence to register a callback function that will be invoked
   * by `showTitleSpotlight` below whenever spotlight onboarding for the Whiteboard title
   * should be shown. The callback is responsible for showing the spotlight.
   */ onShowTitleSpotlight(callback) {
        this.handleShowTitleSpotlight = callback;
    }
    /**
   * This is called by Confluence to register a callback function that will be invoked
   * by `showHeaderSpotlight` below whenever spotlight onboarding for the Content types
   * header should be shown. The callback is responsible for showing the spotlight.
   */ onShowHeaderSpotlight(callback) {
        this.handleShowHeaderSpotlight = callback;
    }
    /**
   * This is called by Confluence to register a callback function that will be invoked
   * by `showCollaboratorSpotlight` below whenever spotlight onboarding for the Content types
   * collaborators should be shown. The callback is responsible for showing the spotlight.
   */ onShowCollaboratorSpotlight(callback) {
        this.handleShowCollaboratorSpotlight = callback;
    }
    /**
   * This invokes a callback handler that should show the onboarding spotlight
   * targeting the Whiteboard title. This callback was registered elsewhere in
   * Confluence by a previous call to `this.onShowTitleSpotlight(callback)`
   */ showTitleSpotlight() {
        this.handleShowTitleSpotlight();
    }
    /**
   * This invokes a callback handler that should show the onboarding spotlight
   * targeting the Content types header. This callback was registered elsewhere in
   * Confluence by a previous call to `this.onShowHeaderSpotlight(callback)`
   */ showHeaderSpotlight() {
        this.handleShowHeaderSpotlight();
    }
    /**
   * This invokes a callback handler that should show the onboarding spotlight
   * targeting the Content types collaborators. This callback was registered elsewhere in
   * Confluence by a previous call to `this.onShowHeaderSpotlight(callback)`
   */ showCollaboratorSpotlight() {
        this.handleShowCollaboratorSpotlight();
    }
    get previousOnboardingScreen() {
        return this._previousOnboardingScreen;
    }
    set previousOnboardingScreen(screen) {
        this._previousOnboardingScreen = screen;
    }
    get currentOnboardingScreen() {
        return this._currentOnboardingScreen;
    }
    set currentOnboardingScreen(screen) {
        this._currentOnboardingScreen = screen;
    }
    /**
   * This is used to get the value of onboardingSkipped (Beta-only)
   *
   * @returns {boolean} value of onboardingSkipped
   */ get onboardingSkipped() {
        return this._onboardingSkipped;
    }
    /**
   * This is called in Confluence to set the value of onboardingSkipped to true
   * if the user exits the Beta onboarding modal early. If the user does this we do
   * not want to show them the Beta onboarding spotlight.
   */ set onboardingSkipped(skipped) {
        this._onboardingSkipped = skipped;
    }
    get hasStartedWhiteboardOnboardingSpotlight() {
        return this._hasStartedWhiteboardOnboardingSpotlight;
    }
    set hasStartedWhiteboardOnboardingSpotlight(bool) {
        this._hasStartedWhiteboardOnboardingSpotlight = bool;
    }
    /**
   * Indicates whether or not the current whiteboard being viewed already existed
   * or was newly created. This is currently used to determine which onboarding
   * flow to send a user through.
   */ get isNewWhiteboard() {
        return this._isNewWhiteboard;
    }
    set isNewWhiteboard(bool) {
        this._isNewWhiteboard = bool;
    }
    /**
   * Indicates whether or not the current whiteboard being viewed already existed
   * or was newly created. This is currently used to determine which onboarding
   * flow to send a user through.
   */ get isEligibleForGAOnboarding() {
        return this._isEligibleForGAOnboarding;
    }
    set isEligibleForGAOnboarding(bool) {
        this._isEligibleForGAOnboarding = bool;
    }
    constructor(){
        this.startOnboardingCallback = void 0;
        this.onOnboardingChangeCallback = void 0;
        this.onOnboardingEndCallback = void 0;
        this.handleShowTitleSpotlight = void 0;
        this.handleShowHeaderSpotlight = void 0;
        this.handleShowCollaboratorSpotlight = void 0;
        this._previousOnboardingScreen = void 0;
        this._currentOnboardingScreen = void 0;
        this._onboardingSkipped = void 0;
        this._hasStartedWhiteboardOnboardingSpotlight = void 0;
        this._isEligibleForGAOnboarding = void 0;
        this._isNewWhiteboard = void 0;
        this.handleShowTitleSpotlight = ()=>{};
        this.startOnboardingCallback = ()=>{};
        this.onOnboardingChangeCallback = ()=>{};
        this.onOnboardingEndCallback = ()=>{};
        this.handleShowHeaderSpotlight = ()=>{};
        this.handleShowCollaboratorSpotlight = ()=>{};
        this._previousOnboardingScreen = undefined;
        this._currentOnboardingScreen = undefined;
        this._onboardingSkipped = false;
        this._hasStartedWhiteboardOnboardingSpotlight = false;
        this._isEligibleForGAOnboarding = false;
        this._isNewWhiteboard = false;
    }
}
const $d6d1beda986aaf1b$export$66f3fb1d40113cac = new $d6d1beda986aaf1b$export$e08330274746fce9();

});


parcelRegister("3CK9i", function(module, exports) {

$parcel$export(module.exports, "useNavigationService", () => $8e95e5f969e38541$export$f36e2a0739ee7611);

var $gwFzn = parcelRequire("gwFzn");

var $dPJCf = parcelRequire("dPJCf");

var $5XBLX = parcelRequire("5XBLX");
const $8e95e5f969e38541$export$f36e2a0739ee7611 = (spaceKey)=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [navigationService] = (0, $gwFzn.useState)(()=>new (0, $5XBLX.WhiteboardNavigationService)());
    (0, $gwFzn.useMemo)(()=>{
        navigationService.setPushFn(push);
        navigationService.setSpaceKey(spaceKey);
    }, [
        navigationService,
        push,
        spaceKey
    ]);
    return navigationService;
};

});
parcelRegister("5XBLX", function(module, exports) {

$parcel$export(module.exports, "WhiteboardNavigationService", () => $6453008e770872a0$export$8c60206bd7650109);

var $1NBp8 = parcelRequire("1NBp8");
class $6453008e770872a0$export$8c60206bd7650109 {
    goToContent(id, query) {
        this.pushFn((0, $1NBp8.WHITEBOARD_BOARD).toUrl({
            spaceKey: this.spaceKey,
            contentId: id
        }, {
            query: query
        }));
    }
    goToContentCreate() {
        this.pushFn((0, $1NBp8.WHITEBOARD_BOARD).toUrl({
            spaceKey: this.spaceKey,
            contentId: 'new'
        }));
    }
    goToHome() {
        this.pushFn((0, $1NBp8.WHITEBOARD_HOME).toUrl({
            spaceKey: this.spaceKey
        }));
    }
    goToContainer(containerKey) {
        this.pushFn((0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: containerKey
        }));
    }
    setPushFn(pushFn) {
        this.pushFn = pushFn;
    }
    setSpaceKey(spaceKey) {
        this.spaceKey = spaceKey;
    }
    registerLockoutStateHandler(handler) {
        this.lockoutStateHandler = handler;
    }
    setLockoutState(lockoutState) {
        this.lockoutStateHandler(lockoutState);
    }
    constructor(){
        this.lockoutStateHandler = void 0;
        this.pushFn = void 0;
        this.spaceKey = void 0;
        this.lockoutStateHandler = ()=>undefined;
        this.pushFn = ()=>undefined;
        this.spaceKey = '';
    }
}

});


parcelRegister("41HuM", function(module, exports) {

$parcel$export(module.exports, "WhiteboardInternalModalService", () => $12adae0cf05a6758$export$821b08b132c63217);
function $12adae0cf05a6758$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $12adae0cf05a6758$var$id = 0;
function $12adae0cf05a6758$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $12adae0cf05a6758$var$id++ + "_" + e;
}
var $12adae0cf05a6758$var$_modalHandler = /*#__PURE__*/ $12adae0cf05a6758$var$_classPrivateFieldLooseKey("modalHandler");
var $12adae0cf05a6758$var$_closeHandler = /*#__PURE__*/ $12adae0cf05a6758$var$_classPrivateFieldLooseKey("closeHandler");
class $12adae0cf05a6758$export$821b08b132c63217 {
    registerModalHandler(modalHandler) {
        $12adae0cf05a6758$var$_classPrivateFieldLooseBase(this, $12adae0cf05a6758$var$_modalHandler)[$12adae0cf05a6758$var$_modalHandler] = modalHandler;
    }
    registerCloseHandler(closeHandler) {
        $12adae0cf05a6758$var$_classPrivateFieldLooseBase(this, $12adae0cf05a6758$var$_closeHandler)[$12adae0cf05a6758$var$_closeHandler] = closeHandler;
    }
    showModal(config) {
        return $12adae0cf05a6758$var$_classPrivateFieldLooseBase(this, $12adae0cf05a6758$var$_modalHandler)[$12adae0cf05a6758$var$_modalHandler](config);
    }
    closeModal() {
        $12adae0cf05a6758$var$_classPrivateFieldLooseBase(this, $12adae0cf05a6758$var$_closeHandler)[$12adae0cf05a6758$var$_closeHandler]();
    }
    constructor(){
        Object.defineProperty(this, $12adae0cf05a6758$var$_modalHandler, {
            writable: true,
            value: async ()=>{}
        });
        Object.defineProperty(this, $12adae0cf05a6758$var$_closeHandler, {
            writable: true,
            value: ()=>{}
        });
    }
}

});

parcelRegister("gsFkM", function(module, exports) {

$parcel$export(module.exports, "WhiteboardInternalModal", () => $461e72e301b64edc$export$c1f6ed46bd481538);

var $gwFzn = parcelRequire("gwFzn");

var $1k2FV = parcelRequire("1k2FV");

var $dUFdO = parcelRequire("dUFdO");

var $4NM2Z = parcelRequire("4NM2Z");
const $461e72e301b64edc$export$c1f6ed46bd481538 = ({ whiteboardInternalModalService: whiteboardInternalModalService })=>{
    const { modalState: modalState, closeModal: closeModal } = (0, $1k2FV.useWhiteboardInternalModal)(whiteboardInternalModalService);
    if (modalState.isModalOpen) {
        const modalType = modalState.config.type;
        if (modalType === 'dialogList') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NM2Z.WhiteboardInternalOnboardingSlidesModal), {
            ...modalState.config,
            closeModal: closeModal
        });
        else if (modalType === 'dialog') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dUFdO.WhiteboardInternalDialog), {
            modalProps: modalState.config,
            closeModal: closeModal
        });
    }
    return null;
};

});
parcelRegister("1k2FV", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardInternalModal", () => $f254d253f1a5a3f2$export$1dbfadfe9c8c54e6);

var $gwFzn = parcelRequire("gwFzn");

var $iXDsc = parcelRequire("iXDsc");
const $f254d253f1a5a3f2$export$1dbfadfe9c8c54e6 = (whiteboardInternalModalService)=>{
    const [modalState, setModalState] = (0, $gwFzn.useState)({
        isModalOpen: false
    });
    const closeModal = (0, $gwFzn.useCallback)(()=>{
        setModalState((prevModalState)=>{
            if (prevModalState.isModalOpen) prevModalState.modalCloseDeferrable.resolve();
            return {
                isModalOpen: false
            };
        });
    }, []);
    const ModalHandler = (0, $gwFzn.useCallback)((config)=>{
        const deferrable = new (0, $iXDsc.Deferrable)();
        setModalState((prevModalState)=>{
            if (prevModalState.isModalOpen) prevModalState.modalCloseDeferrable.resolve();
            if (config.type === undefined) throw new Error('invalid config passed');
            return {
                isModalOpen: true,
                config: config,
                modalCloseDeferrable: deferrable
            };
        });
        return deferrable.get();
    }, []);
    whiteboardInternalModalService.registerModalHandler(ModalHandler);
    whiteboardInternalModalService.registerCloseHandler(closeModal);
    return {
        modalState: modalState,
        closeModal: closeModal
    };
};

});

parcelRegister("dUFdO", function(module, exports) {

$parcel$export(module.exports, "WhiteboardInternalDialog", () => $a7896bd8170c7a1a$export$32810c90064e6cec);

var $gwFzn = parcelRequire("gwFzn");

var $ccHMk = parcelRequire("ccHMk");

var $gj7hi = parcelRequire("gj7hi");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $gdv5Z = parcelRequire("gdv5Z");
const $a7896bd8170c7a1a$export$32810c90064e6cec = ({ modalProps: modalProps, closeModal: closeModal })=>{
    const { props: dialogProps, modalHeader: { title: { content: titleContent, props: titleProps }, props: headerProps }, modalBody: { content: bodyContent, props: bodyProps }, modalFooter: { buttons: buttons, props: footerProps }, image: svgImage } = modalProps;
    const onClose = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        dialogProps?.onClose?.(e, analyticsEvent);
        closeModal();
    }, [
        closeModal,
        dialogProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        ...dialogProps,
        onClose: onClose
    }, svgImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        src: svgImage,
        alt: "Dialog image"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        ...headerProps,
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), titleProps, titleContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1DHa6.default), bodyProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        as: "p",
        dangerouslySetInnerHTML: {
            __html: bodyContent
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8o1lj.default), footerProps, buttons.map((b, i)=>{
        const { shouldCloseModal: shouldCloseModal, props: props } = b;
        const onClick = (e, analyticsEvent)=>{
            props?.onClick?.(e, analyticsEvent);
            if (shouldCloseModal) onClose(e, analyticsEvent);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
            ...b.props,
            key: `whiteboard-modal-button-${i}`,
            onClick: onClick
        }, b.label);
    })));
};

});

parcelRegister("4NM2Z", function(module, exports) {

$parcel$export(module.exports, "WhiteboardInternalOnboardingSlidesModal", () => $f67bb3578ed0e6e6$export$743e9ca71753d671);
/* WhiteboardInternalOnboardingSlidesModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6R5uz = parcelRequire("6R5uz");

var $laHi9 = parcelRequire("laHi9");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");

var $7hXDW = parcelRequire("7hXDW");

var $lnqHu = parcelRequire("lnqHu");

var $gj7hi = parcelRequire("gj7hi");

var $ekolh = parcelRequire("ekolh");
var $6xdDU = parcelRequire("6xdDU");

var $6f0Oj = parcelRequire("6f0Oj");
var $cwkWT = parcelRequire("cwkWT");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $jZuqn = parcelRequire("jZuqn");
const $f67bb3578ed0e6e6$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    closeButtonLabel: {
        id: "whiteboard-common.onboarding-modal.closeButtonLabel",
        defaultMessage: "Close modal"
    },
    prevButtonLabel: {
        id: "whiteboard-common.onboarding-modal.prevButtonLabel",
        defaultMessage: "Previous page"
    },
    nextButtonLabel: {
        id: "whiteboard-common.onboarding-modal.nextButtonLabel",
        defaultMessage: "Next page"
    }
});
const $f67bb3578ed0e6e6$var$gridStyles = (0, $ecnYn.xcss)({
    gridTemplateColumns: '1fr'
});
const $f67bb3578ed0e6e6$var$closeContainerStyles = (0, $ecnYn.xcss)({
    gridRowStart: '1',
    gridColumnStart: '1',
    padding: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f67bb3578ed0e6e6$var$OverlayedButton = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1ssb _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1bah1h6o _4cvr1h6o _bfhk10xm _80omtlke _tzy4q80t _1bsbd4y9 _4t3id4y9 _lcxv1wug _uiztglyw _16l415bv",
            __cmplp.className
        ])
    });
});
const $f67bb3578ed0e6e6$var$chevronContainerStyles = (0, $ecnYn.xcss)({
    gridRowStart: '1',
    gridColumnStart: '1',
    padding: 'space.200',
    alignItems: 'center'
});
const $f67bb3578ed0e6e6$var$imageContainerStyles = (0, $ecnYn.xcss)({
    gridRowStart: '1',
    gridColumnStart: '1'
});
const $f67bb3578ed0e6e6$var$contentContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
});
const $f67bb3578ed0e6e6$var$bodyContainerStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.400',
    paddingBlockEnd: 'space.200',
    paddingInline: 'space.300',
    alignItems: 'center'
});
const $f67bb3578ed0e6e6$var$bodyTextContainerStyles = (0, $ecnYn.xcss)({
    width: '88%',
    paddingBlockStart: 'space.100',
    textAlign: 'center'
});
const $f67bb3578ed0e6e6$var$footerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBlockStart: 'space.100',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    paddingBottom: 'space.300'
});
const $f67bb3578ed0e6e6$var$footerElementContainerStyles = (0, $ecnYn.xcss)({
    flexGrow: 1,
    flexBasis: 0
});
const $f67bb3578ed0e6e6$var$rightFooterElementContainerStyles = (0, $ecnYn.xcss)({
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    justifyContent: 'flex-end'
});
const $f67bb3578ed0e6e6$export$743e9ca71753d671 = ({ dialogList: dialogList, closeModal: closeModal, bodyTextHeight: bodyTextHeight, props: dialogProps })=>{
    const [selectedIndex, setSelectedIndex] = (0, $gwFzn.useState)(0);
    const svgCache = (0, $gwFzn.useRef)({});
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { titleContent: titleContent, titleProps: titleProps, bodyContent: bodyContent, bodyProps: bodyProps, skipButton: skipButton, nextOrDoneButton: nextOrDoneButton, svgImage: svgImage } = (0, $gwFzn.useMemo)(()=>{
        const { modalHeader: { title: { content: titleContent, props: titleProps } }, modalBody: { content: bodyContent, props: bodyProps }, modalFooter: { buttons: [skipButton, nextOrDoneButton] }, image: svgImage } = dialogList[selectedIndex]; // Cache the SVG if not already cached
        if (svgImage && !svgCache.current[svgImage]) svgCache.current[svgImage] = svgImage;
        return {
            titleContent: titleContent,
            titleProps: titleProps,
            bodyContent: bodyContent,
            bodyProps: bodyProps,
            skipButton: skipButton,
            nextOrDoneButton: nextOrDoneButton,
            svgImage: svgImage ? svgCache.current[svgImage] : ''
        };
    }, [
        dialogList,
        selectedIndex
    ]);
    const onModalClose = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        dialogProps?.onClose?.(e, analyticsEvent);
        closeModal();
    }, [
        closeModal,
        dialogProps
    ]);
    const handlePrev = (0, $gwFzn.useCallback)(()=>{
        setSelectedIndex((prevState)=>prevState - 1);
    }, []);
    const handleNext = (0, $gwFzn.useCallback)(()=>{
        setSelectedIndex((prevState)=>prevState + 1);
    }, []);
    const handleNextOrDoneButtonClick = (0, $gwFzn.useCallback)((e, analyticsEvent)=>{
        if (selectedIndex === dialogList.length - 1) {
            nextOrDoneButton.props?.onClick?.(e, analyticsEvent);
            onModalClose(e, analyticsEvent);
            return;
        }
        handleNext();
    }, [
        handleNext,
        onModalClose,
        selectedIndex,
        dialogList,
        nextOrDoneButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        ...dialogProps,
        onClose: onModalClose,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cwkWT.default), {
        gap: "space.0",
        xcss: $f67bb3578ed0e6e6$var$gridStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cwkWT.default), {
        xcss: $f67bb3578ed0e6e6$var$closeContainerStyles,
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        testId: `${dialogProps?.testId}-close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        label: formatMessage($f67bb3578ed0e6e6$export$a7357cdd1f0b0168.closeButtonLabel),
        onClick: onModalClose
    })), selectedIndex !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cwkWT.default), {
        xcss: $f67bb3578ed0e6e6$var$chevronContainerStyles,
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f67bb3578ed0e6e6$var$OverlayedButton, {
        "data-testid": `${dialogProps?.testId}-left-chevron-button`,
        onClick: handlePrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: formatMessage($f67bb3578ed0e6e6$export$a7357cdd1f0b0168.prevButtonLabel),
        size: "small"
    }))), selectedIndex !== dialogList.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cwkWT.default), {
        xcss: $f67bb3578ed0e6e6$var$chevronContainerStyles,
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f67bb3578ed0e6e6$var$OverlayedButton, {
        "data-testid": `${dialogProps?.testId}-right-chevron-button`,
        onClick: handleNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: formatMessage($f67bb3578ed0e6e6$export$a7357cdd1f0b0168.nextButtonLabel),
        size: "small"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cwkWT.default), {
        xcss: $f67bb3578ed0e6e6$var$imageContainerStyles,
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        testId: `${dialogProps?.testId}-image`,
        src: svgImage,
        alt: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $f67bb3578ed0e6e6$var$contentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $f67bb3578ed0e6e6$var$bodyContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        ...titleProps,
        as: "h1",
        size: "medium"
    }, titleContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        ...bodyProps,
        xcss: $f67bb3578ed0e6e6$var$bodyTextContainerStyles,
        style: {
            minHeight: bodyTextHeight ?? '88px'
        },
        as: "p",
        dangerouslySetInnerHTML: {
            __html: bodyContent
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $f67bb3578ed0e6e6$var$footerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $f67bb3578ed0e6e6$var$footerElementContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        ...skipButton.props,
        onClick: onModalClose,
        appearance: "subtle"
    }, skipButton.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $f67bb3578ed0e6e6$var$footerElementContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jZuqn.default), {
        testId: `${dialogProps?.testId}-progress-indicator`,
        size: "default",
        appearance: "help",
        selectedIndex: selectedIndex,
        values: dialogList
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $f67bb3578ed0e6e6$var$rightFooterElementContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        ...nextOrDoneButton.props,
        onClick: handleNextOrDoneButtonClick,
        appearance: "discovery"
    }, nextOrDoneButton.label)))))));
};

});


parcelRegister("5ojcA", function(module, exports) {

$parcel$export(module.exports, "WhiteboardNavigationLockout", () => $53752dda094d1029$export$764f69ffe21b3228);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2ZJmt = parcelRequire("2ZJmt");

var $yAQR5 = parcelRequire("yAQR5");
const $53752dda094d1029$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    defaultLockoutMessage: {
        id: "whiteboard-common.navigation-lockout.default-lockout-message",
        defaultMessage: "An action hasn\u2019t been completed on your whiteboard, leaving this tab will stop the action"
    }
});
const $53752dda094d1029$export$764f69ffe21b3228 = ({ navigationService: navigationService, contentId: contentId })=>{
    const intl = (0, $dBxQj.default)();
    const lockoutState = (0, $yAQR5.useWhiteboardNavigationLockout)(navigationService);
    const isSameRoute = (0, $gwFzn.useCallback)((currentRoute, nextRoute)=>{
        const contentIdMatch = 'contentId' in nextRoute.params && nextRoute.params['contentId'] === contentId;
        const routeNameMatch = currentRoute.name === nextRoute.name;
        return contentIdMatch && routeNameMatch;
    }, [
        contentId
    ]);
    return lockoutState.isLockoutSet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2ZJmt.NavigationLockout), {
        message: lockoutState.message ? lockoutState.message : intl.formatMessage($53752dda094d1029$export$a7357cdd1f0b0168.defaultLockoutMessage),
        isSafeTransition: isSameRoute
    }) : null;
};

});
parcelRegister("yAQR5", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardNavigationLockout", () => $445ad71adc526278$export$61773cacadd721c);

var $gwFzn = parcelRequire("gwFzn");
const $445ad71adc526278$export$61773cacadd721c = (navigationService)=>{
    const [lockoutState, setLockoutState] = (0, $gwFzn.useState)({
        isLockoutSet: false
    });
    const lockoutStateHandler = (0, $gwFzn.useCallback)((newLockoutState)=>{
        setLockoutState(newLockoutState);
    }, []);
    navigationService.registerLockoutStateHandler(lockoutStateHandler);
    return lockoutState;
};

});


parcelRegister("5x0FP", function(module, exports) {

$parcel$export(module.exports, "useIntegrationService", () => $88b9ada007561e73$export$50e055b70e95ce8c);

var $cG6Ub = parcelRequire("cG6Ub");
const $88b9ada007561e73$var$integrationsMap = {};
const $88b9ada007561e73$export$50e055b70e95ce8c = (flags, contentId, contentStatus)=>{
    const loomService = (0, $cG6Ub.useLoomService)(flags, contentId, contentStatus);
    $88b9ada007561e73$var$integrationsMap['loom'] = {
        integration: loomService.triggerIntegration,
        isAvailable: loomService.isAvailable
    };
    const triggerIntegration = ({ id: id, onSuccess: onSuccess, onFailure: onFailure, otherProps: otherProps })=>$88b9ada007561e73$var$integrationsMap[id] ? $88b9ada007561e73$var$integrationsMap[id].integration({
            onSuccess: onSuccess,
            onFailure: onFailure,
            otherProps: otherProps
        }) : Promise.reject('No integration found');
    const checkIntegration = ({ id: id })=>$88b9ada007561e73$var$integrationsMap[id]?.isAvailable() || false;
    return {
        triggerIntegration: triggerIntegration,
        checkIntegration: checkIntegration
    };
};

});
parcelRegister("cG6Ub", function(module, exports) {

$parcel$export(module.exports, "useLoomService", () => $2a2b22267c6ee58a$export$ef32e55bd84ac7c9);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $jojoK = parcelRequire("jojoK");

var $f5Ulo = parcelRequire("f5Ulo");
var $4R3wx = parcelRequire("4R3wx");
var $9uAPw = parcelRequire("9uAPw");

var $7QM6o = parcelRequire("7QM6o");
const $2a2b22267c6ee58a$export$ef32e55bd84ac7c9 = (flags, contentId, contentStatus)=>{
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const isEntryPointEnabled = [
        'BETA',
        'CO_USE',
        'CROSS_JOIN'
    ].includes(entryPointVariant);
    const crossJoinUrl = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const { openLoomRecorder: localOpenLoom } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        flags: flags,
        entryPointLocation: 'whiteboards',
        resetInsertFunctionOnUnmount: true
    });
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isAvailable = ()=>isEntryPointEnabled && !!localOpenLoom && contentStatus === 'current';
    const openLoomRecorder = (0, $gwFzn.useCallback)(({ insertButtonText: insertButtonText, onSuccess: onSuccess })=>{
        const onLoomInsert = (videoUrl)=>{
            onSuccess(videoUrl);
            (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'insertVideo',
                        actionSubject: 'loom',
                        source: 'whiteboardSideBar',
                        containerType: 'space',
                        containerId: spaceId,
                        objectType: 'whiteboard',
                        objectId: contentId,
                        attributes: {
                            video_id: hashedVideoId
                        }
                    }
                }).fire();
            });
        };
        return localOpenLoom({
            insertButtonText: insertButtonText,
            onInsert: onLoomInsert
        });
    }, [
        contentId,
        createAnalyticsEvent,
        localOpenLoom,
        spaceId
    ]);
    const triggerIntegration = (0, $gwFzn.useCallback)(async ({ onSuccess: onSuccess, otherProps: otherProps })=>{
        if (entryPointVariant === 'CROSS_JOIN') {
            window.open(crossJoinUrl, '_blank');
            // `onSuccess` intentionally not called as it's used in Whiteboards app to insert a Loom
            // video after successful recording and not meant to handle any cross-join logic
            return;
        }
        if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') return openLoomRecorder({
            onSuccess: onSuccess,
            insertButtonText: otherProps.insertButtonText
        });
    }, [
        crossJoinUrl,
        entryPointVariant,
        openLoomRecorder
    ]);
    return {
        triggerIntegration: triggerIntegration,
        isAvailable: isAvailable
    };
};

});


parcelRegister("vMrtF", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardsVersionHistory", () => $167789284ed97567$export$4f72e8a302311e18);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $ck0S9 = parcelRequire("ck0S9");
const $167789284ed97567$export$4f72e8a302311e18 = ()=>{
    const { formatDate: formatDate, formatTime: formatTime } = (0, $dBxQj.default)();
    const [whiteboardVersionId, setWhiteboardVersionId] = (0, $gwFzn.useState)(null);
    const versionName = (0, $gwFzn.useRef)(null);
    const getVersionName = ()=>versionName.current;
    const setWhiteboardVersion = (0, $gwFzn.useCallback)((version)=>{
        setWhiteboardVersionId(version?.contentProperties?.latest?.externalVersionId || null);
        versionName.current = version ? (0, $ck0S9.getFormattedDate)(version.updatedTime, formatDate, formatTime) : null;
    }, [
        formatDate,
        formatTime
    ]);
    return {
        versionId: whiteboardVersionId,
        getVersionName: getVersionName,
        setWhiteboardVersion: setWhiteboardVersion
    };
};

});

parcelRegister("7vhVT", function(module, exports) {

$parcel$export(module.exports, "PaywallStatus", () => $b0c2e25abce2e6df$export$d9669dcdbd1161d9);
/**
 * @generated SignedSource<<b04201fd2f9a57fd1475d92ec1e48c48>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $b0c2e25abce2e6df$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});

});

parcelRegister("jUWrE", function(module, exports) {

$parcel$export(module.exports, "useWhiteboardAIAgentService", () => $0886db2f41305e80$export$9516687be7b3d3d0);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $cUQMr = parcelRequire("cUQMr");

var $33kXB = parcelRequire("33kXB");

var $4Hqhn = parcelRequire("4Hqhn");

var $5aqrM = parcelRequire("5aqrM");
var $8ETUZ = parcelRequire("8ETUZ");

var $q7r2L = parcelRequire("q7r2L");
var $9j9JP = parcelRequire("9j9JP");

var $8xyMM = parcelRequire("8xyMM");

var $aWwYt = parcelRequire("aWwYt");

var $ly2zj = parcelRequire("ly2zj");

var $bQm3c = parcelRequire("bQm3c");

var $itz1F = parcelRequire("itz1F");
const $0886db2f41305e80$var$i18n = (0, $2nPZH.defineMessages)({
    panelHeaderLabel: {
        id: "whiteboard-common.use-whiteboard-ai-agent-service.ai-panel-header-name",
        defaultMessage: "Whiteboard AI Panel"
    },
    summarizeWhiteboardButtonTitle: {
        id: "whiteboard-common.use-whiteboard-ai-agent-service.ai-panel.summarize-button",
        defaultMessage: "Summarize whiteboard"
    },
    generateDiagramButtonTitle: {
        id: "whiteboard-common.use-whiteboard-ai-agent-service.ai-panel.generate-diagram-button",
        defaultMessage: "Generate diagram"
    },
    generateCardButtonTitle: {
        id: "whiteboard-common.use-whiteboard-ai-agent-service.ai-panel.generate-card-button",
        defaultMessage: "Generate Card"
    }
});
function $0886db2f41305e80$export$7828cb6bb8487fb4() {
    const objectSidebar = (0, $8xyMM.useCreateObjectSidebarProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $q7r2L.AIDynamicSurface), {
        objectSidebar: objectSidebar
    });
}
const $0886db2f41305e80$export$6393a1b7f2a8d76e = {
    id: (0, $9j9JP.DYNAMIC_SURFACE_PANEL_ID),
    headerComponentElements: {
        HeaderIcon: (0, $9j9JP.RovoLogo)
    },
    BodyComponent: $0886db2f41305e80$export$7828cb6bb8487fb4
};
const $0886db2f41305e80$var$WHITEBOARD_DYNAMIC_SURFACE_SOURCE_ID = 'whiteboard';
const $0886db2f41305e80$export$9516687be7b3d3d0 = ({ contentId: contentId, spaceKey: spaceKey, contentTitle: contentTitle })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const [availableWhiteboardSmartActions, setAvailableWhiteboardSmartActions] = (0, $gwFzn.useState)([]);
    const [isAgentEnabled, setIsAgentEnabled] = (0, $gwFzn.useState)(false);
    const { setActions: setActions } = (0, $5aqrM.useSourceAIActions)($0886db2f41305e80$var$WHITEBOARD_DYNAMIC_SURFACE_SOURCE_ID);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { setSurfaceMetadata: setSurfaceMetadata } = (0, $8ETUZ.useSurfaceAIActions)();
    const summarizeButtonText = formatMessage($0886db2f41305e80$var$i18n.summarizeWhiteboardButtonTitle);
    const generateDiagramButtonText = formatMessage($0886db2f41305e80$var$i18n.generateDiagramButtonTitle);
    const generateCardButtonText = formatMessage($0886db2f41305e80$var$i18n.generateCardButtonTitle);
    (0, $gwFzn.useEffect)(()=>{
        setSurfaceMetadata({
            siteId: cloudId,
            product: 'confluence',
            contentType: 'whiteboard'
        });
    }, [
        cloudId,
        setSurfaceMetadata
    ]);
    // Handler for calling whiteboards to toggle the ai agent dialog
    const openAIAgentDialog = (0, $gwFzn.useCallback)((selectedAction)=>{
        (0, $itz1F.whiteboardAIAgentService).toggleAIAgentDialog({
            selectedAction: selectedAction
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        hideObjectSidebar();
    }, [
        hideObjectSidebar
    ]);
    const confluenceSideWhiteboardSmartActions = (0, $gwFzn.useMemo)(()=>({
            summary: {
                id: 'summarize-whiteboard-ai-action',
                title: summarizeButtonText,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                    label: ""
                }),
                viewConfig: {
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.CreatePageButtonContextProvider), {
                            contentId: contentId,
                            spaceKey: spaceKey,
                            contentTitle: contentTitle
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.QuickSummaryStreamingComponent), {
                            contentId: contentId,
                            spaceKey: spaceKey,
                            contentType: "whiteboard",
                            lastModifiedDate: "",
                            source: "whiteboard",
                            setIsOpen: ()=>{},
                            contentPath: window.location.pathname,
                            isInObjectSidebar: true
                        }))
                }
            }
        }), [
        summarizeButtonText,
        contentId,
        spaceKey,
        contentTitle
    ]);
    const whiteboardSideWhiteboardSmartActions = (0, $gwFzn.useMemo)(()=>({
            diagram: {
                id: 'generate-diagram-whiteboard-ai-action',
                title: generateDiagramButtonText,
                onClick: ()=>openAIAgentDialog('diagram'),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33kXB))), {
                    label: ""
                })
            },
            card: {
                id: 'generate-card-whiteboard-ai-action',
                title: generateCardButtonText,
                onClick: ()=>openAIAgentDialog('card'),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Hqhn))), {
                    label: ""
                })
            }
        }), [
        generateCardButtonText,
        generateDiagramButtonText,
        openAIAgentDialog
    ]);
    // Clean up
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            (0, $itz1F.whiteboardAIAgentService).dispose();
        };
    // clean-up on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Register for smart action updates
    (0, $gwFzn.useEffect)(()=>{
        (0, $itz1F.whiteboardAIAgentService).registerOnSmartActionsUpdate(setAvailableWhiteboardSmartActions);
    }, [
        setAvailableWhiteboardSmartActions
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const filteredActions = isAgentEnabled ? availableWhiteboardSmartActions.map((action)=>whiteboardSideWhiteboardSmartActions[action]) : [];
        setActions([
            ...Object.values(confluenceSideWhiteboardSmartActions),
            ...Object.values(filteredActions)
        ]);
    }, [
        confluenceSideWhiteboardSmartActions,
        availableWhiteboardSmartActions,
        whiteboardSideWhiteboardSmartActions,
        setActions,
        isAgentEnabled
    ]);
    // Object sidebar handlers
    const toggleWhiteboardAIAgentObjectSidePanel = (0, $gwFzn.useCallback)(()=>{
        if (isObjectSidebarShown && panel?.id === $0886db2f41305e80$export$6393a1b7f2a8d76e.id) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        hideObjectSidebar();
        else showObjectSidebar($0886db2f41305e80$export$6393a1b7f2a8d76e, 'push');
    }, [
        isObjectSidebarShown,
        panel,
        hideObjectSidebar,
        showObjectSidebar
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $itz1F.whiteboardAIAgentService).registerToggleWhiteboardAIAgentRightPanel(toggleWhiteboardAIAgentObjectSidePanel);
    }, [
        toggleWhiteboardAIAgentObjectSidePanel
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $itz1F.whiteboardAIAgentService).updateConfluenceSidebarState({
            isOpen: isObjectSidebarShown,
            panelId: panel?.id || ''
        });
    }, [
        isObjectSidebarShown,
        panel?.id
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $itz1F.whiteboardAIAgentService).onAgentEnablementChange(setIsAgentEnabled);
    }, [
        setIsAgentEnabled
    ]);
    return 0, $itz1F.whiteboardAIAgentService;
};

});
parcelRegister("4Hqhn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cea8cfd29428997d16ab57b549672759>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36bf9011bd11cb83$var$_react = $36bf9011bd11cb83$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $36bf9011bd11cb83$var$_baseNew = $36bf9011bd11cb83$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $36bf9011bd11cb83$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Note".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36bf9011bd11cb83$var$NoteIcon = (props)=>/*#__PURE__*/ $36bf9011bd11cb83$var$_react.default.createElement($36bf9011bd11cb83$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 15H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6V9.75A.75.75 0 0 1 9.75 9h3.75V3a.5.5 0 0 0-.5-.5zm9.94 8H10.5v2.44zM11 6H4V4.5h7zM7 9.5H4V8h3z" clip-rule="evenodd"/>`
    }, props));
$36bf9011bd11cb83$var$NoteIcon.displayName = 'NoteIcon';
var $36bf9011bd11cb83$var$_default = module.exports.default = $36bf9011bd11cb83$var$NoteIcon;

});

parcelRegister("itz1F", function(module, exports) {

$parcel$export(module.exports, "whiteboardAIAgentService", () => $356b157faadb7173$export$656ca705187eb16e);

var $9wGTI = parcelRequire("9wGTI");
const $356b157faadb7173$export$5cf4f092d7061616 = {
    toggleBottom: -1,
    toggleMiddle: -1
};
class $356b157faadb7173$export$bc82268f47354f42 {
    dispose() {
        this.handleToggleWhiteboardAIAgentRightPanel = ()=>{};
        this.handleSmartActionsUpdate = ()=>[];
        this.handleToggleAIAgentDialog = ()=>{};
        this.handleUpdateAIAgentDialogState = ()=>{};
        this.handleConfluenceSidebarStateChange = [];
        this.agentEnablementChangeHandlers = [];
        this.whiteboardContainerRef = null;
        this.aiAgentButtonRef = null;
        this.isAgentEnabled = false;
    }
    /**
   * Returns the current read only state
   */ getIsAgentEnabled() {
        return this.isAgentEnabled;
    }
    /**
   * Local Confluence handler register for listening on permission changes for whiteboard ai agent
   */ onAgentEnablementChange(callback) {
        this.agentEnablementChangeHandlers.push(callback);
    }
    /**
   * Notify permission change handlers of updates
   */ updatePermissions(permissions) {
        this.isAgentEnabled = permissions.includes('write') && (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
        this.agentEnablementChangeHandlers.forEach((handler)=>handler(this.isAgentEnabled));
    }
    /**
   * Registers a callback in whiteboards to be called when the whiteboard ai agent right panel is toggled
   */ registerToggleWhiteboardAIAgentRightPanel(callback) {
        this.handleToggleWhiteboardAIAgentRightPanel = callback;
    }
    /**
   * Allows for a callback to be registered in whiteboards returning the currently available smart ai actions list
   */ registerOnSmartActionsUpdate(callback) {
        this.handleSmartActionsUpdate = callback;
    }
    /**
   * Allows for a callback to be registered in whiteboards to be called when the ai agent dialog is toggled
   */ registerAIAgentToggleHandler(callback) {
        this.handleToggleAIAgentDialog = callback;
    }
    /**
   * Calls registered handler for whiteboard closeWhiteboardAIAgentRightPanel bridge action
   * Registration found in useWhiteboardAIAgentService
   */ toggleWhiteboardAIAgentRightPanel() {
        this.handleToggleWhiteboardAIAgentRightPanel();
    }
    /**
   * Calls callback registered in whiteboards to retrieve currently available smart ai actions
   */ updateSmartActions(availableActions) {
        return this.handleSmartActionsUpdate(availableActions);
    }
    /**
   * Calls handler registered in canvas to open the internal ai agent dialog
   */ toggleAIAgentDialog(properties) {
        this.handleToggleAIAgentDialog(properties);
    }
    /**
   * React ref objects required to calculate the current mount position
   */ setWhiteboardContainerRef(ref) {
        this.whiteboardContainerRef = ref;
    }
    setAIAgentButtonRef(ref) {
        this.aiAgentButtonRef = ref;
    }
    /**
   * Calls handler registered in canvas to return a mount point for the ai agent dialog
   */ getAIAgentDialogMountPoint() {
        if (!this.whiteboardContainerRef?.current || !this.aiAgentButtonRef?.current) return $356b157faadb7173$export$5cf4f092d7061616;
        const containerRect = this.whiteboardContainerRef.current.getBoundingClientRect();
        const buttonRect = this.aiAgentButtonRef.current.getBoundingClientRect();
        // toggleMiddle is calculated as the offset from the right edge of the container as
        // that is where we want the dialog to be anchored
        const toggleMiddle = containerRect.right - (buttonRect.left + buttonRect.width / 2);
        const toggleBottom = buttonRect.bottom - containerRect.top;
        return {
            toggleBottom: toggleBottom,
            toggleMiddle: toggleMiddle
        };
    }
    /**
   * Calls a handler meant to be registered in Confluence to update the ai agent dialog state
   */ onUpdateAIAgentDialogState(callback) {
        this.handleUpdateAIAgentDialogState = callback;
    }
    /**
   * Updates the ai agent dialog state
   */ updateAIAgentDialogState(state) {
        this.handleUpdateAIAgentDialogState(state);
    }
    /**
   * Calls a handler meant to be registered in Confluence to update the ai agent dialog state
   */ onConfluenceSidebarStateChange(callback) {
        this.handleConfluenceSidebarStateChange.push(callback);
    }
    /**
   * Calls a handler meant to be registered in Whiteboards to notify of changes in the Confluence sidebar state
   */ updateConfluenceSidebarState(state) {
        this.handleConfluenceSidebarStateChange.forEach((callback)=>callback(state));
    }
    constructor(){
        this.handleToggleWhiteboardAIAgentRightPanel = void 0;
        this.handleSmartActionsUpdate = void 0;
        this.handleToggleAIAgentDialog = void 0;
        this.handleUpdateAIAgentDialogState = void 0;
        this.handleConfluenceSidebarStateChange = void 0;
        this.agentEnablementChangeHandlers = void 0;
        this.whiteboardContainerRef = void 0;
        this.aiAgentButtonRef = void 0;
        this.isAgentEnabled = void 0;
        this.handleToggleWhiteboardAIAgentRightPanel = ()=>{};
        this.handleSmartActionsUpdate = ()=>[];
        this.handleToggleAIAgentDialog = ()=>{};
        this.handleUpdateAIAgentDialogState = ()=>{};
        this.handleConfluenceSidebarStateChange = [];
        this.agentEnablementChangeHandlers = [];
        this.whiteboardContainerRef = null;
        this.aiAgentButtonRef = null;
        this.isAgentEnabled = false;
    }
}
const $356b157faadb7173$export$656ca705187eb16e = new $356b157faadb7173$export$bc82268f47354f42();

});




//# sourceMappingURL=ObjectSidebarControl.235da716.js.map
